export const words = [
    {
      "headword": "a"
    },
    {
      "headword": "a.m./A.M./am/AM"
    },
    {
      "headword": "abandon"
    },
    {
      "headword": "abandoned"
    },
    {
      "headword": "ability"
    },
    {
      "headword": "able"
    },
    {
      "headword": "abnormal"
    },
    {
      "headword": "abnormally"
    },
    {
      "headword": "aboard"
    },
    {
      "headword": "abolish"
    },
    {
      "headword": "aboriginal"
    },
    {
      "headword": "about"
    },
    {
      "headword": "about"
    },
    {
      "headword": "above"
    },
    {
      "headword": "above"
    },
    {
      "headword": "above"
    },
    {
      "headword": "abroad"
    },
    {
      "headword": "abruptly"
    },
    {
      "headword": "absence"
    },
    {
      "headword": "absent"
    },
    {
      "headword": "absentee"
    },
    {
      "headword": "absolute"
    },
    {
      "headword": "absolutely"
    },
    {
      "headword": "absorb"
    },
    {
      "headword": "abstract"
    },
    {
      "headword": "absurd"
    },
    {
      "headword": "abundance"
    },
    {
      "headword": "abundant"
    },
    {
      "headword": "abuse"
    },
    {
      "headword": "academic"
    },
    {
      "headword": "academy"
    },
    {
      "headword": "accent"
    },
    {
      "headword": "accept"
    },
    {
      "headword": "acceptable"
    },
    {
      "headword": "acceptance"
    },
    {
      "headword": "access"
    },
    {
      "headword": "access"
    },
    {
      "headword": "accessibility"
    },
    {
      "headword": "accessible"
    },
    {
      "headword": "accessory"
    },
    {
      "headword": "accident"
    },
    {
      "headword": "accidental"
    },
    {
      "headword": "accidentally"
    },
    {
      "headword": "accommodation"
    },
    {
      "headword": "accompany"
    },
    {
      "headword": "accomplish"
    },
    {
      "headword": "according to"
    },
    {
      "headword": "accordingly"
    },
    {
      "headword": "account"
    },
    {
      "headword": "account"
    },
    {
      "headword": "accountant"
    },
    {
      "headword": "accumulate"
    },
    {
      "headword": "accuracy"
    },
    {
      "headword": "accurate"
    },
    {
      "headword": "accurately"
    },
    {
      "headword": "accusation"
    },
    {
      "headword": "accuse"
    },
    {
      "headword": "accustom"
    },
    {
      "headword": "ache"
    },
    {
      "headword": "ache"
    },
    {
      "headword": "achievable"
    },
    {
      "headword": "achieve"
    },
    {
      "headword": "achievement"
    },
    {
      "headword": "acid"
    },
    {
      "headword": "acknowledge"
    },
    {
      "headword": "acknowledgment/acknowledgement"
    },
    {
      "headword": "acquaintance"
    },
    {
      "headword": "acquire"
    },
    {
      "headword": "acquisition"
    },
    {
      "headword": "across"
    },
    {
      "headword": "across"
    },
    {
      "headword": "act"
    },
    {
      "headword": "act"
    },
    {
      "headword": "action"
    },
    {
      "headword": "active"
    },
    {
      "headword": "actively"
    },
    {
      "headword": "activity"
    },
    {
      "headword": "actor"
    },
    {
      "headword": "actress"
    },
    {
      "headword": "actual"
    },
    {
      "headword": "actually"
    },
    {
      "headword": "acute"
    },
    {
      "headword": "ad"
    },
    {
      "headword": "adapt"
    },
    {
      "headword": "adaptable"
    },
    {
      "headword": "add"
    },
    {
      "headword": "addict"
    },
    {
      "headword": "addicted"
    },
    {
      "headword": "addiction"
    },
    {
      "headword": "addition"
    },
    {
      "headword": "additional"
    },
    {
      "headword": "additionally"
    },
    {
      "headword": "address"
    },
    {
      "headword": "address"
    },
    {
      "headword": "addressee"
    },
    {
      "headword": "adequate"
    },
    {
      "headword": "adequately"
    },
    {
      "headword": "adjective"
    },
    {
      "headword": "adjust"
    },
    {
      "headword": "adjustment"
    },
    {
      "headword": "administration"
    },
    {
      "headword": "administrative"
    },
    {
      "headword": "admirable"
    },
    {
      "headword": "admiration"
    },
    {
      "headword": "admire"
    },
    {
      "headword": "admiringly"
    },
    {
      "headword": "admission"
    },
    {
      "headword": "admit"
    },
    {
      "headword": "admittedly"
    },
    {
      "headword": "adopt"
    },
    {
      "headword": "adopted"
    },
    {
      "headword": "adoption"
    },
    {
      "headword": "adorable"
    },
    {
      "headword": "adore"
    },
    {
      "headword": "adorn"
    },
    {
      "headword": "adult"
    },
    {
      "headword": "adult"
    },
    {
      "headword": "advance"
    },
    {
      "headword": "advance"
    },
    {
      "headword": "advanced"
    },
    {
      "headword": "advancement"
    },
    {
      "headword": "advantage"
    },
    {
      "headword": "advent"
    },
    {
      "headword": "adventure"
    },
    {
      "headword": "adventurous"
    },
    {
      "headword": "adverb"
    },
    {
      "headword": "adverbial"
    },
    {
      "headword": "adverse"
    },
    {
      "headword": "adversely"
    },
    {
      "headword": "adversity"
    },
    {
      "headword": "advert"
    },
    {
      "headword": "advertise"
    },
    {
      "headword": "advertisement"
    },
    {
      "headword": "advertising"
    },
    {
      "headword": "advice"
    },
    {
      "headword": "advise"
    },
    {
      "headword": "adviser/advisor"
    },
    {
      "headword": "aerobics"
    },
    {
      "headword": "affair"
    },
    {
      "headword": "affect"
    },
    {
      "headword": "affection"
    },
    {
      "headword": "affectionate"
    },
    {
      "headword": "affectionately"
    },
    {
      "headword": "afford"
    },
    {
      "headword": "affordable"
    },
    {
      "headword": "afraid"
    },
    {
      "headword": "after"
    },
    {
      "headword": "after"
    },
    {
      "headword": "after"
    },
    {
      "headword": "afternoon"
    },
    {
      "headword": "afterward"
    },
    {
      "headword": "afterwards"
    },
    {
      "headword": "again"
    },
    {
      "headword": "against"
    },
    {
      "headword": "age"
    },
    {
      "headword": "aged"
    },
    {
      "headword": "ageless"
    },
    {
      "headword": "agency"
    },
    {
      "headword": "agenda"
    },
    {
      "headword": "agent"
    },
    {
      "headword": "aggressive"
    },
    {
      "headword": "aggressively"
    },
    {
      "headword": "ago"
    },
    {
      "headword": "agonize/agonise"
    },
    {
      "headword": "agony"
    },
    {
      "headword": "agree"
    },
    {
      "headword": "agreement"
    },
    {
      "headword": "agricultural"
    },
    {
      "headword": "agriculture"
    },
    {
      "headword": "ahead"
    },
    {
      "headword": "aid"
    },
    {
      "headword": "aid"
    },
    {
      "headword": "aim"
    },
    {
      "headword": "aim"
    },
    {
      "headword": "air"
    },
    {
      "headword": "air conditioning"
    },
    {
      "headword": "air force"
    },
    {
      "headword": "aircraft"
    },
    {
      "headword": "aircrew"
    },
    {
      "headword": "airline"
    },
    {
      "headword": "airplane/aeroplane"
    },
    {
      "headword": "airport"
    },
    {
      "headword": "aisle"
    },
    {
      "headword": "alarm"
    },
    {
      "headword": "alarm"
    },
    {
      "headword": "alarm clock"
    },
    {
      "headword": "album"
    },
    {
      "headword": "alcohol"
    },
    {
      "headword": "alcoholic"
    },
    {
      "headword": "alcoholic"
    },
    {
      "headword": "alcoholism"
    },
    {
      "headword": "alert"
    },
    {
      "headword": "alike"
    },
    {
      "headword": "alike"
    },
    {
      "headword": "alive"
    },
    {
      "headword": "all"
    },
    {
      "headword": "all"
    },
    {
      "headword": "all"
    },
    {
      "headword": "all right"
    },
    {
      "headword": "all right"
    },
    {
      "headword": "allegation"
    },
    {
      "headword": "allergic"
    },
    {
      "headword": "alliance"
    },
    {
      "headword": "allow"
    },
    {
      "headword": "allowance"
    },
    {
      "headword": "ally"
    },
    {
      "headword": "almost"
    },
    {
      "headword": "alone"
    },
    {
      "headword": "alone"
    },
    {
      "headword": "along"
    },
    {
      "headword": "along"
    },
    {
      "headword": "alongside"
    },
    {
      "headword": "aloud"
    },
    {
      "headword": "alphabet"
    },
    {
      "headword": "alphabetical"
    },
    {
      "headword": "already"
    },
    {
      "headword": "alright"
    },
    {
      "headword": "alright"
    },
    {
      "headword": "also"
    },
    {
      "headword": "altar"
    },
    {
      "headword": "alter"
    },
    {
      "headword": "alternate"
    },
    {
      "headword": "alternative"
    },
    {
      "headword": "alternative"
    },
    {
      "headword": "alternatively"
    },
    {
      "headword": "although"
    },
    {
      "headword": "altitude"
    },
    {
      "headword": "altogether"
    },
    {
      "headword": "aluminum/aluminium"
    },
    {
      "headword": "always"
    },
    {
      "headword": "am"
    },
    {
      "headword": "amaze"
    },
    {
      "headword": "amazed"
    },
    {
      "headword": "amazement"
    },
    {
      "headword": "amazing"
    },
    {
      "headword": "amazingly"
    },
    {
      "headword": "ambassador"
    },
    {
      "headword": "ambiguity"
    },
    {
      "headword": "ambiguous"
    },
    {
      "headword": "ambition"
    },
    {
      "headword": "ambitious"
    },
    {
      "headword": "ambulance"
    },
    {
      "headword": "ammonia"
    },
    {
      "headword": "among"
    },
    {
      "headword": "amongst"
    },
    {
      "headword": "amount"
    },
    {
      "headword": "ample"
    },
    {
      "headword": "amplifier"
    },
    {
      "headword": "amplify"
    },
    {
      "headword": "amuse"
    },
    {
      "headword": "amused"
    },
    {
      "headword": "amusement"
    },
    {
      "headword": "amusing"
    },
    {
      "headword": "an"
    },
    {
      "headword": "analogy"
    },
    {
      "headword": "analysis"
    },
    {
      "headword": "analyst"
    },
    {
      "headword": "analyze/analyse"
    },
    {
      "headword": "ancestor"
    },
    {
      "headword": "anchor"
    },
    {
      "headword": "anchorage"
    },
    {
      "headword": "anchorman"
    },
    {
      "headword": "anchorperson"
    },
    {
      "headword": "ancient"
    },
    {
      "headword": "and"
    },
    {
      "headword": "angel"
    },
    {
      "headword": "anger"
    },
    {
      "headword": "angle"
    },
    {
      "headword": "angrily"
    },
    {
      "headword": "angry"
    },
    {
      "headword": "anguish"
    },
    {
      "headword": "animal"
    },
    {
      "headword": "animate"
    },
    {
      "headword": "animated"
    },
    {
      "headword": "animation"
    },
    {
      "headword": "ankle"
    },
    {
      "headword": "anniversary"
    },
    {
      "headword": "announce"
    },
    {
      "headword": "announcement"
    },
    {
      "headword": "annoy"
    },
    {
      "headword": "annoyance"
    },
    {
      "headword": "annoyed"
    },
    {
      "headword": "annoying"
    },
    {
      "headword": "annual"
    },
    {
      "headword": "annually"
    },
    {
      "headword": "anonymous"
    },
    {
      "headword": "another"
    },
    {
      "headword": "another"
    },
    {
      "headword": "answer"
    },
    {
      "headword": "answer"
    },
    {
      "headword": "ant"
    },
    {
      "headword": "anti"
    },
    {
      "headword": "antiaircraft"
    },
    {
      "headword": "antibacterial"
    },
    {
      "headword": "anticancer"
    },
    {
      "headword": "anticipate"
    },
    {
      "headword": "anticipation"
    },
    {
      "headword": "antipollution"
    },
    {
      "headword": "antique"
    },
    {
      "headword": "antique"
    },
    {
      "headword": "antistatic"
    },
    {
      "headword": "antivirus"
    },
    {
      "headword": "antonym"
    },
    {
      "headword": "anxiety"
    },
    {
      "headword": "anxious"
    },
    {
      "headword": "anxiously"
    },
    {
      "headword": "any"
    },
    {
      "headword": "any"
    },
    {
      "headword": "anybody"
    },
    {
      "headword": "anyhow"
    },
    {
      "headword": "anymore"
    },
    {
      "headword": "anyone"
    },
    {
      "headword": "anything"
    },
    {
      "headword": "anyway"
    },
    {
      "headword": "anywhere"
    },
    {
      "headword": "apart"
    },
    {
      "headword": "apartment"
    },
    {
      "headword": "ape"
    },
    {
      "headword": "apologize/apologise"
    },
    {
      "headword": "apology"
    },
    {
      "headword": "apostrophe"
    },
    {
      "headword": "apparent"
    },
    {
      "headword": "apparently"
    },
    {
      "headword": "appeal"
    },
    {
      "headword": "appeal"
    },
    {
      "headword": "appear"
    },
    {
      "headword": "appearance"
    },
    {
      "headword": "appetite"
    },
    {
      "headword": "applaud"
    },
    {
      "headword": "applause"
    },
    {
      "headword": "apple"
    },
    {
      "headword": "applicant"
    },
    {
      "headword": "application"
    },
    {
      "headword": "apply"
    },
    {
      "headword": "appoint"
    },
    {
      "headword": "appointment"
    },
    {
      "headword": "appreciate"
    },
    {
      "headword": "appreciation"
    },
    {
      "headword": "appreciative"
    },
    {
      "headword": "approach"
    },
    {
      "headword": "approach"
    },
    {
      "headword": "appropriate"
    },
    {
      "headword": "appropriately"
    },
    {
      "headword": "approval"
    },
    {
      "headword": "approve"
    },
    {
      "headword": "approximate"
    },
    {
      "headword": "approximately"
    },
    {
      "headword": "April"
    },
    {
      "headword": "apron"
    },
    {
      "headword": "arch"
    },
    {
      "headword": "archaeologist/archeologist"
    },
    {
      "headword": "architect"
    },
    {
      "headword": "architecture"
    },
    {
      "headword": "arctic"
    },
    {
      "headword": "are"
    },
    {
      "headword": "area"
    },
    {
      "headword": "arena"
    },
    {
      "headword": "argue"
    },
    {
      "headword": "argument"
    },
    {
      "headword": "arise"
    },
    {
      "headword": "aristocracy"
    },
    {
      "headword": "arithmetic"
    },
    {
      "headword": "arm"
    },
    {
      "headword": "arm"
    },
    {
      "headword": "armchair"
    },
    {
      "headword": "armed"
    },
    {
      "headword": "armful"
    },
    {
      "headword": "army"
    },
    {
      "headword": "around"
    },
    {
      "headword": "around"
    },
    {
      "headword": "arouse"
    },
    {
      "headword": "arrange"
    },
    {
      "headword": "arrangement"
    },
    {
      "headword": "arrest"
    },
    {
      "headword": "arrest"
    },
    {
      "headword": "arrival"
    },
    {
      "headword": "arrive"
    },
    {
      "headword": "arrogant"
    },
    {
      "headword": "arrow"
    },
    {
      "headword": "art"
    },
    {
      "headword": "artery"
    },
    {
      "headword": "article"
    },
    {
      "headword": "articulate"
    },
    {
      "headword": "artificial"
    },
    {
      "headword": "artificially"
    },
    {
      "headword": "artist"
    },
    {
      "headword": "artistic"
    },
    {
      "headword": "artistry"
    },
    {
      "headword": "as"
    },
    {
      "headword": "as"
    },
    {
      "headword": "ash"
    },
    {
      "headword": "ashamed"
    },
    {
      "headword": "aside"
    },
    {
      "headword": "ask"
    },
    {
      "headword": "asleep"
    },
    {
      "headword": "aspect"
    },
    {
      "headword": "aspiration"
    },
    {
      "headword": "aspire"
    },
    {
      "headword": "aspirin"
    },
    {
      "headword": "assault"
    },
    {
      "headword": "assemble"
    },
    {
      "headword": "assembly"
    },
    {
      "headword": "assert"
    },
    {
      "headword": "assess"
    },
    {
      "headword": "assessment"
    },
    {
      "headword": "assign"
    },
    {
      "headword": "assignment"
    },
    {
      "headword": "assist"
    },
    {
      "headword": "assistance"
    },
    {
      "headword": "assistant"
    },
    {
      "headword": "assistant"
    },
    {
      "headword": "associate"
    },
    {
      "headword": "association"
    },
    {
      "headword": "assume"
    },
    {
      "headword": "assumption"
    },
    {
      "headword": "assurance"
    },
    {
      "headword": "assure"
    },
    {
      "headword": "astonish"
    },
    {
      "headword": "astonished"
    },
    {
      "headword": "astonishing"
    },
    {
      "headword": "astonishment"
    },
    {
      "headword": "astronaut"
    },
    {
      "headword": "astronomer"
    },
    {
      "headword": "astronomy"
    },
    {
      "headword": "at"
    },
    {
      "headword": "athlete"
    },
    {
      "headword": "athletic"
    },
    {
      "headword": "athletics"
    },
    {
      "headword": "Atlantic"
    },
    {
      "headword": "atmosphere"
    },
    {
      "headword": "atom"
    },
    {
      "headword": "atomic"
    },
    {
      "headword": "attach"
    },
    {
      "headword": "attached"
    },
    {
      "headword": "attachment"
    },
    {
      "headword": "attack"
    },
    {
      "headword": "attack"
    },
    {
      "headword": "attain"
    },
    {
      "headword": "attainable"
    },
    {
      "headword": "attainment"
    },
    {
      "headword": "attempt"
    },
    {
      "headword": "attempt"
    },
    {
      "headword": "attend"
    },
    {
      "headword": "attendance"
    },
    {
      "headword": "attention"
    },
    {
      "headword": "attentive"
    },
    {
      "headword": "attentively"
    },
    {
      "headword": "attitude"
    },
    {
      "headword": "attract"
    },
    {
      "headword": "attraction"
    },
    {
      "headword": "attractive"
    },
    {
      "headword": "attractiveness"
    },
    {
      "headword": "attribute"
    },
    {
      "headword": "attribute"
    },
    {
      "headword": "atypical"
    },
    {
      "headword": "aubergine"
    },
    {
      "headword": "audience"
    },
    {
      "headword": "audio"
    },
    {
      "headword": "audit"
    },
    {
      "headword": "audition"
    },
    {
      "headword": "August"
    },
    {
      "headword": "aunt"
    },
    {
      "headword": "author"
    },
    {
      "headword": "authoritative"
    },
    {
      "headword": "authority"
    },
    {
      "headword": "authorize/authorise"
    },
    {
      "headword": "automatic"
    },
    {
      "headword": "automatically"
    },
    {
      "headword": "autumn"
    },
    {
      "headword": "auxiliary"
    },
    {
      "headword": "availability"
    },
    {
      "headword": "available"
    },
    {
      "headword": "avenue"
    },
    {
      "headword": "average"
    },
    {
      "headword": "average"
    },
    {
      "headword": "avoid"
    },
    {
      "headword": "await"
    },
    {
      "headword": "awake"
    },
    {
      "headword": "award"
    },
    {
      "headword": "award"
    },
    {
      "headword": "aware"
    },
    {
      "headword": "awareness"
    },
    {
      "headword": "away"
    },
    {
      "headword": "awe"
    },
    {
      "headword": "awesome"
    },
    {
      "headword": "awful"
    },
    {
      "headword": "awkward"
    },
    {
      "headword": "ax/axe"
    },
    {
      "headword": "axis"
    },
    {
      "headword": "baby"
    },
    {
      "headword": "babysit"
    },
    {
      "headword": "babysitter"
    },
    {
      "headword": "back"
    },
    {
      "headword": "back"
    },
    {
      "headword": "back"
    },
    {
      "headword": "back"
    },
    {
      "headword": "backache"
    },
    {
      "headword": "background"
    },
    {
      "headword": "backpack"
    },
    {
      "headword": "backpacker"
    },
    {
      "headword": "backpacking"
    },
    {
      "headword": "backup"
    },
    {
      "headword": "backward/backwards"
    },
    {
      "headword": "backyard"
    },
    {
      "headword": "bacon"
    },
    {
      "headword": "bad"
    },
    {
      "headword": "badge"
    },
    {
      "headword": "badly"
    },
    {
      "headword": "badminton"
    },
    {
      "headword": "bad-tempered"
    },
    {
      "headword": "bag"
    },
    {
      "headword": "baggage"
    },
    {
      "headword": "bake"
    },
    {
      "headword": "baker"
    },
    {
      "headword": "bakery"
    },
    {
      "headword": "balance"
    },
    {
      "headword": "balance"
    },
    {
      "headword": "balanced"
    },
    {
      "headword": "balcony"
    },
    {
      "headword": "bald"
    },
    {
      "headword": "balky"
    },
    {
      "headword": "ball"
    },
    {
      "headword": "ballad"
    },
    {
      "headword": "ballet"
    },
    {
      "headword": "balloon"
    },
    {
      "headword": "ballot"
    },
    {
      "headword": "ban"
    },
    {
      "headword": "ban"
    },
    {
      "headword": "banana"
    },
    {
      "headword": "band"
    },
    {
      "headword": "bandage"
    },
    {
      "headword": "bang"
    },
    {
      "headword": "bang"
    },
    {
      "headword": "bank"
    },
    {
      "headword": "bank"
    },
    {
      "headword": "bank account"
    },
    {
      "headword": "banker"
    },
    {
      "headword": "banking"
    },
    {
      "headword": "bankrupt"
    },
    {
      "headword": "bankruptcy"
    },
    {
      "headword": "bar"
    },
    {
      "headword": "bar"
    },
    {
      "headword": "barbecue"
    },
    {
      "headword": "barbecue"
    },
    {
      "headword": "barber"
    },
    {
      "headword": "barbershop"
    },
    {
      "headword": "bare"
    },
    {
      "headword": "bare"
    },
    {
      "headword": "barely"
    },
    {
      "headword": "bargain"
    },
    {
      "headword": "bargain"
    },
    {
      "headword": "bark"
    },
    {
      "headword": "bark"
    },
    {
      "headword": "barley"
    },
    {
      "headword": "barman"
    },
    {
      "headword": "barn"
    },
    {
      "headword": "barometer"
    },
    {
      "headword": "barrel"
    },
    {
      "headword": "barren"
    },
    {
      "headword": "barrier"
    },
    {
      "headword": "bartender"
    },
    {
      "headword": "base"
    },
    {
      "headword": "base"
    },
    {
      "headword": "baseball"
    },
    {
      "headword": "basement"
    },
    {
      "headword": "basic"
    },
    {
      "headword": "basically"
    },
    {
      "headword": "basin"
    },
    {
      "headword": "basis"
    },
    {
      "headword": "basket"
    },
    {
      "headword": "basketball"
    },
    {
      "headword": "bat"
    },
    {
      "headword": "bat"
    },
    {
      "headword": "batch"
    },
    {
      "headword": "bath"
    },
    {
      "headword": "bathe"
    },
    {
      "headword": "bathhouse"
    },
    {
      "headword": "bathroom"
    },
    {
      "headword": "battery"
    },
    {
      "headword": "battle"
    },
    {
      "headword": "battlefield"
    },
    {
      "headword": "bay"
    },
    {
      "headword": "be"
    },
    {
      "headword": "beach"
    },
    {
      "headword": "beagle"
    },
    {
      "headword": "beak"
    },
    {
      "headword": "beam"
    },
    {
      "headword": "bean"
    },
    {
      "headword": "bear"
    },
    {
      "headword": "bear"
    },
    {
      "headword": "beard"
    },
    {
      "headword": "bearing"
    },
    {
      "headword": "beast"
    },
    {
      "headword": "beat"
    },
    {
      "headword": "beat"
    },
    {
      "headword": "beautiful"
    },
    {
      "headword": "beautifully"
    },
    {
      "headword": "beautify"
    },
    {
      "headword": "beauty"
    },
    {
      "headword": "beaver"
    },
    {
      "headword": "because"
    },
    {
      "headword": "because of"
    },
    {
      "headword": "become"
    },
    {
      "headword": "bed"
    },
    {
      "headword": "bedroom"
    },
    {
      "headword": "bedside"
    },
    {
      "headword": "bee"
    },
    {
      "headword": "beef"
    },
    {
      "headword": "been"
    },
    {
      "headword": "beer"
    },
    {
      "headword": "before"
    },
    {
      "headword": "before"
    },
    {
      "headword": "before"
    },
    {
      "headword": "beg"
    },
    {
      "headword": "begin"
    },
    {
      "headword": "beginner"
    },
    {
      "headword": "beginning"
    },
    {
      "headword": "behalf"
    },
    {
      "headword": "behave"
    },
    {
      "headword": "behavior/behaviour"
    },
    {
      "headword": "behind"
    },
    {
      "headword": "behind"
    },
    {
      "headword": "being"
    },
    {
      "headword": "belief"
    },
    {
      "headword": "believe"
    },
    {
      "headword": "bell"
    },
    {
      "headword": "bellow"
    },
    {
      "headword": "belly"
    },
    {
      "headword": "belong"
    },
    {
      "headword": "belongings"
    },
    {
      "headword": "beloved"
    },
    {
      "headword": "below"
    },
    {
      "headword": "below"
    },
    {
      "headword": "belt"
    },
    {
      "headword": "bench"
    },
    {
      "headword": "bend"
    },
    {
      "headword": "bend"
    },
    {
      "headword": "beneath"
    },
    {
      "headword": "beneficial"
    },
    {
      "headword": "benefit"
    },
    {
      "headword": "benefit"
    },
    {
      "headword": "benevolence"
    },
    {
      "headword": "benevolent"
    },
    {
      "headword": "bent"
    },
    {
      "headword": "berry"
    },
    {
      "headword": "beside"
    },
    {
      "headword": "besides"
    },
    {
      "headword": "besides"
    },
    {
      "headword": "best"
    },
    {
      "headword": "best"
    },
    {
      "headword": "bestow"
    },
    {
      "headword": "bestseller"
    },
    {
      "headword": "bet"
    },
    {
      "headword": "betray"
    },
    {
      "headword": "better"
    },
    {
      "headword": "better"
    },
    {
      "headword": "between"
    },
    {
      "headword": "bewilder"
    },
    {
      "headword": "bewilderment"
    },
    {
      "headword": "beyond"
    },
    {
      "headword": "bicycle"
    },
    {
      "headword": "bid"
    },
    {
      "headword": "bidding"
    },
    {
      "headword": "big"
    },
    {
      "headword": "bike"
    },
    {
      "headword": "bikini"
    },
    {
      "headword": "bilingual"
    },
    {
      "headword": "bill"
    },
    {
      "headword": "bill"
    },
    {
      "headword": "billion"
    },
    {
      "headword": "bin"
    },
    {
      "headword": "bind"
    },
    {
      "headword": "bio"
    },
    {
      "headword": "biochemistry"
    },
    {
      "headword": "biography"
    },
    {
      "headword": "biological"
    },
    {
      "headword": "biology"
    },
    {
      "headword": "biotechnology"
    },
    {
      "headword": "bird"
    },
    {
      "headword": "birdcage"
    },
    {
      "headword": "birth"
    },
    {
      "headword": "birthday"
    },
    {
      "headword": "birthplace"
    },
    {
      "headword": "biscuit"
    },
    {
      "headword": "bishop"
    },
    {
      "headword": "bit"
    },
    {
      "headword": "bite"
    },
    {
      "headword": "bite"
    },
    {
      "headword": "bitter"
    },
    {
      "headword": "bitterly"
    },
    {
      "headword": "bizarre"
    },
    {
      "headword": "black"
    },
    {
      "headword": "black"
    },
    {
      "headword": "blackboard"
    },
    {
      "headword": "blade"
    },
    {
      "headword": "blame"
    },
    {
      "headword": "blame"
    },
    {
      "headword": "blank"
    },
    {
      "headword": "blanket"
    },
    {
      "headword": "blast"
    },
    {
      "headword": "blast"
    },
    {
      "headword": "blaze"
    },
    {
      "headword": "blaze"
    },
    {
      "headword": "bleed"
    },
    {
      "headword": "blend"
    },
    {
      "headword": "blend"
    },
    {
      "headword": "bless"
    },
    {
      "headword": "blessing"
    },
    {
      "headword": "blind"
    },
    {
      "headword": "blindly"
    },
    {
      "headword": "blindness"
    },
    {
      "headword": "blink"
    },
    {
      "headword": "block"
    },
    {
      "headword": "block"
    },
    {
      "headword": "blog"
    },
    {
      "headword": "blogger"
    },
    {
      "headword": "blonde"
    },
    {
      "headword": "blood"
    },
    {
      "headword": "bloodstream"
    },
    {
      "headword": "bloody"
    },
    {
      "headword": "bloody"
    },
    {
      "headword": "bloom"
    },
    {
      "headword": "blooming"
    },
    {
      "headword": "blossom"
    },
    {
      "headword": "blow"
    },
    {
      "headword": "blow"
    },
    {
      "headword": "blue"
    },
    {
      "headword": "blue"
    },
    {
      "headword": "blur"
    },
    {
      "headword": "blurt"
    },
    {
      "headword": "blush"
    },
    {
      "headword": "blush"
    },
    {
      "headword": "board"
    },
    {
      "headword": "board"
    },
    {
      "headword": "board game"
    },
    {
      "headword": "boast"
    },
    {
      "headword": "boat"
    },
    {
      "headword": "body"
    },
    {
      "headword": "boil"
    },
    {
      "headword": "boiled"
    },
    {
      "headword": "boiling"
    },
    {
      "headword": "bold"
    },
    {
      "headword": "bold"
    },
    {
      "headword": "boldly"
    },
    {
      "headword": "bolt"
    },
    {
      "headword": "bolt"
    },
    {
      "headword": "bomb"
    },
    {
      "headword": "bomb"
    },
    {
      "headword": "bombard"
    },
    {
      "headword": "bomber"
    },
    {
      "headword": "bombing"
    },
    {
      "headword": "bond"
    },
    {
      "headword": "bone"
    },
    {
      "headword": "bonus"
    },
    {
      "headword": "bony"
    },
    {
      "headword": "book"
    },
    {
      "headword": "book"
    },
    {
      "headword": "bookcase"
    },
    {
      "headword": "booking"
    },
    {
      "headword": "bookish"
    },
    {
      "headword": "booklet"
    },
    {
      "headword": "bookmark"
    },
    {
      "headword": "bookmark"
    },
    {
      "headword": "bookshelf"
    },
    {
      "headword": "bookshop"
    },
    {
      "headword": "bookstore"
    },
    {
      "headword": "boom"
    },
    {
      "headword": "boost"
    },
    {
      "headword": "boost"
    },
    {
      "headword": "boot"
    },
    {
      "headword": "booth"
    },
    {
      "headword": "border"
    },
    {
      "headword": "bore"
    },
    {
      "headword": "bored"
    },
    {
      "headword": "boredom"
    },
    {
      "headword": "boring"
    },
    {
      "headword": "borrow"
    },
    {
      "headword": "boss"
    },
    {
      "headword": "bossy"
    },
    {
      "headword": "botany"
    },
    {
      "headword": "both"
    },
    {
      "headword": "both"
    },
    {
      "headword": "both"
    },
    {
      "headword": "bother"
    },
    {
      "headword": "bother"
    },
    {
      "headword": "bothered"
    },
    {
      "headword": "bothersome"
    },
    {
      "headword": "bottle"
    },
    {
      "headword": "bottle"
    },
    {
      "headword": "bottom"
    },
    {
      "headword": "bounce"
    },
    {
      "headword": "bounce"
    },
    {
      "headword": "bound"
    },
    {
      "headword": "bourbon"
    },
    {
      "headword": "bow"
    },
    {
      "headword": "bow"
    },
    {
      "headword": "bowl"
    },
    {
      "headword": "bowl"
    },
    {
      "headword": "box"
    },
    {
      "headword": "boxer"
    },
    {
      "headword": "boxing"
    },
    {
      "headword": "boy"
    },
    {
      "headword": "boyfriend"
    },
    {
      "headword": "bra"
    },
    {
      "headword": "bracelet"
    },
    {
      "headword": "bracket"
    },
    {
      "headword": "brag"
    },
    {
      "headword": "brain"
    },
    {
      "headword": "brainstorm"
    },
    {
      "headword": "brainstorming"
    },
    {
      "headword": "brake"
    },
    {
      "headword": "brake"
    },
    {
      "headword": "branch"
    },
    {
      "headword": "branch"
    },
    {
      "headword": "brand"
    },
    {
      "headword": "brand-new"
    },
    {
      "headword": "brass"
    },
    {
      "headword": "brave"
    },
    {
      "headword": "bravely"
    },
    {
      "headword": "bravery"
    },
    {
      "headword": "bread"
    },
    {
      "headword": "break"
    },
    {
      "headword": "break"
    },
    {
      "headword": "breakable"
    },
    {
      "headword": "breakdown"
    },
    {
      "headword": "breakfast"
    },
    {
      "headword": "breakthrough"
    },
    {
      "headword": "breakup"
    },
    {
      "headword": "breast"
    },
    {
      "headword": "breath"
    },
    {
      "headword": "breathe"
    },
    {
      "headword": "breathless"
    },
    {
      "headword": "breathtaking"
    },
    {
      "headword": "breed"
    },
    {
      "headword": "breed"
    },
    {
      "headword": "breeding"
    },
    {
      "headword": "breeze"
    },
    {
      "headword": "breezy"
    },
    {
      "headword": "brewery"
    },
    {
      "headword": "brick"
    },
    {
      "headword": "bride"
    },
    {
      "headword": "bridge"
    },
    {
      "headword": "brief"
    },
    {
      "headword": "briefly"
    },
    {
      "headword": "bright"
    },
    {
      "headword": "brightly"
    },
    {
      "headword": "brilliant"
    },
    {
      "headword": "brilliantly"
    },
    {
      "headword": "bring"
    },
    {
      "headword": "broad"
    },
    {
      "headword": "broadband"
    },
    {
      "headword": "broadcast"
    },
    {
      "headword": "broadcast"
    },
    {
      "headword": "broadcaster"
    },
    {
      "headword": "broaden"
    },
    {
      "headword": "broadly"
    },
    {
      "headword": "broccoli"
    },
    {
      "headword": "brochure"
    },
    {
      "headword": "broken"
    },
    {
      "headword": "bronze"
    },
    {
      "headword": "brother"
    },
    {
      "headword": "brotherhood"
    },
    {
      "headword": "brother-in-law"
    },
    {
      "headword": "brown"
    },
    {
      "headword": "brown"
    },
    {
      "headword": "browse"
    },
    {
      "headword": "browser"
    },
    {
      "headword": "bruise"
    },
    {
      "headword": "brush"
    },
    {
      "headword": "brush"
    },
    {
      "headword": "bubble"
    },
    {
      "headword": "bucket"
    },
    {
      "headword": "bud"
    },
    {
      "headword": "buddy"
    },
    {
      "headword": "budget"
    },
    {
      "headword": "budget"
    },
    {
      "headword": "bug"
    },
    {
      "headword": "build"
    },
    {
      "headword": "builder"
    },
    {
      "headword": "building"
    },
    {
      "headword": "bulb"
    },
    {
      "headword": "bulimia"
    },
    {
      "headword": "bull"
    },
    {
      "headword": "bullet"
    },
    {
      "headword": "bulletin"
    },
    {
      "headword": "bully"
    },
    {
      "headword": "bum"
    },
    {
      "headword": "bump"
    },
    {
      "headword": "bumper"
    },
    {
      "headword": "bun"
    },
    {
      "headword": "bunch"
    },
    {
      "headword": "burden"
    },
    {
      "headword": "burden"
    },
    {
      "headword": "burdensome"
    },
    {
      "headword": "bureau"
    },
    {
      "headword": "bureaucracy"
    },
    {
      "headword": "burger"
    },
    {
      "headword": "burglar"
    },
    {
      "headword": "burglary"
    },
    {
      "headword": "burgle"
    },
    {
      "headword": "burial"
    },
    {
      "headword": "burn"
    },
    {
      "headword": "burn"
    },
    {
      "headword": "burning"
    },
    {
      "headword": "burst"
    },
    {
      "headword": "bury"
    },
    {
      "headword": "bus"
    },
    {
      "headword": "bus station"
    },
    {
      "headword": "bus stop"
    },
    {
      "headword": "bush"
    },
    {
      "headword": "business"
    },
    {
      "headword": "businessman"
    },
    {
      "headword": "businesswoman"
    },
    {
      "headword": "bust"
    },
    {
      "headword": "bustle"
    },
    {
      "headword": "bustling"
    },
    {
      "headword": "busy"
    },
    {
      "headword": "but"
    },
    {
      "headword": "but"
    },
    {
      "headword": "butcher"
    },
    {
      "headword": "butcher"
    },
    {
      "headword": "butter"
    },
    {
      "headword": "butterfly"
    },
    {
      "headword": "button"
    },
    {
      "headword": "buy"
    },
    {
      "headword": "buyer"
    },
    {
      "headword": "buzz"
    },
    {
      "headword": "buzz"
    },
    {
      "headword": "by"
    },
    {
      "headword": "bye"
    },
    {
      "headword": "cab"
    },
    {
      "headword": "cabbage"
    },
    {
      "headword": "cabin"
    },
    {
      "headword": "cabinet"
    },
    {
      "headword": "cable"
    },
    {
      "headword": "cafe/café"
    },
    {
      "headword": "cafeteria"
    },
    {
      "headword": "cage"
    },
    {
      "headword": "cake"
    },
    {
      "headword": "calculate"
    },
    {
      "headword": "calculation"
    },
    {
      "headword": "calculator"
    },
    {
      "headword": "calendar"
    },
    {
      "headword": "calf"
    },
    {
      "headword": "call"
    },
    {
      "headword": "call"
    },
    {
      "headword": "caller"
    },
    {
      "headword": "calm"
    },
    {
      "headword": "calmly"
    },
    {
      "headword": "calmness"
    },
    {
      "headword": "camel"
    },
    {
      "headword": "camera"
    },
    {
      "headword": "camp"
    },
    {
      "headword": "camp"
    },
    {
      "headword": "campaign"
    },
    {
      "headword": "camping"
    },
    {
      "headword": "campsite"
    },
    {
      "headword": "campus"
    },
    {
      "headword": "can"
    },
    {
      "headword": "can"
    },
    {
      "headword": "canal"
    },
    {
      "headword": "cancel"
    },
    {
      "headword": "cancer"
    },
    {
      "headword": "candidate"
    },
    {
      "headword": "candle"
    },
    {
      "headword": "candy"
    },
    {
      "headword": "cane"
    },
    {
      "headword": "canned"
    },
    {
      "headword": "cannonball"
    },
    {
      "headword": "canon"
    },
    {
      "headword": "canteen"
    },
    {
      "headword": "cap"
    },
    {
      "headword": "capability"
    },
    {
      "headword": "capable"
    },
    {
      "headword": "capacity"
    },
    {
      "headword": "capital"
    },
    {
      "headword": "capital letter"
    },
    {
      "headword": "capsule"
    },
    {
      "headword": "captain"
    },
    {
      "headword": "caption"
    },
    {
      "headword": "captive"
    },
    {
      "headword": "capture"
    },
    {
      "headword": "capture"
    },
    {
      "headword": "car"
    },
    {
      "headword": "car park"
    },
    {
      "headword": "caravan"
    },
    {
      "headword": "carbon"
    },
    {
      "headword": "carbon dioxide"
    },
    {
      "headword": "carbon footprint"
    },
    {
      "headword": "carbon monoxide"
    },
    {
      "headword": "card"
    },
    {
      "headword": "cardboard"
    },
    {
      "headword": "cardigan"
    },
    {
      "headword": "care"
    },
    {
      "headword": "care"
    },
    {
      "headword": "career"
    },
    {
      "headword": "carefree"
    },
    {
      "headword": "careful"
    },
    {
      "headword": "carefully"
    },
    {
      "headword": "careless"
    },
    {
      "headword": "carelessly"
    },
    {
      "headword": "carelessness"
    },
    {
      "headword": "caring"
    },
    {
      "headword": "carnival"
    },
    {
      "headword": "carpet"
    },
    {
      "headword": "carpool"
    },
    {
      "headword": "carriage"
    },
    {
      "headword": "carrot"
    },
    {
      "headword": "carry"
    },
    {
      "headword": "carton"
    },
    {
      "headword": "cartoon"
    },
    {
      "headword": "carve"
    },
    {
      "headword": "cascade"
    },
    {
      "headword": "case"
    },
    {
      "headword": "cash"
    },
    {
      "headword": "cashpoint"
    },
    {
      "headword": "cassette"
    },
    {
      "headword": "cast"
    },
    {
      "headword": "cast"
    },
    {
      "headword": "castle"
    },
    {
      "headword": "casual"
    },
    {
      "headword": "casually"
    },
    {
      "headword": "cat"
    },
    {
      "headword": "catalog/catalogue"
    },
    {
      "headword": "catalyst"
    },
    {
      "headword": "catastrophe"
    },
    {
      "headword": "catastrophic"
    },
    {
      "headword": "catch"
    },
    {
      "headword": "catch"
    },
    {
      "headword": "catchy"
    },
    {
      "headword": "categorization/categorisation"
    },
    {
      "headword": "categorize/categorise"
    },
    {
      "headword": "category"
    },
    {
      "headword": "catering"
    },
    {
      "headword": "cathedral"
    },
    {
      "headword": "cattle"
    },
    {
      "headword": "cause"
    },
    {
      "headword": "cause"
    },
    {
      "headword": "caution"
    },
    {
      "headword": "cautious"
    },
    {
      "headword": "cave"
    },
    {
      "headword": "CD"
    },
    {
      "headword": "CD player"
    },
    {
      "headword": "CD-ROM"
    },
    {
      "headword": "cease"
    },
    {
      "headword": "ceiling"
    },
    {
      "headword": "celebrate"
    },
    {
      "headword": "celebration"
    },
    {
      "headword": "celebrity"
    },
    {
      "headword": "cell"
    },
    {
      "headword": "cellar"
    },
    {
      "headword": "cellist"
    },
    {
      "headword": "cello"
    },
    {
      "headword": "cemetery"
    },
    {
      "headword": "cent"
    },
    {
      "headword": "center/centre"
    },
    {
      "headword": "centigrade"
    },
    {
      "headword": "centimeter/centimetre"
    },
    {
      "headword": "central"
    },
    {
      "headword": "central heating"
    },
    {
      "headword": "century"
    },
    {
      "headword": "cereal"
    },
    {
      "headword": "ceremony"
    },
    {
      "headword": "certain"
    },
    {
      "headword": "certainly"
    },
    {
      "headword": "certainty"
    },
    {
      "headword": "certificate"
    },
    {
      "headword": "certification"
    },
    {
      "headword": "certify"
    },
    {
      "headword": "chain"
    },
    {
      "headword": "chair"
    },
    {
      "headword": "chairman"
    },
    {
      "headword": "challenge"
    },
    {
      "headword": "challenge"
    },
    {
      "headword": "challenging"
    },
    {
      "headword": "champagne"
    },
    {
      "headword": "champion"
    },
    {
      "headword": "championship"
    },
    {
      "headword": "chance"
    },
    {
      "headword": "chancellor"
    },
    {
      "headword": "change"
    },
    {
      "headword": "change"
    },
    {
      "headword": "channel"
    },
    {
      "headword": "chaos"
    },
    {
      "headword": "chaotic"
    },
    {
      "headword": "chapter"
    },
    {
      "headword": "character"
    },
    {
      "headword": "characteristic"
    },
    {
      "headword": "characteristic"
    },
    {
      "headword": "characterize/characterise"
    },
    {
      "headword": "charge"
    },
    {
      "headword": "charge"
    },
    {
      "headword": "chariot"
    },
    {
      "headword": "charity"
    },
    {
      "headword": "charm"
    },
    {
      "headword": "charming"
    },
    {
      "headword": "chart"
    },
    {
      "headword": "chase"
    },
    {
      "headword": "chase"
    },
    {
      "headword": "chat"
    },
    {
      "headword": "chat"
    },
    {
      "headword": "chat show"
    },
    {
      "headword": "cheap"
    },
    {
      "headword": "cheat"
    },
    {
      "headword": "check"
    },
    {
      "headword": "check"
    },
    {
      "headword": "check-in counter/check-in"
    },
    {
      "headword": "check-in desk/check-in"
    },
    {
      "headword": "checkout"
    },
    {
      "headword": "checkpoint"
    },
    {
      "headword": "cheek"
    },
    {
      "headword": "cheeky"
    },
    {
      "headword": "cheer"
    },
    {
      "headword": "cheerful"
    },
    {
      "headword": "cheerfully"
    },
    {
      "headword": "cheerfulness"
    },
    {
      "headword": "cheese"
    },
    {
      "headword": "chef"
    },
    {
      "headword": "chemical"
    },
    {
      "headword": "chemical"
    },
    {
      "headword": "chemist"
    },
    {
      "headword": "chemistry"
    },
    {
      "headword": "chemotherapy"
    },
    {
      "headword": "cheque"
    },
    {
      "headword": "cherish"
    },
    {
      "headword": "cherished"
    },
    {
      "headword": "cherry"
    },
    {
      "headword": "chess"
    },
    {
      "headword": "chest"
    },
    {
      "headword": "chest of drawers"
    },
    {
      "headword": "chew"
    },
    {
      "headword": "chewing gum"
    },
    {
      "headword": "chicken"
    },
    {
      "headword": "chief"
    },
    {
      "headword": "chief"
    },
    {
      "headword": "child"
    },
    {
      "headword": "childhood"
    },
    {
      "headword": "childish"
    },
    {
      "headword": "chili/chilli"
    },
    {
      "headword": "chimney"
    },
    {
      "headword": "chimpanzee"
    },
    {
      "headword": "chin"
    },
    {
      "headword": "chip"
    },
    {
      "headword": "chirp"
    },
    {
      "headword": "chocolate"
    },
    {
      "headword": "choice"
    },
    {
      "headword": "choir"
    },
    {
      "headword": "choke"
    },
    {
      "headword": "choose"
    },
    {
      "headword": "chop"
    },
    {
      "headword": "Christian"
    },
    {
      "headword": "chronological"
    },
    {
      "headword": "chuckle"
    },
    {
      "headword": "chunk"
    },
    {
      "headword": "church"
    },
    {
      "headword": "cigarette"
    },
    {
      "headword": "cinema"
    },
    {
      "headword": "circle"
    },
    {
      "headword": "circle"
    },
    {
      "headword": "circuit"
    },
    {
      "headword": "circuitry"
    },
    {
      "headword": "circular"
    },
    {
      "headword": "circumstance"
    },
    {
      "headword": "circus"
    },
    {
      "headword": "citizen"
    },
    {
      "headword": "citizenship"
    },
    {
      "headword": "city"
    },
    {
      "headword": "citywide"
    },
    {
      "headword": "civil"
    },
    {
      "headword": "civilization/civilisation"
    },
    {
      "headword": "claim"
    },
    {
      "headword": "claim"
    },
    {
      "headword": "clam"
    },
    {
      "headword": "clap"
    },
    {
      "headword": "clarify"
    },
    {
      "headword": "class"
    },
    {
      "headword": "classic"
    },
    {
      "headword": "classic"
    },
    {
      "headword": "classical"
    },
    {
      "headword": "classical music"
    },
    {
      "headword": "classification"
    },
    {
      "headword": "classify"
    },
    {
      "headword": "classmate"
    },
    {
      "headword": "classroom"
    },
    {
      "headword": "clause"
    },
    {
      "headword": "clean"
    },
    {
      "headword": "clean"
    },
    {
      "headword": "cleaner"
    },
    {
      "headword": "clear"
    },
    {
      "headword": "clear"
    },
    {
      "headword": "clearly"
    },
    {
      "headword": "clearness"
    },
    {
      "headword": "clerical"
    },
    {
      "headword": "clerk"
    },
    {
      "headword": "clever"
    },
    {
      "headword": "click"
    },
    {
      "headword": "click"
    },
    {
      "headword": "client"
    },
    {
      "headword": "cliff"
    },
    {
      "headword": "climate"
    },
    {
      "headword": "climate change"
    },
    {
      "headword": "climb"
    },
    {
      "headword": "climb"
    },
    {
      "headword": "climber"
    },
    {
      "headword": "climbing"
    },
    {
      "headword": "clinic"
    },
    {
      "headword": "clip"
    },
    {
      "headword": "clock"
    },
    {
      "headword": "clog"
    },
    {
      "headword": "clone"
    },
    {
      "headword": "close"
    },
    {
      "headword": "close"
    },
    {
      "headword": "closed"
    },
    {
      "headword": "closely"
    },
    {
      "headword": "closure"
    },
    {
      "headword": "cloth"
    },
    {
      "headword": "clothes"
    },
    {
      "headword": "clothing"
    },
    {
      "headword": "cloud"
    },
    {
      "headword": "cloudy"
    },
    {
      "headword": "clown"
    },
    {
      "headword": "club"
    },
    {
      "headword": "clue"
    },
    {
      "headword": "clumsy"
    },
    {
      "headword": "coach"
    },
    {
      "headword": "coach"
    },
    {
      "headword": "coaching"
    },
    {
      "headword": "coal"
    },
    {
      "headword": "coalition"
    },
    {
      "headword": "coarse"
    },
    {
      "headword": "coast"
    },
    {
      "headword": "coast"
    },
    {
      "headword": "coastal"
    },
    {
      "headword": "coastline"
    },
    {
      "headword": "coat"
    },
    {
      "headword": "cocktail"
    },
    {
      "headword": "cocoa"
    },
    {
      "headword": "coconut"
    },
    {
      "headword": "cod"
    },
    {
      "headword": "code"
    },
    {
      "headword": "coffee"
    },
    {
      "headword": "coffin"
    },
    {
      "headword": "coherence"
    },
    {
      "headword": "coherent"
    },
    {
      "headword": "coin"
    },
    {
      "headword": "coincide"
    },
    {
      "headword": "coincidence"
    },
    {
      "headword": "coke"
    },
    {
      "headword": "cola"
    },
    {
      "headword": "cold"
    },
    {
      "headword": "cold"
    },
    {
      "headword": "collapse"
    },
    {
      "headword": "collapse"
    },
    {
      "headword": "collar"
    },
    {
      "headword": "colleague"
    },
    {
      "headword": "collect"
    },
    {
      "headword": "collection"
    },
    {
      "headword": "collector"
    },
    {
      "headword": "college"
    },
    {
      "headword": "collocation"
    },
    {
      "headword": "colon"
    },
    {
      "headword": "colonial"
    },
    {
      "headword": "color/colour"
    },
    {
      "headword": "color/colour"
    },
    {
      "headword": "colorful/colourful"
    },
    {
      "headword": "column"
    },
    {
      "headword": "columnist"
    },
    {
      "headword": "coma"
    },
    {
      "headword": "comb"
    },
    {
      "headword": "comb"
    },
    {
      "headword": "combination"
    },
    {
      "headword": "combine"
    },
    {
      "headword": "come"
    },
    {
      "headword": "comedian"
    },
    {
      "headword": "comedy"
    },
    {
      "headword": "comet"
    },
    {
      "headword": "comfort"
    },
    {
      "headword": "comfortable"
    },
    {
      "headword": "comfortably"
    },
    {
      "headword": "comic"
    },
    {
      "headword": "comic"
    },
    {
      "headword": "comma"
    },
    {
      "headword": "command"
    },
    {
      "headword": "commander"
    },
    {
      "headword": "commemorate"
    },
    {
      "headword": "comment"
    },
    {
      "headword": "comment"
    },
    {
      "headword": "commerce"
    },
    {
      "headword": "commercial"
    },
    {
      "headword": "commercial"
    },
    {
      "headword": "commission"
    },
    {
      "headword": "commit"
    },
    {
      "headword": "commitment"
    },
    {
      "headword": "committee"
    },
    {
      "headword": "common"
    },
    {
      "headword": "common sense"
    },
    {
      "headword": "commonly"
    },
    {
      "headword": "commonwealth"
    },
    {
      "headword": "communicate"
    },
    {
      "headword": "communication"
    },
    {
      "headword": "communicative"
    },
    {
      "headword": "community"
    },
    {
      "headword": "commute"
    },
    {
      "headword": "companion"
    },
    {
      "headword": "company"
    },
    {
      "headword": "comparative"
    },
    {
      "headword": "compare"
    },
    {
      "headword": "comparison"
    },
    {
      "headword": "compassion"
    },
    {
      "headword": "compassionate"
    },
    {
      "headword": "compatible"
    },
    {
      "headword": "compensate"
    },
    {
      "headword": "compensation"
    },
    {
      "headword": "compete"
    },
    {
      "headword": "competence"
    },
    {
      "headword": "competent"
    },
    {
      "headword": "competition"
    },
    {
      "headword": "competitive"
    },
    {
      "headword": "competitor"
    },
    {
      "headword": "compile"
    },
    {
      "headword": "complain"
    },
    {
      "headword": "complaint"
    },
    {
      "headword": "complement"
    },
    {
      "headword": "complete"
    },
    {
      "headword": "complete"
    },
    {
      "headword": "completely"
    },
    {
      "headword": "completion"
    },
    {
      "headword": "complex"
    },
    {
      "headword": "complexion"
    },
    {
      "headword": "complexity"
    },
    {
      "headword": "complicate"
    },
    {
      "headword": "complicated"
    },
    {
      "headword": "compliment"
    },
    {
      "headword": "component"
    },
    {
      "headword": "compose"
    },
    {
      "headword": "composer"
    },
    {
      "headword": "composition"
    },
    {
      "headword": "compound"
    },
    {
      "headword": "comprehension"
    },
    {
      "headword": "comprehensive"
    },
    {
      "headword": "compress"
    },
    {
      "headword": "compression"
    },
    {
      "headword": "compromise"
    },
    {
      "headword": "compromise"
    },
    {
      "headword": "compulsory"
    },
    {
      "headword": "compute"
    },
    {
      "headword": "computer"
    },
    {
      "headword": "conceal"
    },
    {
      "headword": "concede"
    },
    {
      "headword": "conceit"
    },
    {
      "headword": "conceivable"
    },
    {
      "headword": "conceive"
    },
    {
      "headword": "concentrate"
    },
    {
      "headword": "concentration"
    },
    {
      "headword": "concept"
    },
    {
      "headword": "conception"
    },
    {
      "headword": "concern"
    },
    {
      "headword": "concern"
    },
    {
      "headword": "concerned"
    },
    {
      "headword": "concerning"
    },
    {
      "headword": "concert"
    },
    {
      "headword": "concession"
    },
    {
      "headword": "conclude"
    },
    {
      "headword": "conclusion"
    },
    {
      "headword": "concrete"
    },
    {
      "headword": "concrete"
    },
    {
      "headword": "condemn"
    },
    {
      "headword": "condition"
    },
    {
      "headword": "conduct"
    },
    {
      "headword": "conduct"
    },
    {
      "headword": "conductor"
    },
    {
      "headword": "cone"
    },
    {
      "headword": "conference"
    },
    {
      "headword": "conferencing"
    },
    {
      "headword": "confess"
    },
    {
      "headword": "confession"
    },
    {
      "headword": "confidence"
    },
    {
      "headword": "confident"
    },
    {
      "headword": "confidently"
    },
    {
      "headword": "confine"
    },
    {
      "headword": "confirm"
    },
    {
      "headword": "confirmation"
    },
    {
      "headword": "conflict"
    },
    {
      "headword": "confront"
    },
    {
      "headword": "confuse"
    },
    {
      "headword": "confused"
    },
    {
      "headword": "confusing"
    },
    {
      "headword": "confusion"
    },
    {
      "headword": "congratulate"
    },
    {
      "headword": "conjunction"
    },
    {
      "headword": "connect"
    },
    {
      "headword": "connection/connexion"
    },
    {
      "headword": "conquer"
    },
    {
      "headword": "conquest"
    },
    {
      "headword": "conscience"
    },
    {
      "headword": "conscious"
    },
    {
      "headword": "consciousness"
    },
    {
      "headword": "consensus"
    },
    {
      "headword": "consent"
    },
    {
      "headword": "consequence"
    },
    {
      "headword": "consequently"
    },
    {
      "headword": "conservation"
    },
    {
      "headword": "conservative"
    },
    {
      "headword": "consider"
    },
    {
      "headword": "considerable"
    },
    {
      "headword": "considerably"
    },
    {
      "headword": "consideration"
    },
    {
      "headword": "considering"
    },
    {
      "headword": "considering"
    },
    {
      "headword": "consist"
    },
    {
      "headword": "consistent"
    },
    {
      "headword": "consolation"
    },
    {
      "headword": "console"
    },
    {
      "headword": "consonant"
    },
    {
      "headword": "constant"
    },
    {
      "headword": "constantly"
    },
    {
      "headword": "constitute"
    },
    {
      "headword": "constitution"
    },
    {
      "headword": "construct"
    },
    {
      "headword": "construction"
    },
    {
      "headword": "consult"
    },
    {
      "headword": "consultant"
    },
    {
      "headword": "consume"
    },
    {
      "headword": "consumer"
    },
    {
      "headword": "consumption"
    },
    {
      "headword": "contact"
    },
    {
      "headword": "contact"
    },
    {
      "headword": "contain"
    },
    {
      "headword": "container"
    },
    {
      "headword": "contaminate"
    },
    {
      "headword": "contemporary"
    },
    {
      "headword": "contempt"
    },
    {
      "headword": "content"
    },
    {
      "headword": "content"
    },
    {
      "headword": "contest"
    },
    {
      "headword": "context"
    },
    {
      "headword": "continent"
    },
    {
      "headword": "continual"
    },
    {
      "headword": "continually"
    },
    {
      "headword": "continue"
    },
    {
      "headword": "continuous"
    },
    {
      "headword": "continuously"
    },
    {
      "headword": "contract"
    },
    {
      "headword": "contradict"
    },
    {
      "headword": "contradiction"
    },
    {
      "headword": "contradictory"
    },
    {
      "headword": "contrary"
    },
    {
      "headword": "contrast"
    },
    {
      "headword": "contribute"
    },
    {
      "headword": "contribution"
    },
    {
      "headword": "control"
    },
    {
      "headword": "control"
    },
    {
      "headword": "controversial"
    },
    {
      "headword": "controversy"
    },
    {
      "headword": "convenience"
    },
    {
      "headword": "convenient"
    },
    {
      "headword": "conveniently"
    },
    {
      "headword": "convention"
    },
    {
      "headword": "conventional"
    },
    {
      "headword": "conversation"
    },
    {
      "headword": "converse"
    },
    {
      "headword": "conversely"
    },
    {
      "headword": "conversion"
    },
    {
      "headword": "convert"
    },
    {
      "headword": "convey"
    },
    {
      "headword": "convince"
    },
    {
      "headword": "convinced"
    },
    {
      "headword": "cook"
    },
    {
      "headword": "cook"
    },
    {
      "headword": "cooker"
    },
    {
      "headword": "cookie"
    },
    {
      "headword": "cooking"
    },
    {
      "headword": "cool"
    },
    {
      "headword": "cool"
    },
    {
      "headword": "cooler"
    },
    {
      "headword": "cooperate"
    },
    {
      "headword": "cooperation"
    },
    {
      "headword": "cooperative"
    },
    {
      "headword": "cop"
    },
    {
      "headword": "cope"
    },
    {
      "headword": "copper"
    },
    {
      "headword": "copy"
    },
    {
      "headword": "copy"
    },
    {
      "headword": "copyright"
    },
    {
      "headword": "coral"
    },
    {
      "headword": "core"
    },
    {
      "headword": "corn"
    },
    {
      "headword": "corner"
    },
    {
      "headword": "cornerstone"
    },
    {
      "headword": "cornet"
    },
    {
      "headword": "corona"
    },
    {
      "headword": "corporal"
    },
    {
      "headword": "corporate"
    },
    {
      "headword": "corporation"
    },
    {
      "headword": "correct"
    },
    {
      "headword": "correct"
    },
    {
      "headword": "correction"
    },
    {
      "headword": "correctly"
    },
    {
      "headword": "correctness"
    },
    {
      "headword": "correspond"
    },
    {
      "headword": "correspondence"
    },
    {
      "headword": "correspondent"
    },
    {
      "headword": "corresponding"
    },
    {
      "headword": "corridor"
    },
    {
      "headword": "corrupt"
    },
    {
      "headword": "corruption"
    },
    {
      "headword": "cost"
    },
    {
      "headword": "cost"
    },
    {
      "headword": "costly"
    },
    {
      "headword": "costume"
    },
    {
      "headword": "cottage"
    },
    {
      "headword": "cotton"
    },
    {
      "headword": "couch"
    },
    {
      "headword": "cough"
    },
    {
      "headword": "cough"
    },
    {
      "headword": "could"
    },
    {
      "headword": "council"
    },
    {
      "headword": "counseling/counselling"
    },
    {
      "headword": "count"
    },
    {
      "headword": "count"
    },
    {
      "headword": "counter"
    },
    {
      "headword": "counter"
    },
    {
      "headword": "countless"
    },
    {
      "headword": "country"
    },
    {
      "headword": "countryman"
    },
    {
      "headword": "countryside"
    },
    {
      "headword": "countrywide"
    },
    {
      "headword": "county"
    },
    {
      "headword": "couple"
    },
    {
      "headword": "courage"
    },
    {
      "headword": "courageous"
    },
    {
      "headword": "courgette"
    },
    {
      "headword": "course"
    },
    {
      "headword": "court"
    },
    {
      "headword": "courtesy"
    },
    {
      "headword": "cousin"
    },
    {
      "headword": "cover"
    },
    {
      "headword": "cover"
    },
    {
      "headword": "cow"
    },
    {
      "headword": "coward"
    },
    {
      "headword": "cowardly"
    },
    {
      "headword": "coziness/cosiness"
    },
    {
      "headword": "cozy/cosy"
    },
    {
      "headword": "crab"
    },
    {
      "headword": "crack"
    },
    {
      "headword": "crack"
    },
    {
      "headword": "craft"
    },
    {
      "headword": "craftsman"
    },
    {
      "headword": "crash"
    },
    {
      "headword": "crash"
    },
    {
      "headword": "crater"
    },
    {
      "headword": "crawl"
    },
    {
      "headword": "crazy"
    },
    {
      "headword": "cream"
    },
    {
      "headword": "cream"
    },
    {
      "headword": "crease"
    },
    {
      "headword": "create"
    },
    {
      "headword": "creation"
    },
    {
      "headword": "creative"
    },
    {
      "headword": "creatively"
    },
    {
      "headword": "creativity"
    },
    {
      "headword": "creator"
    },
    {
      "headword": "creature"
    },
    {
      "headword": "credit"
    },
    {
      "headword": "credit card"
    },
    {
      "headword": "creek"
    },
    {
      "headword": "creepy"
    },
    {
      "headword": "crew"
    },
    {
      "headword": "cricket"
    },
    {
      "headword": "crime"
    },
    {
      "headword": "criminal"
    },
    {
      "headword": "criminal"
    },
    {
      "headword": "cripple"
    },
    {
      "headword": "crisis"
    },
    {
      "headword": "crisp"
    },
    {
      "headword": "critic"
    },
    {
      "headword": "critical"
    },
    {
      "headword": "critically"
    },
    {
      "headword": "criticism"
    },
    {
      "headword": "criticize/criticise"
    },
    {
      "headword": "crocodile"
    },
    {
      "headword": "crop"
    },
    {
      "headword": "cross"
    },
    {
      "headword": "cross"
    },
    {
      "headword": "crossing"
    },
    {
      "headword": "crossly"
    },
    {
      "headword": "crossroads"
    },
    {
      "headword": "crow"
    },
    {
      "headword": "crowd"
    },
    {
      "headword": "crowded"
    },
    {
      "headword": "crown"
    },
    {
      "headword": "crucial"
    },
    {
      "headword": "cruel"
    },
    {
      "headword": "cruelly"
    },
    {
      "headword": "cruelty"
    },
    {
      "headword": "cruise"
    },
    {
      "headword": "cruise"
    },
    {
      "headword": "crush"
    },
    {
      "headword": "cry"
    },
    {
      "headword": "cry"
    },
    {
      "headword": "crystallize/crystallise"
    },
    {
      "headword": "cube"
    },
    {
      "headword": "cubism"
    },
    {
      "headword": "cucumber"
    },
    {
      "headword": "cuff"
    },
    {
      "headword": "culmination"
    },
    {
      "headword": "cultivate"
    },
    {
      "headword": "cultural"
    },
    {
      "headword": "culturally"
    },
    {
      "headword": "culture"
    },
    {
      "headword": "cup"
    },
    {
      "headword": "cupboard"
    },
    {
      "headword": "cure"
    },
    {
      "headword": "cure"
    },
    {
      "headword": "curiosity"
    },
    {
      "headword": "curious"
    },
    {
      "headword": "curiously"
    },
    {
      "headword": "curl"
    },
    {
      "headword": "curly"
    },
    {
      "headword": "currency"
    },
    {
      "headword": "current"
    },
    {
      "headword": "currently"
    },
    {
      "headword": "curriculum"
    },
    {
      "headword": "curry"
    },
    {
      "headword": "curse"
    },
    {
      "headword": "cursor"
    },
    {
      "headword": "curtain"
    },
    {
      "headword": "curve"
    },
    {
      "headword": "cushion"
    },
    {
      "headword": "custom"
    },
    {
      "headword": "customer"
    },
    {
      "headword": "customs"
    },
    {
      "headword": "cut"
    },
    {
      "headword": "cut"
    },
    {
      "headword": "cute"
    },
    {
      "headword": "CV"
    },
    {
      "headword": "cyberaddict"
    },
    {
      "headword": "cybercafe/cybercafé"
    },
    {
      "headword": "cybercrime"
    },
    {
      "headword": "cyberpet"
    },
    {
      "headword": "cyberschool"
    },
    {
      "headword": "cyberspace"
    },
    {
      "headword": "cycle"
    },
    {
      "headword": "cycle"
    },
    {
      "headword": "cycling"
    },
    {
      "headword": "cyclist"
    },
    {
      "headword": "dad"
    },
    {
      "headword": "daddy"
    },
    {
      "headword": "daft"
    },
    {
      "headword": "daily"
    },
    {
      "headword": "daily"
    },
    {
      "headword": "daisy"
    },
    {
      "headword": "dam"
    },
    {
      "headword": "damage"
    },
    {
      "headword": "damage"
    },
    {
      "headword": "damaged"
    },
    {
      "headword": "damn"
    },
    {
      "headword": "damn"
    },
    {
      "headword": "damn"
    },
    {
      "headword": "damp"
    },
    {
      "headword": "dance"
    },
    {
      "headword": "dance"
    },
    {
      "headword": "dancer"
    },
    {
      "headword": "dancing"
    },
    {
      "headword": "dandelion"
    },
    {
      "headword": "danger"
    },
    {
      "headword": "dangerous"
    },
    {
      "headword": "dangerously"
    },
    {
      "headword": "dare"
    },
    {
      "headword": "dark"
    },
    {
      "headword": "darkness"
    },
    {
      "headword": "darling"
    },
    {
      "headword": "darling"
    },
    {
      "headword": "dash"
    },
    {
      "headword": "dash"
    },
    {
      "headword": "data"
    },
    {
      "headword": "database"
    },
    {
      "headword": "date"
    },
    {
      "headword": "date"
    },
    {
      "headword": "dated"
    },
    {
      "headword": "dating"
    },
    {
      "headword": "daughter"
    },
    {
      "headword": "daughter-in-law"
    },
    {
      "headword": "dawn"
    },
    {
      "headword": "day"
    },
    {
      "headword": "daylight"
    },
    {
      "headword": "daytime"
    },
    {
      "headword": "daze"
    },
    {
      "headword": "dazzle"
    },
    {
      "headword": "de facto"
    },
    {
      "headword": "dead"
    },
    {
      "headword": "deadline"
    },
    {
      "headword": "deadly"
    },
    {
      "headword": "deaf"
    },
    {
      "headword": "deal"
    },
    {
      "headword": "deal"
    },
    {
      "headword": "dealer"
    },
    {
      "headword": "dear"
    },
    {
      "headword": "dear"
    },
    {
      "headword": "dearly"
    },
    {
      "headword": "death"
    },
    {
      "headword": "debate"
    },
    {
      "headword": "debit"
    },
    {
      "headword": "debit"
    },
    {
      "headword": "debit card"
    },
    {
      "headword": "debris"
    },
    {
      "headword": "debt"
    },
    {
      "headword": "decade"
    },
    {
      "headword": "decay"
    },
    {
      "headword": "deceive"
    },
    {
      "headword": "December"
    },
    {
      "headword": "decent"
    },
    {
      "headword": "deceptive"
    },
    {
      "headword": "decide"
    },
    {
      "headword": "decision"
    },
    {
      "headword": "decisive"
    },
    {
      "headword": "deck"
    },
    {
      "headword": "declaration"
    },
    {
      "headword": "declare"
    },
    {
      "headword": "decline"
    },
    {
      "headword": "decline"
    },
    {
      "headword": "decomposition"
    },
    {
      "headword": "decorate"
    },
    {
      "headword": "decoration"
    },
    {
      "headword": "decorative"
    },
    {
      "headword": "decrease"
    },
    {
      "headword": "decrease"
    },
    {
      "headword": "dedicate"
    },
    {
      "headword": "dedication"
    },
    {
      "headword": "deduce"
    },
    {
      "headword": "deduction"
    },
    {
      "headword": "deed"
    },
    {
      "headword": "deem"
    },
    {
      "headword": "deep"
    },
    {
      "headword": "deep"
    },
    {
      "headword": "deeply"
    },
    {
      "headword": "deer"
    },
    {
      "headword": "defeat"
    },
    {
      "headword": "defeat"
    },
    {
      "headword": "defend"
    },
    {
      "headword": "defender"
    },
    {
      "headword": "defense/defence"
    },
    {
      "headword": "deficiency"
    },
    {
      "headword": "deficit"
    },
    {
      "headword": "define"
    },
    {
      "headword": "definite"
    },
    {
      "headword": "definite article"
    },
    {
      "headword": "definitely"
    },
    {
      "headword": "definition"
    },
    {
      "headword": "deforestation"
    },
    {
      "headword": "defy"
    },
    {
      "headword": "degree"
    },
    {
      "headword": "dehumanize/dehumanise"
    },
    {
      "headword": "delay"
    },
    {
      "headword": "delay"
    },
    {
      "headword": "delegate"
    },
    {
      "headword": "delete"
    },
    {
      "headword": "deliberate"
    },
    {
      "headword": "deliberately"
    },
    {
      "headword": "delicacy"
    },
    {
      "headword": "delicate"
    },
    {
      "headword": "delicately"
    },
    {
      "headword": "delicious"
    },
    {
      "headword": "delight"
    },
    {
      "headword": "delight"
    },
    {
      "headword": "delighted"
    },
    {
      "headword": "delightful"
    },
    {
      "headword": "deliver"
    },
    {
      "headword": "delivery"
    },
    {
      "headword": "demand"
    },
    {
      "headword": "demand"
    },
    {
      "headword": "demanding"
    },
    {
      "headword": "democracy"
    },
    {
      "headword": "democratic"
    },
    {
      "headword": "demolish"
    },
    {
      "headword": "demonstrate"
    },
    {
      "headword": "demonstration"
    },
    {
      "headword": "denim"
    },
    {
      "headword": "dense"
    },
    {
      "headword": "densely"
    },
    {
      "headword": "dental"
    },
    {
      "headword": "dentist"
    },
    {
      "headword": "deny"
    },
    {
      "headword": "depart"
    },
    {
      "headword": "department"
    },
    {
      "headword": "department store"
    },
    {
      "headword": "departure"
    },
    {
      "headword": "depend"
    },
    {
      "headword": "dependable"
    },
    {
      "headword": "dependent"
    },
    {
      "headword": "deposit"
    },
    {
      "headword": "deposit"
    },
    {
      "headword": "depressed"
    },
    {
      "headword": "depressing"
    },
    {
      "headword": "depression"
    },
    {
      "headword": "deprive"
    },
    {
      "headword": "depth"
    },
    {
      "headword": "deputy"
    },
    {
      "headword": "derive"
    },
    {
      "headword": "descend"
    },
    {
      "headword": "describe"
    },
    {
      "headword": "description"
    },
    {
      "headword": "descriptive"
    },
    {
      "headword": "desert"
    },
    {
      "headword": "deserve"
    },
    {
      "headword": "design"
    },
    {
      "headword": "design"
    },
    {
      "headword": "designer"
    },
    {
      "headword": "designer"
    },
    {
      "headword": "desirable"
    },
    {
      "headword": "desire"
    },
    {
      "headword": "desire"
    },
    {
      "headword": "desk"
    },
    {
      "headword": "desktop"
    },
    {
      "headword": "desolation"
    },
    {
      "headword": "despair"
    },
    {
      "headword": "desperate"
    },
    {
      "headword": "desperately"
    },
    {
      "headword": "desperation"
    },
    {
      "headword": "despise"
    },
    {
      "headword": "despite"
    },
    {
      "headword": "dessert"
    },
    {
      "headword": "destination"
    },
    {
      "headword": "destiny"
    },
    {
      "headword": "destroy"
    },
    {
      "headword": "destruction"
    },
    {
      "headword": "destructive"
    },
    {
      "headword": "detach"
    },
    {
      "headword": "detachment"
    },
    {
      "headword": "detail"
    },
    {
      "headword": "detailed"
    },
    {
      "headword": "detect"
    },
    {
      "headword": "detective"
    },
    {
      "headword": "determination"
    },
    {
      "headword": "determine"
    },
    {
      "headword": "determined"
    },
    {
      "headword": "determiner"
    },
    {
      "headword": "devastate"
    },
    {
      "headword": "devastating"
    },
    {
      "headword": "develop"
    },
    {
      "headword": "developed"
    },
    {
      "headword": "developing"
    },
    {
      "headword": "development"
    },
    {
      "headword": "device"
    },
    {
      "headword": "devil"
    },
    {
      "headword": "devote"
    },
    {
      "headword": "devoted"
    },
    {
      "headword": "devotion"
    },
    {
      "headword": "diagram"
    },
    {
      "headword": "dial"
    },
    {
      "headword": "dial"
    },
    {
      "headword": "dialog/dialogue"
    },
    {
      "headword": "diameter"
    },
    {
      "headword": "diamond"
    },
    {
      "headword": "diaper"
    },
    {
      "headword": "diarrhea/diarrhoea"
    },
    {
      "headword": "diary"
    },
    {
      "headword": "dictator"
    },
    {
      "headword": "dictionary"
    },
    {
      "headword": "did"
    },
    {
      "headword": "die"
    },
    {
      "headword": "diet"
    },
    {
      "headword": "differ"
    },
    {
      "headword": "difference"
    },
    {
      "headword": "different"
    },
    {
      "headword": "differently"
    },
    {
      "headword": "difficult"
    },
    {
      "headword": "difficulty"
    },
    {
      "headword": "dig"
    },
    {
      "headword": "dig"
    },
    {
      "headword": "digest"
    },
    {
      "headword": "digital"
    },
    {
      "headword": "digital camera"
    },
    {
      "headword": "dignify"
    },
    {
      "headword": "dignity"
    },
    {
      "headword": "dilemma"
    },
    {
      "headword": "diligence"
    },
    {
      "headword": "diligent"
    },
    {
      "headword": "dim"
    },
    {
      "headword": "dime"
    },
    {
      "headword": "dimension"
    },
    {
      "headword": "dining room"
    },
    {
      "headword": "dinner"
    },
    {
      "headword": "dinosaur"
    },
    {
      "headword": "dioxide"
    },
    {
      "headword": "dip"
    },
    {
      "headword": "diphtheria"
    },
    {
      "headword": "diploma"
    },
    {
      "headword": "diplomat"
    },
    {
      "headword": "direct"
    },
    {
      "headword": "direct"
    },
    {
      "headword": "direction"
    },
    {
      "headword": "directly"
    },
    {
      "headword": "director"
    },
    {
      "headword": "dirt"
    },
    {
      "headword": "dirty"
    },
    {
      "headword": "disability"
    },
    {
      "headword": "disable"
    },
    {
      "headword": "disabled"
    },
    {
      "headword": "disadvantage"
    },
    {
      "headword": "disagree"
    },
    {
      "headword": "disagreement"
    },
    {
      "headword": "disappear"
    },
    {
      "headword": "disappearance"
    },
    {
      "headword": "disappoint"
    },
    {
      "headword": "disappointed"
    },
    {
      "headword": "disappointing"
    },
    {
      "headword": "disappointment"
    },
    {
      "headword": "disapproval"
    },
    {
      "headword": "disapprove"
    },
    {
      "headword": "disaster"
    },
    {
      "headword": "disastrous"
    },
    {
      "headword": "disc jockey/disk jockey"
    },
    {
      "headword": "discharge"
    },
    {
      "headword": "disciple"
    },
    {
      "headword": "discipline"
    },
    {
      "headword": "disco"
    },
    {
      "headword": "discomfort"
    },
    {
      "headword": "disconnect"
    },
    {
      "headword": "discount"
    },
    {
      "headword": "discourage"
    },
    {
      "headword": "discover"
    },
    {
      "headword": "discovery"
    },
    {
      "headword": "discredit"
    },
    {
      "headword": "discriminate"
    },
    {
      "headword": "discrimination"
    },
    {
      "headword": "discuss"
    },
    {
      "headword": "discussion"
    },
    {
      "headword": "disease"
    },
    {
      "headword": "disgrace"
    },
    {
      "headword": "disguise"
    },
    {
      "headword": "disguise"
    },
    {
      "headword": "disgusting"
    },
    {
      "headword": "dish"
    },
    {
      "headword": "dishonest"
    },
    {
      "headword": "dishonesty"
    },
    {
      "headword": "dishwasher"
    },
    {
      "headword": "disillusion"
    },
    {
      "headword": "disk/disc"
    },
    {
      "headword": "dislike"
    },
    {
      "headword": "dislike"
    },
    {
      "headword": "dismiss"
    },
    {
      "headword": "disorder"
    },
    {
      "headword": "disorderly"
    },
    {
      "headword": "disorganized/disorganised"
    },
    {
      "headword": "dispensable"
    },
    {
      "headword": "displace"
    },
    {
      "headword": "display"
    },
    {
      "headword": "display"
    },
    {
      "headword": "displeasure"
    },
    {
      "headword": "disposal"
    },
    {
      "headword": "disposition"
    },
    {
      "headword": "dispute"
    },
    {
      "headword": "disqualify"
    },
    {
      "headword": "disregard"
    },
    {
      "headword": "disrupt"
    },
    {
      "headword": "dissatisfaction"
    },
    {
      "headword": "dissatisfied"
    },
    {
      "headword": "dissident"
    },
    {
      "headword": "dissolve"
    },
    {
      "headword": "distance"
    },
    {
      "headword": "distant"
    },
    {
      "headword": "distinction"
    },
    {
      "headword": "distinctly"
    },
    {
      "headword": "distinguish"
    },
    {
      "headword": "distinguished"
    },
    {
      "headword": "distortion"
    },
    {
      "headword": "distract"
    },
    {
      "headword": "distraction"
    },
    {
      "headword": "distressing"
    },
    {
      "headword": "distribute"
    },
    {
      "headword": "distribution"
    },
    {
      "headword": "distributor"
    },
    {
      "headword": "district"
    },
    {
      "headword": "disturb"
    },
    {
      "headword": "disturbance"
    },
    {
      "headword": "dive"
    },
    {
      "headword": "dive"
    },
    {
      "headword": "diver"
    },
    {
      "headword": "diverse"
    },
    {
      "headword": "diversion"
    },
    {
      "headword": "divert"
    },
    {
      "headword": "divide"
    },
    {
      "headword": "divide"
    },
    {
      "headword": "divided"
    },
    {
      "headword": "divine"
    },
    {
      "headword": "diving"
    },
    {
      "headword": "division"
    },
    {
      "headword": "divorce"
    },
    {
      "headword": "divorce"
    },
    {
      "headword": "divorced"
    },
    {
      "headword": "dizzy"
    },
    {
      "headword": "DJ"
    },
    {
      "headword": "DNA"
    },
    {
      "headword": "do"
    },
    {
      "headword": "doc"
    },
    {
      "headword": "dock"
    },
    {
      "headword": "doctor/Dr./Dr"
    },
    {
      "headword": "document"
    },
    {
      "headword": "documentary"
    },
    {
      "headword": "does"
    },
    {
      "headword": "dog"
    },
    {
      "headword": "doing"
    },
    {
      "headword": "doll"
    },
    {
      "headword": "dollar"
    },
    {
      "headword": "dolphin"
    },
    {
      "headword": "domestic"
    },
    {
      "headword": "dominate"
    },
    {
      "headword": "donate"
    },
    {
      "headword": "donation"
    },
    {
      "headword": "done"
    },
    {
      "headword": "donkey"
    },
    {
      "headword": "doom"
    },
    {
      "headword": "door"
    },
    {
      "headword": "doorkeeper"
    },
    {
      "headword": "doorway"
    },
    {
      "headword": "dorm"
    },
    {
      "headword": "dormitory"
    },
    {
      "headword": "dose"
    },
    {
      "headword": "dot"
    },
    {
      "headword": "double"
    },
    {
      "headword": "double"
    },
    {
      "headword": "double"
    },
    {
      "headword": "doubly"
    },
    {
      "headword": "doubt"
    },
    {
      "headword": "doubt"
    },
    {
      "headword": "doubtful"
    },
    {
      "headword": "dove"
    },
    {
      "headword": "down"
    },
    {
      "headword": "down"
    },
    {
      "headword": "down"
    },
    {
      "headword": "downfall"
    },
    {
      "headword": "download"
    },
    {
      "headword": "download"
    },
    {
      "headword": "downsize"
    },
    {
      "headword": "downstairs"
    },
    {
      "headword": "downstairs"
    },
    {
      "headword": "downtown"
    },
    {
      "headword": "downward"
    },
    {
      "headword": "dowry"
    },
    {
      "headword": "doze"
    },
    {
      "headword": "dozen"
    },
    {
      "headword": "dozen"
    },
    {
      "headword": "draft/draught"
    },
    {
      "headword": "drag"
    },
    {
      "headword": "drain"
    },
    {
      "headword": "drain"
    },
    {
      "headword": "drama"
    },
    {
      "headword": "dramatic"
    },
    {
      "headword": "dramatically"
    },
    {
      "headword": "drapery"
    },
    {
      "headword": "draw"
    },
    {
      "headword": "draw"
    },
    {
      "headword": "drawer"
    },
    {
      "headword": "drawing"
    },
    {
      "headword": "dread"
    },
    {
      "headword": "dreadful"
    },
    {
      "headword": "dream"
    },
    {
      "headword": "dream"
    },
    {
      "headword": "dreamy"
    },
    {
      "headword": "dress"
    },
    {
      "headword": "dress"
    },
    {
      "headword": "dressed"
    },
    {
      "headword": "drill"
    },
    {
      "headword": "drink"
    },
    {
      "headword": "drink"
    },
    {
      "headword": "drinkable"
    },
    {
      "headword": "drive"
    },
    {
      "headword": "drive"
    },
    {
      "headword": "driver"
    },
    {
      "headword": "driver's license/driving licence"
    },
    {
      "headword": "droop"
    },
    {
      "headword": "drop"
    },
    {
      "headword": "drop"
    },
    {
      "headword": "dropout"
    },
    {
      "headword": "drought"
    },
    {
      "headword": "drown"
    },
    {
      "headword": "drug"
    },
    {
      "headword": "drugstore"
    },
    {
      "headword": "drum"
    },
    {
      "headword": "drunk"
    },
    {
      "headword": "dry"
    },
    {
      "headword": "dry"
    },
    {
      "headword": "duck"
    },
    {
      "headword": "dude"
    },
    {
      "headword": "due"
    },
    {
      "headword": "duel"
    },
    {
      "headword": "dull"
    },
    {
      "headword": "dumb"
    },
    {
      "headword": "dump"
    },
    {
      "headword": "dump"
    },
    {
      "headword": "duplicate"
    },
    {
      "headword": "duplication"
    },
    {
      "headword": "during"
    },
    {
      "headword": "dust"
    },
    {
      "headword": "dustbin"
    },
    {
      "headword": "dusty"
    },
    {
      "headword": "duty"
    },
    {
      "headword": "duty-free"
    },
    {
      "headword": "duvet"
    },
    {
      "headword": "DVD"
    },
    {
      "headword": "dwarf"
    },
    {
      "headword": "dye"
    },
    {
      "headword": "dynamic"
    },
    {
      "headword": "dynasty"
    },
    {
      "headword": "each"
    },
    {
      "headword": "each"
    },
    {
      "headword": "each other"
    },
    {
      "headword": "eager"
    },
    {
      "headword": "eagerly"
    },
    {
      "headword": "eagerness"
    },
    {
      "headword": "eagle"
    },
    {
      "headword": "ear"
    },
    {
      "headword": "earache"
    },
    {
      "headword": "early"
    },
    {
      "headword": "early"
    },
    {
      "headword": "earn"
    },
    {
      "headword": "earnest"
    },
    {
      "headword": "earnings"
    },
    {
      "headword": "earring"
    },
    {
      "headword": "earth"
    },
    {
      "headword": "earthquake"
    },
    {
      "headword": "ease"
    },
    {
      "headword": "ease"
    },
    {
      "headword": "easily"
    },
    {
      "headword": "east"
    },
    {
      "headword": "east"
    },
    {
      "headword": "east"
    },
    {
      "headword": "eastern"
    },
    {
      "headword": "eastward"
    },
    {
      "headword": "easy"
    },
    {
      "headword": "easygoing/easy-going"
    },
    {
      "headword": "eat"
    },
    {
      "headword": "eco"
    },
    {
      "headword": "ecological"
    },
    {
      "headword": "ecologically"
    },
    {
      "headword": "ecologist"
    },
    {
      "headword": "ecology"
    },
    {
      "headword": "economic"
    },
    {
      "headword": "economical"
    },
    {
      "headword": "economics"
    },
    {
      "headword": "economist"
    },
    {
      "headword": "economy"
    },
    {
      "headword": "ecosystem"
    },
    {
      "headword": "ecstasy"
    },
    {
      "headword": "ecstatic"
    },
    {
      "headword": "edge"
    },
    {
      "headword": "edit"
    },
    {
      "headword": "edit"
    },
    {
      "headword": "edition"
    },
    {
      "headword": "editor"
    },
    {
      "headword": "editorial"
    },
    {
      "headword": "educate"
    },
    {
      "headword": "educated"
    },
    {
      "headword": "education"
    },
    {
      "headword": "educational"
    },
    {
      "headword": "educator"
    },
    {
      "headword": "effect"
    },
    {
      "headword": "effective"
    },
    {
      "headword": "effectively"
    },
    {
      "headword": "effectiveness"
    },
    {
      "headword": "efficiency"
    },
    {
      "headword": "efficient"
    },
    {
      "headword": "effort"
    },
    {
      "headword": "egg"
    },
    {
      "headword": "eight"
    },
    {
      "headword": "eighteen"
    },
    {
      "headword": "eighty"
    },
    {
      "headword": "either"
    },
    {
      "headword": "either"
    },
    {
      "headword": "either"
    },
    {
      "headword": "either"
    },
    {
      "headword": "elbow"
    },
    {
      "headword": "elderly"
    },
    {
      "headword": "elect"
    },
    {
      "headword": "election"
    },
    {
      "headword": "elective"
    },
    {
      "headword": "electric"
    },
    {
      "headword": "electrical"
    },
    {
      "headword": "electrician"
    },
    {
      "headword": "electricity"
    },
    {
      "headword": "electron"
    },
    {
      "headword": "electronic"
    },
    {
      "headword": "electronically"
    },
    {
      "headword": "electronics"
    },
    {
      "headword": "elegance"
    },
    {
      "headword": "elegant"
    },
    {
      "headword": "elegantly"
    },
    {
      "headword": "element"
    },
    {
      "headword": "elemental"
    },
    {
      "headword": "elementary"
    },
    {
      "headword": "elephant"
    },
    {
      "headword": "elevator"
    },
    {
      "headword": "eleven"
    },
    {
      "headword": "eligible"
    },
    {
      "headword": "eliminate"
    },
    {
      "headword": "elite"
    },
    {
      "headword": "eloquence"
    },
    {
      "headword": "eloquent"
    },
    {
      "headword": "else"
    },
    {
      "headword": "elsewhere"
    },
    {
      "headword": "email"
    },
    {
      "headword": "email/e-mail/E-mail"
    },
    {
      "headword": "embarrass"
    },
    {
      "headword": "embarrassed"
    },
    {
      "headword": "embarrassing"
    },
    {
      "headword": "embarrassment"
    },
    {
      "headword": "embassy"
    },
    {
      "headword": "embrace"
    },
    {
      "headword": "emerge"
    },
    {
      "headword": "emergence"
    },
    {
      "headword": "emergency"
    },
    {
      "headword": "emotion"
    },
    {
      "headword": "emotional"
    },
    {
      "headword": "emotionally"
    },
    {
      "headword": "emperor"
    },
    {
      "headword": "emphasis"
    },
    {
      "headword": "emphasize/emphasize"
    },
    {
      "headword": "emphatically"
    },
    {
      "headword": "empire"
    },
    {
      "headword": "employ"
    },
    {
      "headword": "employee"
    },
    {
      "headword": "employer"
    },
    {
      "headword": "employment"
    },
    {
      "headword": "empty"
    },
    {
      "headword": "enable"
    },
    {
      "headword": "enclose"
    },
    {
      "headword": "encounter"
    },
    {
      "headword": "encounter"
    },
    {
      "headword": "encourage"
    },
    {
      "headword": "encouragement"
    },
    {
      "headword": "encouraging"
    },
    {
      "headword": "encyclopedia/encyclopaedia"
    },
    {
      "headword": "end"
    },
    {
      "headword": "end"
    },
    {
      "headword": "endanger"
    },
    {
      "headword": "endangered"
    },
    {
      "headword": "endeavor/endeavour"
    },
    {
      "headword": "ending"
    },
    {
      "headword": "endless"
    },
    {
      "headword": "endlessly"
    },
    {
      "headword": "endorse"
    },
    {
      "headword": "endurance"
    },
    {
      "headword": "endure"
    },
    {
      "headword": "enduring"
    },
    {
      "headword": "enemy"
    },
    {
      "headword": "energetic"
    },
    {
      "headword": "energy"
    },
    {
      "headword": "enforce"
    },
    {
      "headword": "engage"
    },
    {
      "headword": "engaged"
    },
    {
      "headword": "engagement"
    },
    {
      "headword": "engine"
    },
    {
      "headword": "engineer"
    },
    {
      "headword": "engineering"
    },
    {
      "headword": "Englishman"
    },
    {
      "headword": "engulf"
    },
    {
      "headword": "enhance"
    },
    {
      "headword": "enjoy"
    },
    {
      "headword": "enjoyable"
    },
    {
      "headword": "enjoyment"
    },
    {
      "headword": "enormous"
    },
    {
      "headword": "enough"
    },
    {
      "headword": "enough"
    },
    {
      "headword": "enough"
    },
    {
      "headword": "enrich"
    },
    {
      "headword": "enroll/enrol"
    },
    {
      "headword": "ensure"
    },
    {
      "headword": "enter"
    },
    {
      "headword": "enterprise"
    },
    {
      "headword": "entertain"
    },
    {
      "headword": "entertainer"
    },
    {
      "headword": "entertaining"
    },
    {
      "headword": "entertainment"
    },
    {
      "headword": "enthusiasm"
    },
    {
      "headword": "enthusiast"
    },
    {
      "headword": "enthusiastic"
    },
    {
      "headword": "enthusiastically"
    },
    {
      "headword": "entire"
    },
    {
      "headword": "entirely"
    },
    {
      "headword": "entitle"
    },
    {
      "headword": "entrance"
    },
    {
      "headword": "entrepreneur"
    },
    {
      "headword": "entry"
    },
    {
      "headword": "envelope"
    },
    {
      "headword": "environment"
    },
    {
      "headword": "environmental"
    },
    {
      "headword": "environmentalist"
    },
    {
      "headword": "environmentally"
    },
    {
      "headword": "environmentally friendly"
    },
    {
      "headword": "envy"
    },
    {
      "headword": "envy"
    },
    {
      "headword": "episode"
    },
    {
      "headword": "equal"
    },
    {
      "headword": "equal"
    },
    {
      "headword": "equal"
    },
    {
      "headword": "equality"
    },
    {
      "headword": "equally"
    },
    {
      "headword": "equation"
    },
    {
      "headword": "equip"
    },
    {
      "headword": "equipment"
    },
    {
      "headword": "equity"
    },
    {
      "headword": "era"
    },
    {
      "headword": "erect"
    },
    {
      "headword": "error"
    },
    {
      "headword": "erupt"
    },
    {
      "headword": "eruption"
    },
    {
      "headword": "escalator"
    },
    {
      "headword": "escape"
    },
    {
      "headword": "escape"
    },
    {
      "headword": "especially"
    },
    {
      "headword": "essay"
    },
    {
      "headword": "essayist"
    },
    {
      "headword": "essence"
    },
    {
      "headword": "essential"
    },
    {
      "headword": "essentially"
    },
    {
      "headword": "establish"
    },
    {
      "headword": "establishment"
    },
    {
      "headword": "estate"
    },
    {
      "headword": "estimate"
    },
    {
      "headword": "estimate"
    },
    {
      "headword": "estimated"
    },
    {
      "headword": "eternal"
    },
    {
      "headword": "eternally"
    },
    {
      "headword": "eternity"
    },
    {
      "headword": "ethic"
    },
    {
      "headword": "ethnic"
    },
    {
      "headword": "euro"
    },
    {
      "headword": "evacuate"
    },
    {
      "headword": "evacuation"
    },
    {
      "headword": "evaluate"
    },
    {
      "headword": "evaluation"
    },
    {
      "headword": "even"
    },
    {
      "headword": "even"
    },
    {
      "headword": "evening"
    },
    {
      "headword": "evenly"
    },
    {
      "headword": "event"
    },
    {
      "headword": "eventually"
    },
    {
      "headword": "ever"
    },
    {
      "headword": "everlasting"
    },
    {
      "headword": "every"
    },
    {
      "headword": "everybody"
    },
    {
      "headword": "everyday"
    },
    {
      "headword": "everyone"
    },
    {
      "headword": "everything"
    },
    {
      "headword": "everywhere"
    },
    {
      "headword": "evidence"
    },
    {
      "headword": "evident"
    },
    {
      "headword": "evidently"
    },
    {
      "headword": "evil"
    },
    {
      "headword": "evil"
    },
    {
      "headword": "evolution"
    },
    {
      "headword": "evolve"
    },
    {
      "headword": "exact"
    },
    {
      "headword": "exactly"
    },
    {
      "headword": "exactness"
    },
    {
      "headword": "exaggerate"
    },
    {
      "headword": "exaggeration"
    },
    {
      "headword": "exalt"
    },
    {
      "headword": "exam"
    },
    {
      "headword": "examination"
    },
    {
      "headword": "examine"
    },
    {
      "headword": "examinee"
    },
    {
      "headword": "examiner"
    },
    {
      "headword": "example"
    },
    {
      "headword": "exceed"
    },
    {
      "headword": "excel"
    },
    {
      "headword": "excellence"
    },
    {
      "headword": "excellent"
    },
    {
      "headword": "except"
    },
    {
      "headword": "except"
    },
    {
      "headword": "exception"
    },
    {
      "headword": "exceptional"
    },
    {
      "headword": "exceptionally"
    },
    {
      "headword": "excess"
    },
    {
      "headword": "excessive"
    },
    {
      "headword": "exchange"
    },
    {
      "headword": "exchange"
    },
    {
      "headword": "exchange rate"
    },
    {
      "headword": "excited"
    },
    {
      "headword": "excitedly"
    },
    {
      "headword": "excitement"
    },
    {
      "headword": "exciting"
    },
    {
      "headword": "exclaim"
    },
    {
      "headword": "exclamation mark"
    },
    {
      "headword": "exclude"
    },
    {
      "headword": "exclusion"
    },
    {
      "headword": "exclusive"
    },
    {
      "headword": "exclusively"
    },
    {
      "headword": "excursion"
    },
    {
      "headword": "excuse"
    },
    {
      "headword": "excuse"
    },
    {
      "headword": "execute"
    },
    {
      "headword": "execution"
    },
    {
      "headword": "executive"
    },
    {
      "headword": "executive"
    },
    {
      "headword": "exercise"
    },
    {
      "headword": "exercise"
    },
    {
      "headword": "exhaust"
    },
    {
      "headword": "exhausted"
    },
    {
      "headword": "exhausting"
    },
    {
      "headword": "exhaustion"
    },
    {
      "headword": "exhibit"
    },
    {
      "headword": "exhibition"
    },
    {
      "headword": "exile"
    },
    {
      "headword": "exist"
    },
    {
      "headword": "existence"
    },
    {
      "headword": "existing"
    },
    {
      "headword": "exit"
    },
    {
      "headword": "exit"
    },
    {
      "headword": "exotic"
    },
    {
      "headword": "expand"
    },
    {
      "headword": "expansion"
    },
    {
      "headword": "expect"
    },
    {
      "headword": "expectation"
    },
    {
      "headword": "expected"
    },
    {
      "headword": "expedition"
    },
    {
      "headword": "expense"
    },
    {
      "headword": "expensive"
    },
    {
      "headword": "experience"
    },
    {
      "headword": "experience"
    },
    {
      "headword": "experienced"
    },
    {
      "headword": "experiment"
    },
    {
      "headword": "experiment"
    },
    {
      "headword": "expert"
    },
    {
      "headword": "expert"
    },
    {
      "headword": "explain"
    },
    {
      "headword": "explanation"
    },
    {
      "headword": "explode"
    },
    {
      "headword": "exploit"
    },
    {
      "headword": "exploration"
    },
    {
      "headword": "explore"
    },
    {
      "headword": "explorer"
    },
    {
      "headword": "explosion"
    },
    {
      "headword": "explosive"
    },
    {
      "headword": "explosive"
    },
    {
      "headword": "export"
    },
    {
      "headword": "export"
    },
    {
      "headword": "expose"
    },
    {
      "headword": "express"
    },
    {
      "headword": "express"
    },
    {
      "headword": "expression"
    },
    {
      "headword": "expressive"
    },
    {
      "headword": "exquisite"
    },
    {
      "headword": "extend"
    },
    {
      "headword": "extension"
    },
    {
      "headword": "extensive"
    },
    {
      "headword": "extensively"
    },
    {
      "headword": "extent"
    },
    {
      "headword": "external"
    },
    {
      "headword": "extinct"
    },
    {
      "headword": "extinction"
    },
    {
      "headword": "extra"
    },
    {
      "headword": "extra"
    },
    {
      "headword": "extra"
    },
    {
      "headword": "extract"
    },
    {
      "headword": "extract"
    },
    {
      "headword": "extraordinarily"
    },
    {
      "headword": "extraordinary"
    },
    {
      "headword": "extreme"
    },
    {
      "headword": "extreme sports"
    },
    {
      "headword": "extremely"
    },
    {
      "headword": "exultant"
    },
    {
      "headword": "eye"
    },
    {
      "headword": "eyebrow"
    },
    {
      "headword": "eyelash"
    },
    {
      "headword": "eyelid"
    },
    {
      "headword": "eyesight"
    },
    {
      "headword": "fabric"
    },
    {
      "headword": "fabulous"
    },
    {
      "headword": "face"
    },
    {
      "headword": "face"
    },
    {
      "headword": "face to face"
    },
    {
      "headword": "face-to-face"
    },
    {
      "headword": "facilitate"
    },
    {
      "headword": "facilities"
    },
    {
      "headword": "facility"
    },
    {
      "headword": "fact"
    },
    {
      "headword": "factor"
    },
    {
      "headword": "factory"
    },
    {
      "headword": "faculty"
    },
    {
      "headword": "fade"
    },
    {
      "headword": "fail"
    },
    {
      "headword": "failure"
    },
    {
      "headword": "faint"
    },
    {
      "headword": "faint"
    },
    {
      "headword": "fair"
    },
    {
      "headword": "fair"
    },
    {
      "headword": "fairly"
    },
    {
      "headword": "fairy"
    },
    {
      "headword": "faith"
    },
    {
      "headword": "faithful"
    },
    {
      "headword": "fake"
    },
    {
      "headword": "fall"
    },
    {
      "headword": "fall"
    },
    {
      "headword": "fallen"
    },
    {
      "headword": "FALSE"
    },
    {
      "headword": "falter"
    },
    {
      "headword": "fame"
    },
    {
      "headword": "familiar"
    },
    {
      "headword": "familiarize/familiarise"
    },
    {
      "headword": "family"
    },
    {
      "headword": "famous"
    },
    {
      "headword": "fan"
    },
    {
      "headword": "fancy"
    },
    {
      "headword": "fancy"
    },
    {
      "headword": "fancy"
    },
    {
      "headword": "fantastic"
    },
    {
      "headword": "fantastically"
    },
    {
      "headword": "fantasy"
    },
    {
      "headword": "far"
    },
    {
      "headword": "far"
    },
    {
      "headword": "faraway"
    },
    {
      "headword": "fare"
    },
    {
      "headword": "farewell"
    },
    {
      "headword": "farm"
    },
    {
      "headword": "farmer"
    },
    {
      "headword": "farming"
    },
    {
      "headword": "farmland"
    },
    {
      "headword": "farther"
    },
    {
      "headword": "farthest"
    },
    {
      "headword": "fascinate"
    },
    {
      "headword": "fascinated"
    },
    {
      "headword": "fascinating"
    },
    {
      "headword": "fascination"
    },
    {
      "headword": "fashion"
    },
    {
      "headword": "fashionable"
    },
    {
      "headword": "fast"
    },
    {
      "headword": "fast"
    },
    {
      "headword": "fast food"
    },
    {
      "headword": "fasten"
    },
    {
      "headword": "fat"
    },
    {
      "headword": "fat"
    },
    {
      "headword": "fatal"
    },
    {
      "headword": "fate"
    },
    {
      "headword": "father"
    },
    {
      "headword": "father-in-law"
    },
    {
      "headword": "fault"
    },
    {
      "headword": "faulty"
    },
    {
      "headword": "favor/favour"
    },
    {
      "headword": "favorable/favourable"
    },
    {
      "headword": "favorite/favourite"
    },
    {
      "headword": "favorite/favourite"
    },
    {
      "headword": "fax"
    },
    {
      "headword": "fax"
    },
    {
      "headword": "fear"
    },
    {
      "headword": "fear"
    },
    {
      "headword": "fearsome"
    },
    {
      "headword": "feast"
    },
    {
      "headword": "feat"
    },
    {
      "headword": "feather"
    },
    {
      "headword": "feature"
    },
    {
      "headword": "feature"
    },
    {
      "headword": "February"
    },
    {
      "headword": "fed up"
    },
    {
      "headword": "federal"
    },
    {
      "headword": "fee"
    },
    {
      "headword": "feed"
    },
    {
      "headword": "feed"
    },
    {
      "headword": "feedback"
    },
    {
      "headword": "feel"
    },
    {
      "headword": "feel"
    },
    {
      "headword": "feeling"
    },
    {
      "headword": "fellow"
    },
    {
      "headword": "fellow"
    },
    {
      "headword": "female"
    },
    {
      "headword": "female"
    },
    {
      "headword": "fence"
    },
    {
      "headword": "ferry"
    },
    {
      "headword": "ferryboat"
    },
    {
      "headword": "festival"
    },
    {
      "headword": "festive"
    },
    {
      "headword": "fetch"
    },
    {
      "headword": "fever"
    },
    {
      "headword": "feverishly"
    },
    {
      "headword": "few"
    },
    {
      "headword": "few"
    },
    {
      "headword": "fiber/fibre"
    },
    {
      "headword": "fiction"
    },
    {
      "headword": "fictional"
    },
    {
      "headword": "field"
    },
    {
      "headword": "fierce"
    },
    {
      "headword": "fifteen"
    },
    {
      "headword": "fifth"
    },
    {
      "headword": "fifty"
    },
    {
      "headword": "fight"
    },
    {
      "headword": "fight"
    },
    {
      "headword": "fighter"
    },
    {
      "headword": "fighting"
    },
    {
      "headword": "figurative"
    },
    {
      "headword": "figure"
    },
    {
      "headword": "figure"
    },
    {
      "headword": "file"
    },
    {
      "headword": "file"
    },
    {
      "headword": "filial"
    },
    {
      "headword": "fill"
    },
    {
      "headword": "filling"
    },
    {
      "headword": "film"
    },
    {
      "headword": "film"
    },
    {
      "headword": "film-maker"
    },
    {
      "headword": "filter"
    },
    {
      "headword": "final"
    },
    {
      "headword": "final"
    },
    {
      "headword": "finally"
    },
    {
      "headword": "finance"
    },
    {
      "headword": "finance"
    },
    {
      "headword": "financial"
    },
    {
      "headword": "financially"
    },
    {
      "headword": "find"
    },
    {
      "headword": "finding"
    },
    {
      "headword": "fine"
    },
    {
      "headword": "fine"
    },
    {
      "headword": "fine"
    },
    {
      "headword": "fine"
    },
    {
      "headword": "finely"
    },
    {
      "headword": "finger"
    },
    {
      "headword": "fingernail"
    },
    {
      "headword": "finish"
    },
    {
      "headword": "finish"
    },
    {
      "headword": "fire"
    },
    {
      "headword": "fire"
    },
    {
      "headword": "fire brigade"
    },
    {
      "headword": "fire station"
    },
    {
      "headword": "firearm"
    },
    {
      "headword": "firefighter"
    },
    {
      "headword": "fireplace"
    },
    {
      "headword": "firework"
    },
    {
      "headword": "firm"
    },
    {
      "headword": "firm"
    },
    {
      "headword": "firmly"
    },
    {
      "headword": "firmness"
    },
    {
      "headword": "first"
    },
    {
      "headword": "first"
    },
    {
      "headword": "first floor"
    },
    {
      "headword": "first lady"
    },
    {
      "headword": "first language"
    },
    {
      "headword": "first name"
    },
    {
      "headword": "first person"
    },
    {
      "headword": "first-floor"
    },
    {
      "headword": "firstly"
    },
    {
      "headword": "fiscal"
    },
    {
      "headword": "fish"
    },
    {
      "headword": "fish"
    },
    {
      "headword": "fisherman"
    },
    {
      "headword": "fishing"
    },
    {
      "headword": "fit"
    },
    {
      "headword": "fit"
    },
    {
      "headword": "fit"
    },
    {
      "headword": "fitness"
    },
    {
      "headword": "five"
    },
    {
      "headword": "fix"
    },
    {
      "headword": "fix"
    },
    {
      "headword": "fixed"
    },
    {
      "headword": "flag"
    },
    {
      "headword": "flame"
    },
    {
      "headword": "flap"
    },
    {
      "headword": "flash"
    },
    {
      "headword": "flash"
    },
    {
      "headword": "flash"
    },
    {
      "headword": "flat"
    },
    {
      "headword": "flat"
    },
    {
      "headword": "flat"
    },
    {
      "headword": "flavor/flavour"
    },
    {
      "headword": "flaw"
    },
    {
      "headword": "flawless"
    },
    {
      "headword": "flax"
    },
    {
      "headword": "flea"
    },
    {
      "headword": "flee"
    },
    {
      "headword": "fleet"
    },
    {
      "headword": "flesh"
    },
    {
      "headword": "flexibility"
    },
    {
      "headword": "flexible"
    },
    {
      "headword": "flexibly"
    },
    {
      "headword": "flight"
    },
    {
      "headword": "flip"
    },
    {
      "headword": "float"
    },
    {
      "headword": "float"
    },
    {
      "headword": "flock"
    },
    {
      "headword": "flood"
    },
    {
      "headword": "flood"
    },
    {
      "headword": "floor"
    },
    {
      "headword": "flour"
    },
    {
      "headword": "flow"
    },
    {
      "headword": "flow"
    },
    {
      "headword": "flower"
    },
    {
      "headword": "flu"
    },
    {
      "headword": "fluency"
    },
    {
      "headword": "fluent"
    },
    {
      "headword": "fluently"
    },
    {
      "headword": "fluid"
    },
    {
      "headword": "flunk"
    },
    {
      "headword": "flute"
    },
    {
      "headword": "flutter"
    },
    {
      "headword": "fly"
    },
    {
      "headword": "fly"
    },
    {
      "headword": "focus"
    },
    {
      "headword": "focus"
    },
    {
      "headword": "fog"
    },
    {
      "headword": "foggy"
    },
    {
      "headword": "fold"
    },
    {
      "headword": "fold"
    },
    {
      "headword": "folder"
    },
    {
      "headword": "folk"
    },
    {
      "headword": "follow"
    },
    {
      "headword": "follower"
    },
    {
      "headword": "following"
    },
    {
      "headword": "following"
    },
    {
      "headword": "folly"
    },
    {
      "headword": "fond"
    },
    {
      "headword": "fondly"
    },
    {
      "headword": "fondness"
    },
    {
      "headword": "food"
    },
    {
      "headword": "fool"
    },
    {
      "headword": "fool"
    },
    {
      "headword": "foolish"
    },
    {
      "headword": "foolishly"
    },
    {
      "headword": "foot"
    },
    {
      "headword": "football"
    },
    {
      "headword": "footballer"
    },
    {
      "headword": "footnote"
    },
    {
      "headword": "for"
    },
    {
      "headword": "for"
    },
    {
      "headword": "forbid"
    },
    {
      "headword": "forbidden"
    },
    {
      "headword": "force"
    },
    {
      "headword": "force"
    },
    {
      "headword": "forcefully"
    },
    {
      "headword": "forecast"
    },
    {
      "headword": "forehead"
    },
    {
      "headword": "foreign"
    },
    {
      "headword": "foreigner"
    },
    {
      "headword": "foreman"
    },
    {
      "headword": "foresee"
    },
    {
      "headword": "forest"
    },
    {
      "headword": "forestry"
    },
    {
      "headword": "forever"
    },
    {
      "headword": "forget"
    },
    {
      "headword": "forgive"
    },
    {
      "headword": "fork"
    },
    {
      "headword": "form"
    },
    {
      "headword": "form"
    },
    {
      "headword": "formal"
    },
    {
      "headword": "formally"
    },
    {
      "headword": "format"
    },
    {
      "headword": "format"
    },
    {
      "headword": "formation"
    },
    {
      "headword": "former"
    },
    {
      "headword": "formerly"
    },
    {
      "headword": "formidable"
    },
    {
      "headword": "formula"
    },
    {
      "headword": "forth"
    },
    {
      "headword": "forthcoming"
    },
    {
      "headword": "fortnight"
    },
    {
      "headword": "fortunate"
    },
    {
      "headword": "fortunately"
    },
    {
      "headword": "fortune"
    },
    {
      "headword": "forty"
    },
    {
      "headword": "forward"
    },
    {
      "headword": "foul"
    },
    {
      "headword": "found"
    },
    {
      "headword": "foundation"
    },
    {
      "headword": "fountain"
    },
    {
      "headword": "four"
    },
    {
      "headword": "fourteen"
    },
    {
      "headword": "fox"
    },
    {
      "headword": "fragment"
    },
    {
      "headword": "fragrance"
    },
    {
      "headword": "frame"
    },
    {
      "headword": "frame"
    },
    {
      "headword": "frank"
    },
    {
      "headword": "frankly"
    },
    {
      "headword": "frantically"
    },
    {
      "headword": "fraud"
    },
    {
      "headword": "freak"
    },
    {
      "headword": "free"
    },
    {
      "headword": "free"
    },
    {
      "headword": "free"
    },
    {
      "headword": "freedom"
    },
    {
      "headword": "freely"
    },
    {
      "headword": "freeze"
    },
    {
      "headword": "freezer"
    },
    {
      "headword": "freezing"
    },
    {
      "headword": "frequency"
    },
    {
      "headword": "frequent"
    },
    {
      "headword": "frequently"
    },
    {
      "headword": "fresh"
    },
    {
      "headword": "freshman"
    },
    {
      "headword": "Friday"
    },
    {
      "headword": "fridge"
    },
    {
      "headword": "fried"
    },
    {
      "headword": "friend"
    },
    {
      "headword": "friendliness"
    },
    {
      "headword": "friendly"
    },
    {
      "headword": "friendship"
    },
    {
      "headword": "frigate"
    },
    {
      "headword": "fright"
    },
    {
      "headword": "frighten"
    },
    {
      "headword": "frightened"
    },
    {
      "headword": "frightening"
    },
    {
      "headword": "frog"
    },
    {
      "headword": "from"
    },
    {
      "headword": "front"
    },
    {
      "headword": "front"
    },
    {
      "headword": "frontier"
    },
    {
      "headword": "frost"
    },
    {
      "headword": "frozen"
    },
    {
      "headword": "frugal"
    },
    {
      "headword": "fruit"
    },
    {
      "headword": "frustrated"
    },
    {
      "headword": "frustration"
    },
    {
      "headword": "fry"
    },
    {
      "headword": "fry"
    },
    {
      "headword": "frying pan"
    },
    {
      "headword": "fuel"
    },
    {
      "headword": "fulfill/fulfil"
    },
    {
      "headword": "full"
    },
    {
      "headword": "full stop"
    },
    {
      "headword": "full-time"
    },
    {
      "headword": "full-time"
    },
    {
      "headword": "fully"
    },
    {
      "headword": "fume"
    },
    {
      "headword": "fun"
    },
    {
      "headword": "fun"
    },
    {
      "headword": "function"
    },
    {
      "headword": "function"
    },
    {
      "headword": "functional"
    },
    {
      "headword": "functionality"
    },
    {
      "headword": "fund"
    },
    {
      "headword": "fund"
    },
    {
      "headword": "fundamental"
    },
    {
      "headword": "funeral"
    },
    {
      "headword": "funk"
    },
    {
      "headword": "funky"
    },
    {
      "headword": "funny"
    },
    {
      "headword": "fur"
    },
    {
      "headword": "furious"
    },
    {
      "headword": "furiously"
    },
    {
      "headword": "furnish"
    },
    {
      "headword": "furniture"
    },
    {
      "headword": "furor/furore"
    },
    {
      "headword": "further"
    },
    {
      "headword": "further"
    },
    {
      "headword": "furthermore"
    },
    {
      "headword": "furthest"
    },
    {
      "headword": "fuss"
    },
    {
      "headword": "future"
    },
    {
      "headword": "future"
    },
    {
      "headword": "gaiety"
    },
    {
      "headword": "gain"
    },
    {
      "headword": "gain"
    },
    {
      "headword": "gall"
    },
    {
      "headword": "gallery"
    },
    {
      "headword": "gallon"
    },
    {
      "headword": "gambling"
    },
    {
      "headword": "game"
    },
    {
      "headword": "gang"
    },
    {
      "headword": "gangster"
    },
    {
      "headword": "gap"
    },
    {
      "headword": "garage"
    },
    {
      "headword": "garbage"
    },
    {
      "headword": "garden"
    },
    {
      "headword": "gardener"
    },
    {
      "headword": "gardening"
    },
    {
      "headword": "garlic"
    },
    {
      "headword": "garment"
    },
    {
      "headword": "gas"
    },
    {
      "headword": "gasp"
    },
    {
      "headword": "gate"
    },
    {
      "headword": "gateway"
    },
    {
      "headword": "gather"
    },
    {
      "headword": "gaudy"
    },
    {
      "headword": "gay"
    },
    {
      "headword": "gaze"
    },
    {
      "headword": "gear"
    },
    {
      "headword": "gee"
    },
    {
      "headword": "gender"
    },
    {
      "headword": "gene"
    },
    {
      "headword": "general"
    },
    {
      "headword": "general"
    },
    {
      "headword": "generalization/generalisation"
    },
    {
      "headword": "generalize/generalise"
    },
    {
      "headword": "generally"
    },
    {
      "headword": "generate"
    },
    {
      "headword": "generation"
    },
    {
      "headword": "generosity"
    },
    {
      "headword": "generous"
    },
    {
      "headword": "generously"
    },
    {
      "headword": "genetic"
    },
    {
      "headword": "genetically"
    },
    {
      "headword": "genetics"
    },
    {
      "headword": "genius"
    },
    {
      "headword": "genre"
    },
    {
      "headword": "gentle"
    },
    {
      "headword": "gentleman"
    },
    {
      "headword": "gently"
    },
    {
      "headword": "genuine"
    },
    {
      "headword": "genuinely"
    },
    {
      "headword": "geographic"
    },
    {
      "headword": "geographical"
    },
    {
      "headword": "geography"
    },
    {
      "headword": "geology"
    },
    {
      "headword": "germ"
    },
    {
      "headword": "gesture"
    },
    {
      "headword": "get"
    },
    {
      "headword": "getaway"
    },
    {
      "headword": "ghetto"
    },
    {
      "headword": "ghost"
    },
    {
      "headword": "giant"
    },
    {
      "headword": "gift"
    },
    {
      "headword": "gifted"
    },
    {
      "headword": "giggle"
    },
    {
      "headword": "ginger"
    },
    {
      "headword": "giraffe"
    },
    {
      "headword": "girl"
    },
    {
      "headword": "girlfriend"
    },
    {
      "headword": "give"
    },
    {
      "headword": "giveaway"
    },
    {
      "headword": "given"
    },
    {
      "headword": "glacis"
    },
    {
      "headword": "glad"
    },
    {
      "headword": "glamorous/glamourous"
    },
    {
      "headword": "glance"
    },
    {
      "headword": "glance"
    },
    {
      "headword": "glare"
    },
    {
      "headword": "glass"
    },
    {
      "headword": "glasses"
    },
    {
      "headword": "gleam"
    },
    {
      "headword": "glee"
    },
    {
      "headword": "glide"
    },
    {
      "headword": "glimpse"
    },
    {
      "headword": "glint"
    },
    {
      "headword": "global"
    },
    {
      "headword": "global warming"
    },
    {
      "headword": "globally"
    },
    {
      "headword": "globe"
    },
    {
      "headword": "glocal"
    },
    {
      "headword": "gloomy"
    },
    {
      "headword": "glorify"
    },
    {
      "headword": "glorious"
    },
    {
      "headword": "glory"
    },
    {
      "headword": "glove"
    },
    {
      "headword": "glow"
    },
    {
      "headword": "go"
    },
    {
      "headword": "go"
    },
    {
      "headword": "goal"
    },
    {
      "headword": "goalkeeper"
    },
    {
      "headword": "goat"
    },
    {
      "headword": "god"
    },
    {
      "headword": "goddess"
    },
    {
      "headword": "godly"
    },
    {
      "headword": "gold"
    },
    {
      "headword": "gold"
    },
    {
      "headword": "golden"
    },
    {
      "headword": "golf"
    },
    {
      "headword": "golfer"
    },
    {
      "headword": "good"
    },
    {
      "headword": "good"
    },
    {
      "headword": "good afternoon"
    },
    {
      "headword": "good morning"
    },
    {
      "headword": "good night"
    },
    {
      "headword": "good-looking"
    },
    {
      "headword": "goodness"
    },
    {
      "headword": "goods"
    },
    {
      "headword": "goodwill"
    },
    {
      "headword": "gook"
    },
    {
      "headword": "gorge"
    },
    {
      "headword": "gorgeous"
    },
    {
      "headword": "gorilla"
    },
    {
      "headword": "gossip"
    },
    {
      "headword": "gossip"
    },
    {
      "headword": "govern"
    },
    {
      "headword": "government"
    },
    {
      "headword": "governmental"
    },
    {
      "headword": "governor"
    },
    {
      "headword": "gown"
    },
    {
      "headword": "grab"
    },
    {
      "headword": "grace"
    },
    {
      "headword": "graceful"
    },
    {
      "headword": "gracefulness"
    },
    {
      "headword": "grade"
    },
    {
      "headword": "grade"
    },
    {
      "headword": "gradual"
    },
    {
      "headword": "gradually"
    },
    {
      "headword": "graduate"
    },
    {
      "headword": "graduate"
    },
    {
      "headword": "graduation"
    },
    {
      "headword": "grain"
    },
    {
      "headword": "gram/gramme"
    },
    {
      "headword": "grammar"
    },
    {
      "headword": "grand"
    },
    {
      "headword": "grandchild"
    },
    {
      "headword": "granddad"
    },
    {
      "headword": "granddaughter"
    },
    {
      "headword": "grandfather"
    },
    {
      "headword": "grandma"
    },
    {
      "headword": "grandmother"
    },
    {
      "headword": "grandpa"
    },
    {
      "headword": "grandparent"
    },
    {
      "headword": "grandson"
    },
    {
      "headword": "granny"
    },
    {
      "headword": "grant"
    },
    {
      "headword": "grant"
    },
    {
      "headword": "grape"
    },
    {
      "headword": "graph"
    },
    {
      "headword": "graphic"
    },
    {
      "headword": "graphically"
    },
    {
      "headword": "graphics"
    },
    {
      "headword": "grasp"
    },
    {
      "headword": "grass"
    },
    {
      "headword": "grateful"
    },
    {
      "headword": "gratitude"
    },
    {
      "headword": "grave"
    },
    {
      "headword": "gravestone"
    },
    {
      "headword": "gravitation"
    },
    {
      "headword": "gravy"
    },
    {
      "headword": "gray/grey"
    },
    {
      "headword": "gray/grey"
    },
    {
      "headword": "great"
    },
    {
      "headword": "greatly"
    },
    {
      "headword": "greatness"
    },
    {
      "headword": "greedy"
    },
    {
      "headword": "green"
    },
    {
      "headword": "green"
    },
    {
      "headword": "greenhouse"
    },
    {
      "headword": "greet"
    },
    {
      "headword": "greeting"
    },
    {
      "headword": "grief"
    },
    {
      "headword": "grieve"
    },
    {
      "headword": "grill"
    },
    {
      "headword": "grill"
    },
    {
      "headword": "grilled"
    },
    {
      "headword": "grim"
    },
    {
      "headword": "grin"
    },
    {
      "headword": "grip"
    },
    {
      "headword": "grip"
    },
    {
      "headword": "grocery store"
    },
    {
      "headword": "groom"
    },
    {
      "headword": "gross"
    },
    {
      "headword": "ground"
    },
    {
      "headword": "ground floor"
    },
    {
      "headword": "group"
    },
    {
      "headword": "group"
    },
    {
      "headword": "grouping"
    },
    {
      "headword": "grow"
    },
    {
      "headword": "growing"
    },
    {
      "headword": "grown-up"
    },
    {
      "headword": "grown-up"
    },
    {
      "headword": "growth"
    },
    {
      "headword": "guarantee"
    },
    {
      "headword": "guarantee"
    },
    {
      "headword": "guard"
    },
    {
      "headword": "guard"
    },
    {
      "headword": "guerrilla"
    },
    {
      "headword": "guess"
    },
    {
      "headword": "guess"
    },
    {
      "headword": "guest"
    },
    {
      "headword": "guidance"
    },
    {
      "headword": "guide"
    },
    {
      "headword": "guide"
    },
    {
      "headword": "guidebook"
    },
    {
      "headword": "guideline"
    },
    {
      "headword": "guilt"
    },
    {
      "headword": "guilty"
    },
    {
      "headword": "guitar"
    },
    {
      "headword": "guitarist"
    },
    {
      "headword": "gulp"
    },
    {
      "headword": "gum"
    },
    {
      "headword": "gun"
    },
    {
      "headword": "gunshot"
    },
    {
      "headword": "guts"
    },
    {
      "headword": "guy"
    },
    {
      "headword": "gym"
    },
    {
      "headword": "gymnastic"
    },
    {
      "headword": "gymnastics"
    },
    {
      "headword": "habit"
    },
    {
      "headword": "habitant"
    },
    {
      "headword": "habitat"
    },
    {
      "headword": "had"
    },
    {
      "headword": "hail"
    },
    {
      "headword": "hair"
    },
    {
      "headword": "haircut"
    },
    {
      "headword": "hairdresser"
    },
    {
      "headword": "hairdryer"
    },
    {
      "headword": "hairy"
    },
    {
      "headword": "half"
    },
    {
      "headword": "half"
    },
    {
      "headword": "half"
    },
    {
      "headword": "half"
    },
    {
      "headword": "half-price"
    },
    {
      "headword": "half-price"
    },
    {
      "headword": "hall"
    },
    {
      "headword": "ham"
    },
    {
      "headword": "hamburger"
    },
    {
      "headword": "hammer"
    },
    {
      "headword": "hammer"
    },
    {
      "headword": "hand"
    },
    {
      "headword": "hand"
    },
    {
      "headword": "handbag"
    },
    {
      "headword": "handball"
    },
    {
      "headword": "hand-held"
    },
    {
      "headword": "handicap"
    },
    {
      "headword": "handicapped"
    },
    {
      "headword": "handicraft"
    },
    {
      "headword": "handkerchief"
    },
    {
      "headword": "handle"
    },
    {
      "headword": "handle"
    },
    {
      "headword": "handout"
    },
    {
      "headword": "handrail"
    },
    {
      "headword": "handshake"
    },
    {
      "headword": "handsome"
    },
    {
      "headword": "handwriting"
    },
    {
      "headword": "handy"
    },
    {
      "headword": "hang"
    },
    {
      "headword": "hang"
    },
    {
      "headword": "hanging"
    },
    {
      "headword": "happen"
    },
    {
      "headword": "happily"
    },
    {
      "headword": "happiness"
    },
    {
      "headword": "happy"
    },
    {
      "headword": "harbor/harbour"
    },
    {
      "headword": "hard"
    },
    {
      "headword": "hard"
    },
    {
      "headword": "hard drive"
    },
    {
      "headword": "hardly"
    },
    {
      "headword": "hardship"
    },
    {
      "headword": "hardware"
    },
    {
      "headword": "hard-working"
    },
    {
      "headword": "harm"
    },
    {
      "headword": "harm"
    },
    {
      "headword": "harmful"
    },
    {
      "headword": "harmless"
    },
    {
      "headword": "harmony"
    },
    {
      "headword": "harness"
    },
    {
      "headword": "harrow"
    },
    {
      "headword": "harvest"
    },
    {
      "headword": "has"
    },
    {
      "headword": "haste"
    },
    {
      "headword": "hastily"
    },
    {
      "headword": "hasty"
    },
    {
      "headword": "hat"
    },
    {
      "headword": "hatch"
    },
    {
      "headword": "hatching"
    },
    {
      "headword": "hate"
    },
    {
      "headword": "hate"
    },
    {
      "headword": "hatred"
    },
    {
      "headword": "haunt"
    },
    {
      "headword": "haunt"
    },
    {
      "headword": "haunting"
    },
    {
      "headword": "have"
    },
    {
      "headword": "have to"
    },
    {
      "headword": "haven"
    },
    {
      "headword": "hay"
    },
    {
      "headword": "hazard"
    },
    {
      "headword": "hazardous"
    },
    {
      "headword": "he"
    },
    {
      "headword": "head"
    },
    {
      "headword": "head"
    },
    {
      "headword": "headache"
    },
    {
      "headword": "headline"
    },
    {
      "headword": "headphone"
    },
    {
      "headword": "headquarters"
    },
    {
      "headword": "headteacher"
    },
    {
      "headword": "heal"
    },
    {
      "headword": "healing"
    },
    {
      "headword": "health"
    },
    {
      "headword": "health care"
    },
    {
      "headword": "healthy"
    },
    {
      "headword": "heap"
    },
    {
      "headword": "heap"
    },
    {
      "headword": "hear"
    },
    {
      "headword": "hearing"
    },
    {
      "headword": "heart"
    },
    {
      "headword": "heart attack"
    },
    {
      "headword": "heartbreaking"
    },
    {
      "headword": "hearted"
    },
    {
      "headword": "heartwarming/heart-warming"
    },
    {
      "headword": "hearty"
    },
    {
      "headword": "heat"
    },
    {
      "headword": "heat"
    },
    {
      "headword": "heater"
    },
    {
      "headword": "heating"
    },
    {
      "headword": "heaven"
    },
    {
      "headword": "heavenly"
    },
    {
      "headword": "heavily"
    },
    {
      "headword": "heavy"
    },
    {
      "headword": "hedge"
    },
    {
      "headword": "heel"
    },
    {
      "headword": "height"
    },
    {
      "headword": "helicopter"
    },
    {
      "headword": "hell"
    },
    {
      "headword": "hello"
    },
    {
      "headword": "helmet"
    },
    {
      "headword": "help"
    },
    {
      "headword": "help"
    },
    {
      "headword": "helper"
    },
    {
      "headword": "helpful"
    },
    {
      "headword": "helpless"
    },
    {
      "headword": "hemp"
    },
    {
      "headword": "her"
    },
    {
      "headword": "her"
    },
    {
      "headword": "herb"
    },
    {
      "headword": "herd"
    },
    {
      "headword": "here"
    },
    {
      "headword": "heritage"
    },
    {
      "headword": "hero"
    },
    {
      "headword": "hers"
    },
    {
      "headword": "herself"
    },
    {
      "headword": "hesitate"
    },
    {
      "headword": "hesitation"
    },
    {
      "headword": "hey"
    },
    {
      "headword": "hi"
    },
    {
      "headword": "hidden"
    },
    {
      "headword": "hide"
    },
    {
      "headword": "high"
    },
    {
      "headword": "high"
    },
    {
      "headword": "high school"
    },
    {
      "headword": "highlight"
    },
    {
      "headword": "highlight"
    },
    {
      "headword": "highly"
    },
    {
      "headword": "high-tech/hi-tech"
    },
    {
      "headword": "highway"
    },
    {
      "headword": "hijack"
    },
    {
      "headword": "hijack"
    },
    {
      "headword": "hike"
    },
    {
      "headword": "hiking"
    },
    {
      "headword": "hilarious"
    },
    {
      "headword": "hill"
    },
    {
      "headword": "him"
    },
    {
      "headword": "himself"
    },
    {
      "headword": "hint"
    },
    {
      "headword": "hip"
    },
    {
      "headword": "hip hop/hip-hop/hiphop"
    },
    {
      "headword": "hire"
    },
    {
      "headword": "his"
    },
    {
      "headword": "his"
    },
    {
      "headword": "historian"
    },
    {
      "headword": "historic"
    },
    {
      "headword": "historical"
    },
    {
      "headword": "history"
    },
    {
      "headword": "hit"
    },
    {
      "headword": "hit"
    },
    {
      "headword": "HIV"
    },
    {
      "headword": "hobby"
    },
    {
      "headword": "hockey"
    },
    {
      "headword": "hold"
    },
    {
      "headword": "hold"
    },
    {
      "headword": "holder"
    },
    {
      "headword": "hole"
    },
    {
      "headword": "holiday"
    },
    {
      "headword": "hollow"
    },
    {
      "headword": "holocaust"
    },
    {
      "headword": "holy"
    },
    {
      "headword": "home"
    },
    {
      "headword": "home"
    },
    {
      "headword": "homeless"
    },
    {
      "headword": "hometown"
    },
    {
      "headword": "homeward"
    },
    {
      "headword": "homework"
    },
    {
      "headword": "hone"
    },
    {
      "headword": "honest"
    },
    {
      "headword": "honestly"
    },
    {
      "headword": "honesty"
    },
    {
      "headword": "honey"
    },
    {
      "headword": "honeymoon"
    },
    {
      "headword": "honor/honour"
    },
    {
      "headword": "honor/honour"
    },
    {
      "headword": "honorable/honourable"
    },
    {
      "headword": "hood"
    },
    {
      "headword": "hook"
    },
    {
      "headword": "hook"
    },
    {
      "headword": "hop"
    },
    {
      "headword": "hope"
    },
    {
      "headword": "hope"
    },
    {
      "headword": "hopeful"
    },
    {
      "headword": "hopefully"
    },
    {
      "headword": "hopeless"
    },
    {
      "headword": "horizon"
    },
    {
      "headword": "horn"
    },
    {
      "headword": "horrible"
    },
    {
      "headword": "horrify"
    },
    {
      "headword": "horror"
    },
    {
      "headword": "horse"
    },
    {
      "headword": "hospice"
    },
    {
      "headword": "hospitable"
    },
    {
      "headword": "hospital"
    },
    {
      "headword": "hospitality"
    },
    {
      "headword": "hospitalize/hospitalise"
    },
    {
      "headword": "host"
    },
    {
      "headword": "hostel"
    },
    {
      "headword": "hot"
    },
    {
      "headword": "hotel"
    },
    {
      "headword": "hour"
    },
    {
      "headword": "hourly"
    },
    {
      "headword": "house"
    },
    {
      "headword": "household"
    },
    {
      "headword": "housekeeper"
    },
    {
      "headword": "housemaster"
    },
    {
      "headword": "housewife"
    },
    {
      "headword": "housework"
    },
    {
      "headword": "hover"
    },
    {
      "headword": "how"
    },
    {
      "headword": "however"
    },
    {
      "headword": "hug"
    },
    {
      "headword": "hug"
    },
    {
      "headword": "huge"
    },
    {
      "headword": "hugely"
    },
    {
      "headword": "human"
    },
    {
      "headword": "human"
    },
    {
      "headword": "human rights"
    },
    {
      "headword": "humane"
    },
    {
      "headword": "humanist"
    },
    {
      "headword": "humanity"
    },
    {
      "headword": "humanize/humanise"
    },
    {
      "headword": "humble"
    },
    {
      "headword": "humbug"
    },
    {
      "headword": "humid"
    },
    {
      "headword": "humiliate"
    },
    {
      "headword": "humiliating"
    },
    {
      "headword": "humiliation"
    },
    {
      "headword": "humor/humour"
    },
    {
      "headword": "humorous"
    },
    {
      "headword": "hundred"
    },
    {
      "headword": "hunger"
    },
    {
      "headword": "hungry"
    },
    {
      "headword": "hunt"
    },
    {
      "headword": "hunt"
    },
    {
      "headword": "hunter"
    },
    {
      "headword": "hunting"
    },
    {
      "headword": "hurriedly"
    },
    {
      "headword": "hurry"
    },
    {
      "headword": "hurry"
    },
    {
      "headword": "hurt"
    },
    {
      "headword": "hurt"
    },
    {
      "headword": "husband"
    },
    {
      "headword": "hush"
    },
    {
      "headword": "hut"
    },
    {
      "headword": "hybrid"
    },
    {
      "headword": "hygiene"
    },
    {
      "headword": "hyperbole"
    },
    {
      "headword": "hyphen"
    },
    {
      "headword": "I"
    },
    {
      "headword": "ice"
    },
    {
      "headword": "ice cream"
    },
    {
      "headword": "ice hockey"
    },
    {
      "headword": "ice skating"
    },
    {
      "headword": "iceman"
    },
    {
      "headword": "icon"
    },
    {
      "headword": "icy"
    },
    {
      "headword": "ID"
    },
    {
      "headword": "ID card"
    },
    {
      "headword": "idea"
    },
    {
      "headword": "ideal"
    },
    {
      "headword": "ideally"
    },
    {
      "headword": "identical"
    },
    {
      "headword": "identification"
    },
    {
      "headword": "identify"
    },
    {
      "headword": "identity"
    },
    {
      "headword": "identity card"
    },
    {
      "headword": "ideology"
    },
    {
      "headword": "idiom"
    },
    {
      "headword": "idiot"
    },
    {
      "headword": "idle"
    },
    {
      "headword": "idol"
    },
    {
      "headword": "idolize/idolise"
    },
    {
      "headword": "if"
    },
    {
      "headword": "ignorance"
    },
    {
      "headword": "ignorant"
    },
    {
      "headword": "ignore"
    },
    {
      "headword": "ill"
    },
    {
      "headword": "illegal"
    },
    {
      "headword": "illegally"
    },
    {
      "headword": "illness"
    },
    {
      "headword": "illuminate"
    },
    {
      "headword": "illustrate"
    },
    {
      "headword": "illustration"
    },
    {
      "headword": "image"
    },
    {
      "headword": "imagery"
    },
    {
      "headword": "imaginary"
    },
    {
      "headword": "imagination"
    },
    {
      "headword": "imagine"
    },
    {
      "headword": "imitate"
    },
    {
      "headword": "imitation"
    },
    {
      "headword": "immediate"
    },
    {
      "headword": "immediately"
    },
    {
      "headword": "immerse"
    },
    {
      "headword": "immigrant"
    },
    {
      "headword": "immigrate"
    },
    {
      "headword": "immigration"
    },
    {
      "headword": "immoral"
    },
    {
      "headword": "immortal"
    },
    {
      "headword": "immortality"
    },
    {
      "headword": "impact"
    },
    {
      "headword": "impair"
    },
    {
      "headword": "impartial"
    },
    {
      "headword": "impatient"
    },
    {
      "headword": "impatiently"
    },
    {
      "headword": "imperative"
    },
    {
      "headword": "impermanent"
    },
    {
      "headword": "implement"
    },
    {
      "headword": "implement"
    },
    {
      "headword": "implication"
    },
    {
      "headword": "imply"
    },
    {
      "headword": "impolite"
    },
    {
      "headword": "impolitely"
    },
    {
      "headword": "import"
    },
    {
      "headword": "importance"
    },
    {
      "headword": "important"
    },
    {
      "headword": "importantly"
    },
    {
      "headword": "impose"
    },
    {
      "headword": "impossibility"
    },
    {
      "headword": "impossible"
    },
    {
      "headword": "impractical"
    },
    {
      "headword": "impress"
    },
    {
      "headword": "impressed"
    },
    {
      "headword": "impression"
    },
    {
      "headword": "impressionism"
    },
    {
      "headword": "impressionist"
    },
    {
      "headword": "impressive"
    },
    {
      "headword": "imprison"
    },
    {
      "headword": "imprisonment"
    },
    {
      "headword": "improbable"
    },
    {
      "headword": "improper"
    },
    {
      "headword": "improperly"
    },
    {
      "headword": "improve"
    },
    {
      "headword": "improved"
    },
    {
      "headword": "improvement"
    },
    {
      "headword": "impulse"
    },
    {
      "headword": "impulsive"
    },
    {
      "headword": "in"
    },
    {
      "headword": "in"
    },
    {
      "headword": "inaccurate"
    },
    {
      "headword": "inadequate"
    },
    {
      "headword": "inanimate"
    },
    {
      "headword": "inborn"
    },
    {
      "headword": "incense"
    },
    {
      "headword": "incentive"
    },
    {
      "headword": "inch"
    },
    {
      "headword": "inch"
    },
    {
      "headword": "incident"
    },
    {
      "headword": "include"
    },
    {
      "headword": "including"
    },
    {
      "headword": "income"
    },
    {
      "headword": "inconvenient"
    },
    {
      "headword": "incorrect"
    },
    {
      "headword": "increase"
    },
    {
      "headword": "increase"
    },
    {
      "headword": "increasingly"
    },
    {
      "headword": "incredible"
    },
    {
      "headword": "incredibly"
    },
    {
      "headword": "incur"
    },
    {
      "headword": "incurable"
    },
    {
      "headword": "indebted"
    },
    {
      "headword": "indeed"
    },
    {
      "headword": "indefinite article"
    },
    {
      "headword": "indent"
    },
    {
      "headword": "independence"
    },
    {
      "headword": "independent"
    },
    {
      "headword": "independently"
    },
    {
      "headword": "indescribable"
    },
    {
      "headword": "index"
    },
    {
      "headword": "indicate"
    },
    {
      "headword": "indifferent"
    },
    {
      "headword": "indignity"
    },
    {
      "headword": "indirect"
    },
    {
      "headword": "indirectly"
    },
    {
      "headword": "indispensable"
    },
    {
      "headword": "individual"
    },
    {
      "headword": "individual"
    },
    {
      "headword": "indoor"
    },
    {
      "headword": "indoors"
    },
    {
      "headword": "indulge"
    },
    {
      "headword": "indulgent"
    },
    {
      "headword": "industrial"
    },
    {
      "headword": "industrialize/industrialise"
    },
    {
      "headword": "industry"
    },
    {
      "headword": "ineffective"
    },
    {
      "headword": "inert"
    },
    {
      "headword": "inevitable"
    },
    {
      "headword": "inexpensive"
    },
    {
      "headword": "inexperienced"
    },
    {
      "headword": "infant"
    },
    {
      "headword": "infect"
    },
    {
      "headword": "infected"
    },
    {
      "headword": "infection"
    },
    {
      "headword": "infectious"
    },
    {
      "headword": "infer"
    },
    {
      "headword": "inference"
    },
    {
      "headword": "infinitive"
    },
    {
      "headword": "inflammation"
    },
    {
      "headword": "inflammatory"
    },
    {
      "headword": "inflate"
    },
    {
      "headword": "inflation"
    },
    {
      "headword": "influence"
    },
    {
      "headword": "influence"
    },
    {
      "headword": "influential"
    },
    {
      "headword": "influenza"
    },
    {
      "headword": "inform"
    },
    {
      "headword": "informal"
    },
    {
      "headword": "information"
    },
    {
      "headword": "informative"
    },
    {
      "headword": "infringe"
    },
    {
      "headword": "infringement"
    },
    {
      "headword": "ingredient"
    },
    {
      "headword": "inhabit"
    },
    {
      "headword": "inhabitant"
    },
    {
      "headword": "inhale"
    },
    {
      "headword": "inherit"
    },
    {
      "headword": "initial"
    },
    {
      "headword": "initial"
    },
    {
      "headword": "initially"
    },
    {
      "headword": "initiative"
    },
    {
      "headword": "inject"
    },
    {
      "headword": "injection"
    },
    {
      "headword": "injure"
    },
    {
      "headword": "injured"
    },
    {
      "headword": "injury"
    },
    {
      "headword": "ink"
    },
    {
      "headword": "innate"
    },
    {
      "headword": "inner"
    },
    {
      "headword": "innermost"
    },
    {
      "headword": "innocent"
    },
    {
      "headword": "innocently"
    },
    {
      "headword": "innovation"
    },
    {
      "headword": "innovative"
    },
    {
      "headword": "innovator"
    },
    {
      "headword": "input"
    },
    {
      "headword": "inquire/enquire"
    },
    {
      "headword": "inquiry/enquiry"
    },
    {
      "headword": "insane"
    },
    {
      "headword": "inscribe"
    },
    {
      "headword": "inscription"
    },
    {
      "headword": "insect"
    },
    {
      "headword": "inseparable"
    },
    {
      "headword": "inside"
    },
    {
      "headword": "inside"
    },
    {
      "headword": "inside"
    },
    {
      "headword": "inside"
    },
    {
      "headword": "insight"
    },
    {
      "headword": "insist"
    },
    {
      "headword": "inspect"
    },
    {
      "headword": "inspection"
    },
    {
      "headword": "inspector"
    },
    {
      "headword": "inspiration"
    },
    {
      "headword": "inspirational"
    },
    {
      "headword": "inspire"
    },
    {
      "headword": "install/instal"
    },
    {
      "headword": "instance"
    },
    {
      "headword": "instant"
    },
    {
      "headword": "instantly"
    },
    {
      "headword": "instead"
    },
    {
      "headword": "instead of"
    },
    {
      "headword": "instill/instil"
    },
    {
      "headword": "instinct"
    },
    {
      "headword": "institute"
    },
    {
      "headword": "institution"
    },
    {
      "headword": "instruct"
    },
    {
      "headword": "instruction"
    },
    {
      "headword": "instructor"
    },
    {
      "headword": "instrument"
    },
    {
      "headword": "insufficient"
    },
    {
      "headword": "insult"
    },
    {
      "headword": "insult"
    },
    {
      "headword": "insurance"
    },
    {
      "headword": "integrate"
    },
    {
      "headword": "intellectual"
    },
    {
      "headword": "intellectual"
    },
    {
      "headword": "intelligence"
    },
    {
      "headword": "intelligent"
    },
    {
      "headword": "intend"
    },
    {
      "headword": "intense"
    },
    {
      "headword": "intensive"
    },
    {
      "headword": "intent"
    },
    {
      "headword": "intention"
    },
    {
      "headword": "intentionally"
    },
    {
      "headword": "interact"
    },
    {
      "headword": "interaction"
    },
    {
      "headword": "interactive"
    },
    {
      "headword": "interest"
    },
    {
      "headword": "interest"
    },
    {
      "headword": "interested"
    },
    {
      "headword": "interesting"
    },
    {
      "headword": "interfere"
    },
    {
      "headword": "interior"
    },
    {
      "headword": "intermediate"
    },
    {
      "headword": "intermission"
    },
    {
      "headword": "internal"
    },
    {
      "headword": "international"
    },
    {
      "headword": "internationally"
    },
    {
      "headword": "Internet/internet"
    },
    {
      "headword": "interpersonal"
    },
    {
      "headword": "interpret"
    },
    {
      "headword": "interpretation"
    },
    {
      "headword": "interpreter"
    },
    {
      "headword": "interrupt"
    },
    {
      "headword": "interruption"
    },
    {
      "headword": "intersection"
    },
    {
      "headword": "interval"
    },
    {
      "headword": "interview"
    },
    {
      "headword": "interview"
    },
    {
      "headword": "interviewee"
    },
    {
      "headword": "interviewer"
    },
    {
      "headword": "intimate"
    },
    {
      "headword": "into"
    },
    {
      "headword": "intransitive"
    },
    {
      "headword": "intravenous"
    },
    {
      "headword": "introduce"
    },
    {
      "headword": "introduction"
    },
    {
      "headword": "intrude"
    },
    {
      "headword": "intruder"
    },
    {
      "headword": "intrusion"
    },
    {
      "headword": "invade"
    },
    {
      "headword": "invariable"
    },
    {
      "headword": "invariably"
    },
    {
      "headword": "invasion"
    },
    {
      "headword": "invent"
    },
    {
      "headword": "invention"
    },
    {
      "headword": "inventor"
    },
    {
      "headword": "inverted commas"
    },
    {
      "headword": "invest"
    },
    {
      "headword": "investigate"
    },
    {
      "headword": "investigation"
    },
    {
      "headword": "investigator"
    },
    {
      "headword": "investment"
    },
    {
      "headword": "investor"
    },
    {
      "headword": "invisible"
    },
    {
      "headword": "invitation"
    },
    {
      "headword": "invite"
    },
    {
      "headword": "invitingly"
    },
    {
      "headword": "invoke"
    },
    {
      "headword": "involuntarily"
    },
    {
      "headword": "involve"
    },
    {
      "headword": "involved"
    },
    {
      "headword": "involvement"
    },
    {
      "headword": "iron"
    },
    {
      "headword": "iron"
    },
    {
      "headword": "ironically"
    },
    {
      "headword": "ironing"
    },
    {
      "headword": "irrational"
    },
    {
      "headword": "irregular"
    },
    {
      "headword": "irresistible"
    },
    {
      "headword": "irresistibly"
    },
    {
      "headword": "irresponsible"
    },
    {
      "headword": "irritate"
    },
    {
      "headword": "irritated"
    },
    {
      "headword": "irritating"
    },
    {
      "headword": "irritation"
    },
    {
      "headword": "is"
    },
    {
      "headword": "island"
    },
    {
      "headword": "islander"
    },
    {
      "headword": "isle"
    },
    {
      "headword": "isolation"
    },
    {
      "headword": "issue"
    },
    {
      "headword": "issue"
    },
    {
      "headword": "IT"
    },
    {
      "headword": "it"
    },
    {
      "headword": "italicize/italicise"
    },
    {
      "headword": "itch"
    },
    {
      "headword": "item"
    },
    {
      "headword": "its"
    },
    {
      "headword": "its"
    },
    {
      "headword": "itself"
    },
    {
      "headword": "ivory"
    },
    {
      "headword": "jacket"
    },
    {
      "headword": "jade"
    },
    {
      "headword": "jail/gaol"
    },
    {
      "headword": "jam"
    },
    {
      "headword": "jam"
    },
    {
      "headword": "January"
    },
    {
      "headword": "jar"
    },
    {
      "headword": "jaw"
    },
    {
      "headword": "jazz"
    },
    {
      "headword": "jealous"
    },
    {
      "headword": "jealously"
    },
    {
      "headword": "jeans"
    },
    {
      "headword": "jelly"
    },
    {
      "headword": "jeopardize/jeopardise"
    },
    {
      "headword": "jet"
    },
    {
      "headword": "jewel"
    },
    {
      "headword": "jeweler/jeweller"
    },
    {
      "headword": "jewelry/jewellery"
    },
    {
      "headword": "job"
    },
    {
      "headword": "jog"
    },
    {
      "headword": "jog"
    },
    {
      "headword": "jogging"
    },
    {
      "headword": "join"
    },
    {
      "headword": "joint"
    },
    {
      "headword": "joint"
    },
    {
      "headword": "joke"
    },
    {
      "headword": "joke"
    },
    {
      "headword": "journal"
    },
    {
      "headword": "journalism"
    },
    {
      "headword": "journalist"
    },
    {
      "headword": "journey"
    },
    {
      "headword": "joy"
    },
    {
      "headword": "judge"
    },
    {
      "headword": "judge"
    },
    {
      "headword": "judgment/judgement"
    },
    {
      "headword": "judo"
    },
    {
      "headword": "jug"
    },
    {
      "headword": "juice"
    },
    {
      "headword": "juicy"
    },
    {
      "headword": "July"
    },
    {
      "headword": "jump"
    },
    {
      "headword": "jump"
    },
    {
      "headword": "jumper"
    },
    {
      "headword": "June"
    },
    {
      "headword": "jungle"
    },
    {
      "headword": "junior"
    },
    {
      "headword": "junk"
    },
    {
      "headword": "junk food"
    },
    {
      "headword": "juror"
    },
    {
      "headword": "jury"
    },
    {
      "headword": "just"
    },
    {
      "headword": "justice"
    },
    {
      "headword": "justify"
    },
    {
      "headword": "kangaroo"
    },
    {
      "headword": "karaoke"
    },
    {
      "headword": "keen"
    },
    {
      "headword": "keep"
    },
    {
      "headword": "keeper"
    },
    {
      "headword": "kerosene"
    },
    {
      "headword": "kettle"
    },
    {
      "headword": "key"
    },
    {
      "headword": "key"
    },
    {
      "headword": "keyboard"
    },
    {
      "headword": "keystroke"
    },
    {
      "headword": "kick"
    },
    {
      "headword": "kick"
    },
    {
      "headword": "kid"
    },
    {
      "headword": "kid"
    },
    {
      "headword": "kill"
    },
    {
      "headword": "killer"
    },
    {
      "headword": "killing"
    },
    {
      "headword": "kilo"
    },
    {
      "headword": "kilogram/kilogramme"
    },
    {
      "headword": "kilometer/kilometre"
    },
    {
      "headword": "kind"
    },
    {
      "headword": "kind"
    },
    {
      "headword": "kindly"
    },
    {
      "headword": "kindly"
    },
    {
      "headword": "kindness"
    },
    {
      "headword": "king"
    },
    {
      "headword": "kingdom"
    },
    {
      "headword": "kiss"
    },
    {
      "headword": "kiss"
    },
    {
      "headword": "kit"
    },
    {
      "headword": "kitchen"
    },
    {
      "headword": "kite"
    },
    {
      "headword": "kitten"
    },
    {
      "headword": "knee"
    },
    {
      "headword": "kneel"
    },
    {
      "headword": "knife"
    },
    {
      "headword": "knit"
    },
    {
      "headword": "knock"
    },
    {
      "headword": "knock"
    },
    {
      "headword": "knot"
    },
    {
      "headword": "know"
    },
    {
      "headword": "knowingly"
    },
    {
      "headword": "knowledge"
    },
    {
      "headword": "known"
    },
    {
      "headword": "lab"
    },
    {
      "headword": "label"
    },
    {
      "headword": "labor/labour"
    },
    {
      "headword": "laboratory"
    },
    {
      "headword": "laborer/labourer"
    },
    {
      "headword": "lack"
    },
    {
      "headword": "lack"
    },
    {
      "headword": "ladder"
    },
    {
      "headword": "lady"
    },
    {
      "headword": "lake"
    },
    {
      "headword": "lamb"
    },
    {
      "headword": "lame"
    },
    {
      "headword": "lamp"
    },
    {
      "headword": "lance"
    },
    {
      "headword": "land"
    },
    {
      "headword": "land"
    },
    {
      "headword": "landing"
    },
    {
      "headword": "landlady"
    },
    {
      "headword": "landlord"
    },
    {
      "headword": "landscape"
    },
    {
      "headword": "landslide"
    },
    {
      "headword": "lane"
    },
    {
      "headword": "language"
    },
    {
      "headword": "lap"
    },
    {
      "headword": "laptop"
    },
    {
      "headword": "large"
    },
    {
      "headword": "largely"
    },
    {
      "headword": "lark"
    },
    {
      "headword": "laser"
    },
    {
      "headword": "last"
    },
    {
      "headword": "last"
    },
    {
      "headword": "last"
    },
    {
      "headword": "last"
    },
    {
      "headword": "last minute"
    },
    {
      "headword": "last name"
    },
    {
      "headword": "lasting"
    },
    {
      "headword": "lastly"
    },
    {
      "headword": "last-minute"
    },
    {
      "headword": "late"
    },
    {
      "headword": "late"
    },
    {
      "headword": "latecomer"
    },
    {
      "headword": "lately"
    },
    {
      "headword": "later"
    },
    {
      "headword": "later"
    },
    {
      "headword": "latest"
    },
    {
      "headword": "latter"
    },
    {
      "headword": "latter"
    },
    {
      "headword": "latter"
    },
    {
      "headword": "laugh"
    },
    {
      "headword": "laugh"
    },
    {
      "headword": "laughter"
    },
    {
      "headword": "launch"
    },
    {
      "headword": "laundry"
    },
    {
      "headword": "lava"
    },
    {
      "headword": "law"
    },
    {
      "headword": "lawful"
    },
    {
      "headword": "lawmaker"
    },
    {
      "headword": "lawn"
    },
    {
      "headword": "lawsuit"
    },
    {
      "headword": "lawyer"
    },
    {
      "headword": "lay"
    },
    {
      "headword": "layabout"
    },
    {
      "headword": "layer"
    },
    {
      "headword": "laziness"
    },
    {
      "headword": "lazy"
    },
    {
      "headword": "lead"
    },
    {
      "headword": "lead"
    },
    {
      "headword": "lead"
    },
    {
      "headword": "leader"
    },
    {
      "headword": "leadership"
    },
    {
      "headword": "leading"
    },
    {
      "headword": "leaf"
    },
    {
      "headword": "leaflet"
    },
    {
      "headword": "league"
    },
    {
      "headword": "leak"
    },
    {
      "headword": "leak"
    },
    {
      "headword": "lean"
    },
    {
      "headword": "lean"
    },
    {
      "headword": "leap"
    },
    {
      "headword": "leap"
    },
    {
      "headword": "learn"
    },
    {
      "headword": "learner"
    },
    {
      "headword": "learning"
    },
    {
      "headword": "lease"
    },
    {
      "headword": "leash"
    },
    {
      "headword": "least"
    },
    {
      "headword": "least"
    },
    {
      "headword": "least"
    },
    {
      "headword": "leather"
    },
    {
      "headword": "leave"
    },
    {
      "headword": "leave"
    },
    {
      "headword": "lecture"
    },
    {
      "headword": "lecturer"
    },
    {
      "headword": "leek"
    },
    {
      "headword": "left"
    },
    {
      "headword": "left"
    },
    {
      "headword": "left"
    },
    {
      "headword": "left-hand"
    },
    {
      "headword": "leg"
    },
    {
      "headword": "legal"
    },
    {
      "headword": "legally"
    },
    {
      "headword": "legend"
    },
    {
      "headword": "legendary"
    },
    {
      "headword": "legislate"
    },
    {
      "headword": "legislation"
    },
    {
      "headword": "legislative"
    },
    {
      "headword": "legislator"
    },
    {
      "headword": "legislature"
    },
    {
      "headword": "legitimate"
    },
    {
      "headword": "leisure"
    },
    {
      "headword": "leisurely"
    },
    {
      "headword": "lemon"
    },
    {
      "headword": "lemonade"
    },
    {
      "headword": "lend"
    },
    {
      "headword": "length"
    },
    {
      "headword": "lengthen"
    },
    {
      "headword": "lengthy"
    },
    {
      "headword": "leopard"
    },
    {
      "headword": "less"
    },
    {
      "headword": "less"
    },
    {
      "headword": "less"
    },
    {
      "headword": "lessen"
    },
    {
      "headword": "lesson"
    },
    {
      "headword": "lest"
    },
    {
      "headword": "let"
    },
    {
      "headword": "letter"
    },
    {
      "headword": "lettuce"
    },
    {
      "headword": "level"
    },
    {
      "headword": "level"
    },
    {
      "headword": "level"
    },
    {
      "headword": "liar"
    },
    {
      "headword": "liberal"
    },
    {
      "headword": "liberate"
    },
    {
      "headword": "liberation"
    },
    {
      "headword": "liberty"
    },
    {
      "headword": "librarian"
    },
    {
      "headword": "library"
    },
    {
      "headword": "license/licence"
    },
    {
      "headword": "lick"
    },
    {
      "headword": "lid"
    },
    {
      "headword": "lie"
    },
    {
      "headword": "lie"
    },
    {
      "headword": "life"
    },
    {
      "headword": "lifeguard"
    },
    {
      "headword": "lifeless"
    },
    {
      "headword": "lifelong"
    },
    {
      "headword": "lifestyle"
    },
    {
      "headword": "lifetime"
    },
    {
      "headword": "lift"
    },
    {
      "headword": "lift"
    },
    {
      "headword": "light"
    },
    {
      "headword": "light"
    },
    {
      "headword": "light"
    },
    {
      "headword": "lighten"
    },
    {
      "headword": "lighter"
    },
    {
      "headword": "lighting"
    },
    {
      "headword": "lightly"
    },
    {
      "headword": "lightning"
    },
    {
      "headword": "like"
    },
    {
      "headword": "like"
    },
    {
      "headword": "like"
    },
    {
      "headword": "likely"
    },
    {
      "headword": "likeness"
    },
    {
      "headword": "likewise"
    },
    {
      "headword": "lily"
    },
    {
      "headword": "limb"
    },
    {
      "headword": "limit"
    },
    {
      "headword": "limit"
    },
    {
      "headword": "limitation"
    },
    {
      "headword": "limited"
    },
    {
      "headword": "limp"
    },
    {
      "headword": "line"
    },
    {
      "headword": "line"
    },
    {
      "headword": "linen"
    },
    {
      "headword": "liner"
    },
    {
      "headword": "ling"
    },
    {
      "headword": "linger"
    },
    {
      "headword": "link"
    },
    {
      "headword": "link"
    },
    {
      "headword": "lion"
    },
    {
      "headword": "lip"
    },
    {
      "headword": "liquid"
    },
    {
      "headword": "liquid"
    },
    {
      "headword": "list"
    },
    {
      "headword": "list"
    },
    {
      "headword": "listen"
    },
    {
      "headword": "listener"
    },
    {
      "headword": "liter/litre"
    },
    {
      "headword": "literal"
    },
    {
      "headword": "literally"
    },
    {
      "headword": "literary"
    },
    {
      "headword": "literature"
    },
    {
      "headword": "litter"
    },
    {
      "headword": "little"
    },
    {
      "headword": "little"
    },
    {
      "headword": "little"
    },
    {
      "headword": "little"
    },
    {
      "headword": "live"
    },
    {
      "headword": "live"
    },
    {
      "headword": "lively"
    },
    {
      "headword": "liver"
    },
    {
      "headword": "living"
    },
    {
      "headword": "living"
    },
    {
      "headword": "living room"
    },
    {
      "headword": "load"
    },
    {
      "headword": "load"
    },
    {
      "headword": "loaf"
    },
    {
      "headword": "loan"
    },
    {
      "headword": "lobby"
    },
    {
      "headword": "local"
    },
    {
      "headword": "locate"
    },
    {
      "headword": "location"
    },
    {
      "headword": "lock"
    },
    {
      "headword": "lock"
    },
    {
      "headword": "lodge"
    },
    {
      "headword": "log"
    },
    {
      "headword": "logic"
    },
    {
      "headword": "logical"
    },
    {
      "headword": "logo"
    },
    {
      "headword": "loneliness"
    },
    {
      "headword": "lonely"
    },
    {
      "headword": "long"
    },
    {
      "headword": "long"
    },
    {
      "headword": "long-distance"
    },
    {
      "headword": "long-term"
    },
    {
      "headword": "look"
    },
    {
      "headword": "look"
    },
    {
      "headword": "loose"
    },
    {
      "headword": "loosely"
    },
    {
      "headword": "lorry"
    },
    {
      "headword": "lose"
    },
    {
      "headword": "loss"
    },
    {
      "headword": "lost"
    },
    {
      "headword": "lot"
    },
    {
      "headword": "lot"
    },
    {
      "headword": "lot"
    },
    {
      "headword": "lottery"
    },
    {
      "headword": "loud"
    },
    {
      "headword": "loud"
    },
    {
      "headword": "loudly"
    },
    {
      "headword": "loudspeaker"
    },
    {
      "headword": "lousy"
    },
    {
      "headword": "love"
    },
    {
      "headword": "love"
    },
    {
      "headword": "lovely"
    },
    {
      "headword": "lover"
    },
    {
      "headword": "lovingly"
    },
    {
      "headword": "low"
    },
    {
      "headword": "low"
    },
    {
      "headword": "lower"
    },
    {
      "headword": "lowland"
    },
    {
      "headword": "loyal"
    },
    {
      "headword": "loyalty"
    },
    {
      "headword": "luck"
    },
    {
      "headword": "luckily"
    },
    {
      "headword": "lucky"
    },
    {
      "headword": "lucrative"
    },
    {
      "headword": "luggage"
    },
    {
      "headword": "lunch"
    },
    {
      "headword": "lunchtime"
    },
    {
      "headword": "lung"
    },
    {
      "headword": "lush"
    },
    {
      "headword": "luxurious"
    },
    {
      "headword": "luxury"
    },
    {
      "headword": "luxury"
    },
    {
      "headword": "lyric"
    },
    {
      "headword": "lyrics"
    },
    {
      "headword": "m"
    },
    {
      "headword": "machine"
    },
    {
      "headword": "mad"
    },
    {
      "headword": "madam"
    },
    {
      "headword": "madame"
    },
    {
      "headword": "madness"
    },
    {
      "headword": "maestro"
    },
    {
      "headword": "magazine"
    },
    {
      "headword": "magic"
    },
    {
      "headword": "magic"
    },
    {
      "headword": "magical"
    },
    {
      "headword": "magician"
    },
    {
      "headword": "magnificent"
    },
    {
      "headword": "magnify"
    },
    {
      "headword": "mail"
    },
    {
      "headword": "mail"
    },
    {
      "headword": "mailbox"
    },
    {
      "headword": "main"
    },
    {
      "headword": "main course"
    },
    {
      "headword": "mainly"
    },
    {
      "headword": "maintain"
    },
    {
      "headword": "maintenance"
    },
    {
      "headword": "major"
    },
    {
      "headword": "major"
    },
    {
      "headword": "majority"
    },
    {
      "headword": "make"
    },
    {
      "headword": "make"
    },
    {
      "headword": "maker"
    },
    {
      "headword": "make-up"
    },
    {
      "headword": "malady"
    },
    {
      "headword": "malaria"
    },
    {
      "headword": "male"
    },
    {
      "headword": "male"
    },
    {
      "headword": "mall"
    },
    {
      "headword": "mama/mamma"
    },
    {
      "headword": "man"
    },
    {
      "headword": "manage"
    },
    {
      "headword": "management"
    },
    {
      "headword": "manager"
    },
    {
      "headword": "mango"
    },
    {
      "headword": "manipulate"
    },
    {
      "headword": "mankind"
    },
    {
      "headword": "manner"
    },
    {
      "headword": "mansion"
    },
    {
      "headword": "manual"
    },
    {
      "headword": "manual"
    },
    {
      "headword": "manufacture"
    },
    {
      "headword": "manufacture"
    },
    {
      "headword": "manufacturer"
    },
    {
      "headword": "manufacturing"
    },
    {
      "headword": "many"
    },
    {
      "headword": "many"
    },
    {
      "headword": "map"
    },
    {
      "headword": "maple"
    },
    {
      "headword": "marathon"
    },
    {
      "headword": "marble"
    },
    {
      "headword": "March"
    },
    {
      "headword": "march"
    },
    {
      "headword": "march"
    },
    {
      "headword": "margin"
    },
    {
      "headword": "marine"
    },
    {
      "headword": "mark"
    },
    {
      "headword": "mark"
    },
    {
      "headword": "marked"
    },
    {
      "headword": "market"
    },
    {
      "headword": "market"
    },
    {
      "headword": "marketing"
    },
    {
      "headword": "marriage"
    },
    {
      "headword": "married"
    },
    {
      "headword": "marry"
    },
    {
      "headword": "martial art"
    },
    {
      "headword": "marvelous/marvellous"
    },
    {
      "headword": "mash"
    },
    {
      "headword": "mask"
    },
    {
      "headword": "mass"
    },
    {
      "headword": "mass"
    },
    {
      "headword": "massacre"
    },
    {
      "headword": "massage"
    },
    {
      "headword": "masseur"
    },
    {
      "headword": "massive"
    },
    {
      "headword": "master"
    },
    {
      "headword": "masterpiece"
    },
    {
      "headword": "mastery"
    },
    {
      "headword": "match"
    },
    {
      "headword": "match"
    },
    {
      "headword": "mate"
    },
    {
      "headword": "material"
    },
    {
      "headword": "math/maths"
    },
    {
      "headword": "mathematical"
    },
    {
      "headword": "mathematician"
    },
    {
      "headword": "mathematics"
    },
    {
      "headword": "matter"
    },
    {
      "headword": "matter"
    },
    {
      "headword": "mature"
    },
    {
      "headword": "mausoleum"
    },
    {
      "headword": "max"
    },
    {
      "headword": "maximum"
    },
    {
      "headword": "maximum"
    },
    {
      "headword": "may"
    },
    {
      "headword": "May"
    },
    {
      "headword": "maybe"
    },
    {
      "headword": "mayor"
    },
    {
      "headword": "me"
    },
    {
      "headword": "meal"
    },
    {
      "headword": "mean"
    },
    {
      "headword": "mean"
    },
    {
      "headword": "mean"
    },
    {
      "headword": "meaning"
    },
    {
      "headword": "meaningful"
    },
    {
      "headword": "means"
    },
    {
      "headword": "meanwhile"
    },
    {
      "headword": "measure"
    },
    {
      "headword": "measure"
    },
    {
      "headword": "measurement"
    },
    {
      "headword": "meat"
    },
    {
      "headword": "mechanic"
    },
    {
      "headword": "mechanical"
    },
    {
      "headword": "mechanize/mechanise"
    },
    {
      "headword": "medal"
    },
    {
      "headword": "media"
    },
    {
      "headword": "medical"
    },
    {
      "headword": "medication"
    },
    {
      "headword": "medicine"
    },
    {
      "headword": "medieval/mediaeval"
    },
    {
      "headword": "mediocre"
    },
    {
      "headword": "meditate"
    },
    {
      "headword": "meditation"
    },
    {
      "headword": "Mediterranean"
    },
    {
      "headword": "medium"
    },
    {
      "headword": "medium"
    },
    {
      "headword": "meet"
    },
    {
      "headword": "meeting"
    },
    {
      "headword": "melody"
    },
    {
      "headword": "melon"
    },
    {
      "headword": "melt"
    },
    {
      "headword": "member"
    },
    {
      "headword": "membership"
    },
    {
      "headword": "memorable"
    },
    {
      "headword": "memorial"
    },
    {
      "headword": "memorize/memorise"
    },
    {
      "headword": "memory"
    },
    {
      "headword": "mend"
    },
    {
      "headword": "mental"
    },
    {
      "headword": "mentally"
    },
    {
      "headword": "mention"
    },
    {
      "headword": "mention"
    },
    {
      "headword": "mentor"
    },
    {
      "headword": "menu"
    },
    {
      "headword": "merchandise"
    },
    {
      "headword": "merchant"
    },
    {
      "headword": "mercy"
    },
    {
      "headword": "mere"
    },
    {
      "headword": "merely"
    },
    {
      "headword": "merge"
    },
    {
      "headword": "merger"
    },
    {
      "headword": "merry"
    },
    {
      "headword": "mess"
    },
    {
      "headword": "mess"
    },
    {
      "headword": "message"
    },
    {
      "headword": "message board"
    },
    {
      "headword": "messenger"
    },
    {
      "headword": "messy"
    },
    {
      "headword": "metal"
    },
    {
      "headword": "metaphor"
    },
    {
      "headword": "meter/metre"
    },
    {
      "headword": "method"
    },
    {
      "headword": "metric"
    },
    {
      "headword": "micro"
    },
    {
      "headword": "microbe"
    },
    {
      "headword": "microcomputer"
    },
    {
      "headword": "micrometer/micrometre"
    },
    {
      "headword": "microorganism"
    },
    {
      "headword": "microphone"
    },
    {
      "headword": "microscope"
    },
    {
      "headword": "microscopic"
    },
    {
      "headword": "microscopy"
    },
    {
      "headword": "microwave"
    },
    {
      "headword": "midday"
    },
    {
      "headword": "middle"
    },
    {
      "headword": "middle"
    },
    {
      "headword": "middle-aged"
    },
    {
      "headword": "midnight"
    },
    {
      "headword": "midst"
    },
    {
      "headword": "might"
    },
    {
      "headword": "mighty"
    },
    {
      "headword": "migration"
    },
    {
      "headword": "mild"
    },
    {
      "headword": "mile"
    },
    {
      "headword": "military"
    },
    {
      "headword": "milk"
    },
    {
      "headword": "mill"
    },
    {
      "headword": "millimeter/millimetre"
    },
    {
      "headword": "million"
    },
    {
      "headword": "millionaire"
    },
    {
      "headword": "mimic"
    },
    {
      "headword": "mind"
    },
    {
      "headword": "mind"
    },
    {
      "headword": "mine"
    },
    {
      "headword": "mine"
    },
    {
      "headword": "mineral"
    },
    {
      "headword": "mineral water"
    },
    {
      "headword": "miniature"
    },
    {
      "headword": "minimize/minimise"
    },
    {
      "headword": "minimum"
    },
    {
      "headword": "minimum"
    },
    {
      "headword": "minister"
    },
    {
      "headword": "minor"
    },
    {
      "headword": "minority"
    },
    {
      "headword": "mint"
    },
    {
      "headword": "minus"
    },
    {
      "headword": "minute"
    },
    {
      "headword": "miracle"
    },
    {
      "headword": "mirror"
    },
    {
      "headword": "mischief"
    },
    {
      "headword": "misconception"
    },
    {
      "headword": "miserable"
    },
    {
      "headword": "misery"
    },
    {
      "headword": "misfortune"
    },
    {
      "headword": "mislead"
    },
    {
      "headword": "misleading"
    },
    {
      "headword": "Miss"
    },
    {
      "headword": "miss"
    },
    {
      "headword": "missile"
    },
    {
      "headword": "missing"
    },
    {
      "headword": "mission"
    },
    {
      "headword": "mist"
    },
    {
      "headword": "mistake"
    },
    {
      "headword": "mistreat"
    },
    {
      "headword": "mistrustful"
    },
    {
      "headword": "misty"
    },
    {
      "headword": "misunderstand"
    },
    {
      "headword": "misunderstanding"
    },
    {
      "headword": "mix"
    },
    {
      "headword": "mix"
    },
    {
      "headword": "mixing bowl"
    },
    {
      "headword": "mixture"
    },
    {
      "headword": "mobile"
    },
    {
      "headword": "mobile"
    },
    {
      "headword": "mobile phone"
    },
    {
      "headword": "mobility"
    },
    {
      "headword": "mock"
    },
    {
      "headword": "modal verb/modal"
    },
    {
      "headword": "model"
    },
    {
      "headword": "model"
    },
    {
      "headword": "model"
    },
    {
      "headword": "modem"
    },
    {
      "headword": "moderate"
    },
    {
      "headword": "modern"
    },
    {
      "headword": "modernization/modernisation"
    },
    {
      "headword": "modernize/modernise"
    },
    {
      "headword": "modest"
    },
    {
      "headword": "modification"
    },
    {
      "headword": "modify"
    },
    {
      "headword": "mogul"
    },
    {
      "headword": "moisture"
    },
    {
      "headword": "mold/mould"
    },
    {
      "headword": "molecule"
    },
    {
      "headword": "mom"
    },
    {
      "headword": "moment"
    },
    {
      "headword": "momentarily"
    },
    {
      "headword": "momentary"
    },
    {
      "headword": "mommy/mommie"
    },
    {
      "headword": "monastery"
    },
    {
      "headword": "Monday"
    },
    {
      "headword": "money"
    },
    {
      "headword": "monitor"
    },
    {
      "headword": "monitor"
    },
    {
      "headword": "monk"
    },
    {
      "headword": "monkey"
    },
    {
      "headword": "monster"
    },
    {
      "headword": "month"
    },
    {
      "headword": "monthly"
    },
    {
      "headword": "monthly"
    },
    {
      "headword": "monument"
    },
    {
      "headword": "mood"
    },
    {
      "headword": "moody"
    },
    {
      "headword": "moon"
    },
    {
      "headword": "moonlight"
    },
    {
      "headword": "moonscape"
    },
    {
      "headword": "moral"
    },
    {
      "headword": "moral"
    },
    {
      "headword": "morality"
    },
    {
      "headword": "morally"
    },
    {
      "headword": "more"
    },
    {
      "headword": "more"
    },
    {
      "headword": "more"
    },
    {
      "headword": "moreover"
    },
    {
      "headword": "morning"
    },
    {
      "headword": "mortal"
    },
    {
      "headword": "mortar"
    },
    {
      "headword": "mortgage"
    },
    {
      "headword": "mortify"
    },
    {
      "headword": "mosque"
    },
    {
      "headword": "mosquito"
    },
    {
      "headword": "moss"
    },
    {
      "headword": "most"
    },
    {
      "headword": "most"
    },
    {
      "headword": "most"
    },
    {
      "headword": "mostly"
    },
    {
      "headword": "mother"
    },
    {
      "headword": "mother-in-law"
    },
    {
      "headword": "motherland"
    },
    {
      "headword": "motion"
    },
    {
      "headword": "motionless"
    },
    {
      "headword": "motivate"
    },
    {
      "headword": "motivated"
    },
    {
      "headword": "motivation"
    },
    {
      "headword": "motive"
    },
    {
      "headword": "motor"
    },
    {
      "headword": "motorbike"
    },
    {
      "headword": "motorcycle"
    },
    {
      "headword": "motorist"
    },
    {
      "headword": "motorway"
    },
    {
      "headword": "motto"
    },
    {
      "headword": "mount"
    },
    {
      "headword": "mount"
    },
    {
      "headword": "mountain"
    },
    {
      "headword": "mountaintop"
    },
    {
      "headword": "mourn"
    },
    {
      "headword": "mournful"
    },
    {
      "headword": "mouse"
    },
    {
      "headword": "mouth"
    },
    {
      "headword": "move"
    },
    {
      "headword": "move"
    },
    {
      "headword": "movement"
    },
    {
      "headword": "mover"
    },
    {
      "headword": "movie"
    },
    {
      "headword": "moving"
    },
    {
      "headword": "MP3 player"
    },
    {
      "headword": "Mr./Mr"
    },
    {
      "headword": "Mrs./Mrs"
    },
    {
      "headword": "Ms./Ms"
    },
    {
      "headword": "much"
    },
    {
      "headword": "much"
    },
    {
      "headword": "much"
    },
    {
      "headword": "mud"
    },
    {
      "headword": "muddy"
    },
    {
      "headword": "mug"
    },
    {
      "headword": "mule"
    },
    {
      "headword": "multiple"
    },
    {
      "headword": "multiply"
    },
    {
      "headword": "mum"
    },
    {
      "headword": "mumble"
    },
    {
      "headword": "mumble"
    },
    {
      "headword": "murder"
    },
    {
      "headword": "murder"
    },
    {
      "headword": "murderer"
    },
    {
      "headword": "murmur"
    },
    {
      "headword": "muscle"
    },
    {
      "headword": "muse"
    },
    {
      "headword": "museum"
    },
    {
      "headword": "mushroom"
    },
    {
      "headword": "music"
    },
    {
      "headword": "musical"
    },
    {
      "headword": "musical"
    },
    {
      "headword": "musician"
    },
    {
      "headword": "must"
    },
    {
      "headword": "mustache/moustache"
    },
    {
      "headword": "mustard"
    },
    {
      "headword": "mutability"
    },
    {
      "headword": "mutable"
    },
    {
      "headword": "mutter"
    },
    {
      "headword": "mutter"
    },
    {
      "headword": "mutton"
    },
    {
      "headword": "mutual"
    },
    {
      "headword": "my"
    },
    {
      "headword": "myself"
    },
    {
      "headword": "mysterious"
    },
    {
      "headword": "mystery"
    },
    {
      "headword": "mystify"
    },
    {
      "headword": "myth"
    },
    {
      "headword": "nail"
    },
    {
      "headword": "naked"
    },
    {
      "headword": "name"
    },
    {
      "headword": "name"
    },
    {
      "headword": "nano"
    },
    {
      "headword": "nap"
    },
    {
      "headword": "napkin"
    },
    {
      "headword": "narcissistic"
    },
    {
      "headword": "narrate"
    },
    {
      "headword": "narrative"
    },
    {
      "headword": "narrator"
    },
    {
      "headword": "narrow"
    },
    {
      "headword": "narrowly"
    },
    {
      "headword": "nasty"
    },
    {
      "headword": "nation"
    },
    {
      "headword": "national"
    },
    {
      "headword": "nationalist"
    },
    {
      "headword": "nationality"
    },
    {
      "headword": "nationwide"
    },
    {
      "headword": "nationwide"
    },
    {
      "headword": "native"
    },
    {
      "headword": "native speaker"
    },
    {
      "headword": "natural"
    },
    {
      "headword": "naturally"
    },
    {
      "headword": "nature"
    },
    {
      "headword": "naughty"
    },
    {
      "headword": "naval"
    },
    {
      "headword": "navigate"
    },
    {
      "headword": "navigation"
    },
    {
      "headword": "navy"
    },
    {
      "headword": "navy blue"
    },
    {
      "headword": "near"
    },
    {
      "headword": "near"
    },
    {
      "headword": "near"
    },
    {
      "headword": "nearby"
    },
    {
      "headword": "nearby"
    },
    {
      "headword": "nearly"
    },
    {
      "headword": "neat"
    },
    {
      "headword": "necessarily"
    },
    {
      "headword": "necessary"
    },
    {
      "headword": "necessity"
    },
    {
      "headword": "neck"
    },
    {
      "headword": "necklace"
    },
    {
      "headword": "nectar"
    },
    {
      "headword": "need"
    },
    {
      "headword": "need"
    },
    {
      "headword": "need"
    },
    {
      "headword": "needle"
    },
    {
      "headword": "needless"
    },
    {
      "headword": "needy"
    },
    {
      "headword": "negative"
    },
    {
      "headword": "negatively"
    },
    {
      "headword": "neglect"
    },
    {
      "headword": "negotiate"
    },
    {
      "headword": "negotiation"
    },
    {
      "headword": "neighbor/neighbour"
    },
    {
      "headword": "neighborhood/neighbourhood"
    },
    {
      "headword": "neighboring/neighbouring"
    },
    {
      "headword": "neither"
    },
    {
      "headword": "neither"
    },
    {
      "headword": "neither"
    },
    {
      "headword": "neither"
    },
    {
      "headword": "nephew"
    },
    {
      "headword": "nerve"
    },
    {
      "headword": "nerves"
    },
    {
      "headword": "nervous"
    },
    {
      "headword": "nervously"
    },
    {
      "headword": "nervousness"
    },
    {
      "headword": "ness"
    },
    {
      "headword": "net"
    },
    {
      "headword": "net"
    },
    {
      "headword": "netsurfer/net surfer"
    },
    {
      "headword": "network"
    },
    {
      "headword": "neurosis"
    },
    {
      "headword": "neutral"
    },
    {
      "headword": "never"
    },
    {
      "headword": "nevertheless"
    },
    {
      "headword": "new"
    },
    {
      "headword": "newborn"
    },
    {
      "headword": "newcomer"
    },
    {
      "headword": "newly"
    },
    {
      "headword": "news"
    },
    {
      "headword": "newscaster"
    },
    {
      "headword": "newspaper"
    },
    {
      "headword": "newsworthy"
    },
    {
      "headword": "next"
    },
    {
      "headword": "next"
    },
    {
      "headword": "next"
    },
    {
      "headword": "next door"
    },
    {
      "headword": "next to"
    },
    {
      "headword": "next-door"
    },
    {
      "headword": "nice"
    },
    {
      "headword": "nicely"
    },
    {
      "headword": "nickname"
    },
    {
      "headword": "niece"
    },
    {
      "headword": "night"
    },
    {
      "headword": "nightclub"
    },
    {
      "headword": "nightlife"
    },
    {
      "headword": "nightmare"
    },
    {
      "headword": "nine"
    },
    {
      "headword": "nineteen"
    },
    {
      "headword": "ninety"
    },
    {
      "headword": "no"
    },
    {
      "headword": "no"
    },
    {
      "headword": "no one"
    },
    {
      "headword": "nobility"
    },
    {
      "headword": "noble"
    },
    {
      "headword": "nobleman"
    },
    {
      "headword": "nobody"
    },
    {
      "headword": "nod"
    },
    {
      "headword": "nod"
    },
    {
      "headword": "noise"
    },
    {
      "headword": "noisily"
    },
    {
      "headword": "noisy"
    },
    {
      "headword": "nomad"
    },
    {
      "headword": "nomination"
    },
    {
      "headword": "nominee"
    },
    {
      "headword": "none"
    },
    {
      "headword": "nonetheless"
    },
    {
      "headword": "nonprofessional"
    },
    {
      "headword": "nonsense"
    },
    {
      "headword": "non-smoking"
    },
    {
      "headword": "noon"
    },
    {
      "headword": "nor"
    },
    {
      "headword": "normal"
    },
    {
      "headword": "normally"
    },
    {
      "headword": "north"
    },
    {
      "headword": "north"
    },
    {
      "headword": "north"
    },
    {
      "headword": "northeast"
    },
    {
      "headword": "northeast"
    },
    {
      "headword": "northeastern"
    },
    {
      "headword": "northern"
    },
    {
      "headword": "northward"
    },
    {
      "headword": "northwest"
    },
    {
      "headword": "northwest"
    },
    {
      "headword": "northwestern"
    },
    {
      "headword": "nose"
    },
    {
      "headword": "nostril"
    },
    {
      "headword": "not"
    },
    {
      "headword": "note"
    },
    {
      "headword": "note"
    },
    {
      "headword": "notebook"
    },
    {
      "headword": "nothing"
    },
    {
      "headword": "notice"
    },
    {
      "headword": "notice"
    },
    {
      "headword": "noticeable"
    },
    {
      "headword": "noticeboard"
    },
    {
      "headword": "notion"
    },
    {
      "headword": "notorious"
    },
    {
      "headword": "nought"
    },
    {
      "headword": "noun"
    },
    {
      "headword": "nourish"
    },
    {
      "headword": "nourishment"
    },
    {
      "headword": "novel"
    },
    {
      "headword": "novelist"
    },
    {
      "headword": "novelty"
    },
    {
      "headword": "November"
    },
    {
      "headword": "now"
    },
    {
      "headword": "now"
    },
    {
      "headword": "nowadays"
    },
    {
      "headword": "nowhere"
    },
    {
      "headword": "nuclear"
    },
    {
      "headword": "nucleus"
    },
    {
      "headword": "nuisance"
    },
    {
      "headword": "number"
    },
    {
      "headword": "numerical"
    },
    {
      "headword": "numerous"
    },
    {
      "headword": "nurse"
    },
    {
      "headword": "nurse"
    },
    {
      "headword": "nursery"
    },
    {
      "headword": "nut"
    },
    {
      "headword": "nutrient"
    },
    {
      "headword": "nutrition"
    },
    {
      "headword": "nutritious"
    },
    {
      "headword": "nutshell"
    },
    {
      "headword": "oak"
    },
    {
      "headword": "oath"
    },
    {
      "headword": "obedience"
    },
    {
      "headword": "obedient"
    },
    {
      "headword": "obey"
    },
    {
      "headword": "obituary"
    },
    {
      "headword": "object"
    },
    {
      "headword": "object"
    },
    {
      "headword": "objection"
    },
    {
      "headword": "objective"
    },
    {
      "headword": "objective"
    },
    {
      "headword": "obligation"
    },
    {
      "headword": "observation"
    },
    {
      "headword": "observe"
    },
    {
      "headword": "observer"
    },
    {
      "headword": "obsess"
    },
    {
      "headword": "obsession"
    },
    {
      "headword": "obsessive"
    },
    {
      "headword": "obstacle"
    },
    {
      "headword": "obtain"
    },
    {
      "headword": "obvious"
    },
    {
      "headword": "obviously"
    },
    {
      "headword": "occasion"
    },
    {
      "headword": "occasion"
    },
    {
      "headword": "occasional"
    },
    {
      "headword": "occasionally"
    },
    {
      "headword": "occupation"
    },
    {
      "headword": "occupy"
    },
    {
      "headword": "occur"
    },
    {
      "headword": "ocean"
    },
    {
      "headword": "o'clock"
    },
    {
      "headword": "October"
    },
    {
      "headword": "odd"
    },
    {
      "headword": "of"
    },
    {
      "headword": "off"
    },
    {
      "headword": "off"
    },
    {
      "headword": "off"
    },
    {
      "headword": "offend"
    },
    {
      "headword": "offender"
    },
    {
      "headword": "offense/offence"
    },
    {
      "headword": "offensive"
    },
    {
      "headword": "offer"
    },
    {
      "headword": "offer"
    },
    {
      "headword": "offhand"
    },
    {
      "headword": "office"
    },
    {
      "headword": "officer"
    },
    {
      "headword": "official"
    },
    {
      "headword": "official"
    },
    {
      "headword": "officially"
    },
    {
      "headword": "offshore"
    },
    {
      "headword": "often"
    },
    {
      "headword": "oil"
    },
    {
      "headword": "oily"
    },
    {
      "headword": "ointment"
    },
    {
      "headword": "OK/okay"
    },
    {
      "headword": "OK/okay"
    },
    {
      "headword": "old"
    },
    {
      "headword": "old-fashioned"
    },
    {
      "headword": "olive"
    },
    {
      "headword": "olive oil"
    },
    {
      "headword": "Olympia"
    },
    {
      "headword": "Olympiad"
    },
    {
      "headword": "Olympic"
    },
    {
      "headword": "Olympics"
    },
    {
      "headword": "omelet/omelette"
    },
    {
      "headword": "on"
    },
    {
      "headword": "on"
    },
    {
      "headword": "once"
    },
    {
      "headword": "once"
    },
    {
      "headword": "one"
    },
    {
      "headword": "one"
    },
    {
      "headword": "one"
    },
    {
      "headword": "oneself"
    },
    {
      "headword": "onion"
    },
    {
      "headword": "online"
    },
    {
      "headword": "online"
    },
    {
      "headword": "only"
    },
    {
      "headword": "only"
    },
    {
      "headword": "onstage"
    },
    {
      "headword": "onto/on to"
    },
    {
      "headword": "open"
    },
    {
      "headword": "open"
    },
    {
      "headword": "opening"
    },
    {
      "headword": "openly"
    },
    {
      "headword": "opera"
    },
    {
      "headword": "operate"
    },
    {
      "headword": "operation"
    },
    {
      "headword": "operator"
    },
    {
      "headword": "opinion"
    },
    {
      "headword": "opponent"
    },
    {
      "headword": "opportunity"
    },
    {
      "headword": "oppose"
    },
    {
      "headword": "opposite"
    },
    {
      "headword": "opposite"
    },
    {
      "headword": "opposite"
    },
    {
      "headword": "opposite"
    },
    {
      "headword": "opposition"
    },
    {
      "headword": "oppress"
    },
    {
      "headword": "oppression"
    },
    {
      "headword": "optimism"
    },
    {
      "headword": "optimist"
    },
    {
      "headword": "optimistic"
    },
    {
      "headword": "option"
    },
    {
      "headword": "optional"
    },
    {
      "headword": "or"
    },
    {
      "headword": "oral"
    },
    {
      "headword": "oral"
    },
    {
      "headword": "orange"
    },
    {
      "headword": "orange"
    },
    {
      "headword": "orator"
    },
    {
      "headword": "orbit"
    },
    {
      "headword": "orchestra"
    },
    {
      "headword": "orchestral"
    },
    {
      "headword": "orchid"
    },
    {
      "headword": "order"
    },
    {
      "headword": "order"
    },
    {
      "headword": "orderly"
    },
    {
      "headword": "ordinary"
    },
    {
      "headword": "organ"
    },
    {
      "headword": "organic"
    },
    {
      "headword": "organism"
    },
    {
      "headword": "organization/organisation"
    },
    {
      "headword": "organize/organise"
    },
    {
      "headword": "organized/organised"
    },
    {
      "headword": "organizer/organiser"
    },
    {
      "headword": "origin"
    },
    {
      "headword": "original"
    },
    {
      "headword": "original"
    },
    {
      "headword": "originality"
    },
    {
      "headword": "originally"
    },
    {
      "headword": "originate"
    },
    {
      "headword": "ornament"
    },
    {
      "headword": "orphan"
    },
    {
      "headword": "other"
    },
    {
      "headword": "other"
    },
    {
      "headword": "otherwise"
    },
    {
      "headword": "ought to"
    },
    {
      "headword": "ounce"
    },
    {
      "headword": "our"
    },
    {
      "headword": "ours"
    },
    {
      "headword": "ourselves"
    },
    {
      "headword": "out"
    },
    {
      "headword": "out of"
    },
    {
      "headword": "outback"
    },
    {
      "headword": "outbreak"
    },
    {
      "headword": "outcome"
    },
    {
      "headword": "outdistance"
    },
    {
      "headword": "outdo"
    },
    {
      "headword": "outdoor"
    },
    {
      "headword": "outdoors"
    },
    {
      "headword": "outer"
    },
    {
      "headword": "outfit"
    },
    {
      "headword": "outgrow"
    },
    {
      "headword": "outing"
    },
    {
      "headword": "outlaw"
    },
    {
      "headword": "outlet"
    },
    {
      "headword": "outline"
    },
    {
      "headword": "outline"
    },
    {
      "headword": "outlive"
    },
    {
      "headword": "outlook"
    },
    {
      "headword": "out-of-date"
    },
    {
      "headword": "outpatient"
    },
    {
      "headword": "output"
    },
    {
      "headword": "outrage"
    },
    {
      "headword": "outrageous"
    },
    {
      "headword": "outshine"
    },
    {
      "headword": "outside"
    },
    {
      "headword": "outside"
    },
    {
      "headword": "outside"
    },
    {
      "headword": "outside"
    },
    {
      "headword": "outsider"
    },
    {
      "headword": "outskirts"
    },
    {
      "headword": "outstanding"
    },
    {
      "headword": "outward"
    },
    {
      "headword": "outwardly"
    },
    {
      "headword": "outweigh"
    },
    {
      "headword": "oval"
    },
    {
      "headword": "oven"
    },
    {
      "headword": "over"
    },
    {
      "headword": "over"
    },
    {
      "headword": "overall"
    },
    {
      "headword": "overall"
    },
    {
      "headword": "overboard"
    },
    {
      "headword": "overbook"
    },
    {
      "headword": "overcoat"
    },
    {
      "headword": "overcome"
    },
    {
      "headword": "overemphasize/overemphasise"
    },
    {
      "headword": "overestimate"
    },
    {
      "headword": "overhear"
    },
    {
      "headword": "overjoyed"
    },
    {
      "headword": "overlap"
    },
    {
      "headword": "overlook"
    },
    {
      "headword": "overly"
    },
    {
      "headword": "overnight"
    },
    {
      "headword": "overnight"
    },
    {
      "headword": "overseas"
    },
    {
      "headword": "overseas"
    },
    {
      "headword": "overshadow"
    },
    {
      "headword": "oversize"
    },
    {
      "headword": "overstep"
    },
    {
      "headword": "overtake"
    },
    {
      "headword": "overthrow"
    },
    {
      "headword": "overtime"
    },
    {
      "headword": "overtime"
    },
    {
      "headword": "overturn"
    },
    {
      "headword": "overweight"
    },
    {
      "headword": "overwhelm"
    },
    {
      "headword": "overwhelming"
    },
    {
      "headword": "overwork"
    },
    {
      "headword": "ow"
    },
    {
      "headword": "owe"
    },
    {
      "headword": "owing"
    },
    {
      "headword": "owing to"
    },
    {
      "headword": "owl"
    },
    {
      "headword": "own"
    },
    {
      "headword": "own"
    },
    {
      "headword": "own"
    },
    {
      "headword": "owner"
    },
    {
      "headword": "ox"
    },
    {
      "headword": "oxygen"
    },
    {
      "headword": "ozone"
    },
    {
      "headword": "p.m./P.M./pm/PM"
    },
    {
      "headword": "pa"
    },
    {
      "headword": "pace"
    },
    {
      "headword": "pacific"
    },
    {
      "headword": "pack"
    },
    {
      "headword": "pack"
    },
    {
      "headword": "package"
    },
    {
      "headword": "packed"
    },
    {
      "headword": "packet"
    },
    {
      "headword": "packing"
    },
    {
      "headword": "pad"
    },
    {
      "headword": "paddle"
    },
    {
      "headword": "page"
    },
    {
      "headword": "paid"
    },
    {
      "headword": "pain"
    },
    {
      "headword": "painful"
    },
    {
      "headword": "paint"
    },
    {
      "headword": "paint"
    },
    {
      "headword": "paintbrush"
    },
    {
      "headword": "painter"
    },
    {
      "headword": "painting"
    },
    {
      "headword": "pair"
    },
    {
      "headword": "pajamas/pyjamas"
    },
    {
      "headword": "pal"
    },
    {
      "headword": "palace"
    },
    {
      "headword": "pale"
    },
    {
      "headword": "pallet"
    },
    {
      "headword": "palm"
    },
    {
      "headword": "pan"
    },
    {
      "headword": "pancake"
    },
    {
      "headword": "pandemic"
    },
    {
      "headword": "panel"
    },
    {
      "headword": "panic"
    },
    {
      "headword": "panic"
    },
    {
      "headword": "pants"
    },
    {
      "headword": "papaya"
    },
    {
      "headword": "paper"
    },
    {
      "headword": "paperless"
    },
    {
      "headword": "paperwork"
    },
    {
      "headword": "parachute"
    },
    {
      "headword": "parade"
    },
    {
      "headword": "paradise"
    },
    {
      "headword": "paradox"
    },
    {
      "headword": "paragraph"
    },
    {
      "headword": "paralysis"
    },
    {
      "headword": "paralyze/paralyse"
    },
    {
      "headword": "paramedic"
    },
    {
      "headword": "paratrooper"
    },
    {
      "headword": "parcel"
    },
    {
      "headword": "pardon"
    },
    {
      "headword": "pardon"
    },
    {
      "headword": "parent"
    },
    {
      "headword": "parental"
    },
    {
      "headword": "park"
    },
    {
      "headword": "park"
    },
    {
      "headword": "parking"
    },
    {
      "headword": "parliament"
    },
    {
      "headword": "parrot"
    },
    {
      "headword": "part"
    },
    {
      "headword": "part"
    },
    {
      "headword": "partial"
    },
    {
      "headword": "participant"
    },
    {
      "headword": "participate"
    },
    {
      "headword": "participation"
    },
    {
      "headword": "participle"
    },
    {
      "headword": "particle"
    },
    {
      "headword": "particular"
    },
    {
      "headword": "particularly"
    },
    {
      "headword": "partisan"
    },
    {
      "headword": "partly"
    },
    {
      "headword": "partner"
    },
    {
      "headword": "partnership"
    },
    {
      "headword": "part-time"
    },
    {
      "headword": "part-time"
    },
    {
      "headword": "party"
    },
    {
      "headword": "pass"
    },
    {
      "headword": "pass"
    },
    {
      "headword": "passage"
    },
    {
      "headword": "passenger"
    },
    {
      "headword": "passion"
    },
    {
      "headword": "passionate"
    },
    {
      "headword": "passionately"
    },
    {
      "headword": "passive"
    },
    {
      "headword": "passport"
    },
    {
      "headword": "password"
    },
    {
      "headword": "past"
    },
    {
      "headword": "past"
    },
    {
      "headword": "past"
    },
    {
      "headword": "pasta"
    },
    {
      "headword": "pastor"
    },
    {
      "headword": "pastoral"
    },
    {
      "headword": "patch"
    },
    {
      "headword": "path"
    },
    {
      "headword": "patience"
    },
    {
      "headword": "patient"
    },
    {
      "headword": "patient"
    },
    {
      "headword": "patiently"
    },
    {
      "headword": "patriot"
    },
    {
      "headword": "patriotic"
    },
    {
      "headword": "patriotism"
    },
    {
      "headword": "patrol"
    },
    {
      "headword": "patron"
    },
    {
      "headword": "pattern"
    },
    {
      "headword": "pause"
    },
    {
      "headword": "pause"
    },
    {
      "headword": "pave"
    },
    {
      "headword": "pavement"
    },
    {
      "headword": "paw"
    },
    {
      "headword": "pawnbroker"
    },
    {
      "headword": "pawnshop"
    },
    {
      "headword": "pay"
    },
    {
      "headword": "pay"
    },
    {
      "headword": "payment"
    },
    {
      "headword": "PC"
    },
    {
      "headword": "pea"
    },
    {
      "headword": "peace"
    },
    {
      "headword": "peaceful"
    },
    {
      "headword": "peacefully"
    },
    {
      "headword": "peach"
    },
    {
      "headword": "peak"
    },
    {
      "headword": "peanut"
    },
    {
      "headword": "pear"
    },
    {
      "headword": "pearl"
    },
    {
      "headword": "pebble"
    },
    {
      "headword": "peculiar"
    },
    {
      "headword": "pedal"
    },
    {
      "headword": "pedantic"
    },
    {
      "headword": "pedestrian"
    },
    {
      "headword": "pee"
    },
    {
      "headword": "peel"
    },
    {
      "headword": "peel"
    },
    {
      "headword": "peep"
    },
    {
      "headword": "peer"
    },
    {
      "headword": "peg"
    },
    {
      "headword": "pen"
    },
    {
      "headword": "penalize/penalise"
    },
    {
      "headword": "penalty"
    },
    {
      "headword": "pence"
    },
    {
      "headword": "pencil"
    },
    {
      "headword": "penetrate"
    },
    {
      "headword": "penfriend/pen friend"
    },
    {
      "headword": "penguin"
    },
    {
      "headword": "penicillin"
    },
    {
      "headword": "penniless"
    },
    {
      "headword": "penny"
    },
    {
      "headword": "pension"
    },
    {
      "headword": "pentagon"
    },
    {
      "headword": "people"
    },
    {
      "headword": "pepper"
    },
    {
      "headword": "per"
    },
    {
      "headword": "perceive"
    },
    {
      "headword": "percent/per cent"
    },
    {
      "headword": "percentage"
    },
    {
      "headword": "perception"
    },
    {
      "headword": "perfect"
    },
    {
      "headword": "perfectly"
    },
    {
      "headword": "perform"
    },
    {
      "headword": "performance"
    },
    {
      "headword": "performer"
    },
    {
      "headword": "perfume"
    },
    {
      "headword": "perhaps"
    },
    {
      "headword": "period"
    },
    {
      "headword": "permanence"
    },
    {
      "headword": "permanent"
    },
    {
      "headword": "permanently"
    },
    {
      "headword": "permeate"
    },
    {
      "headword": "permission"
    },
    {
      "headword": "permit"
    },
    {
      "headword": "perseverance"
    },
    {
      "headword": "persist"
    },
    {
      "headword": "persistence"
    },
    {
      "headword": "persistent"
    },
    {
      "headword": "person"
    },
    {
      "headword": "personal"
    },
    {
      "headword": "personality"
    },
    {
      "headword": "personally"
    },
    {
      "headword": "personification"
    },
    {
      "headword": "personify"
    },
    {
      "headword": "personnel"
    },
    {
      "headword": "perspective"
    },
    {
      "headword": "perspiration"
    },
    {
      "headword": "persuade"
    },
    {
      "headword": "persuasion"
    },
    {
      "headword": "persuasive"
    },
    {
      "headword": "pessimist"
    },
    {
      "headword": "pessimistic"
    },
    {
      "headword": "pet"
    },
    {
      "headword": "petrified"
    },
    {
      "headword": "petrol"
    },
    {
      "headword": "petrol station"
    },
    {
      "headword": "petty"
    },
    {
      "headword": "pH"
    },
    {
      "headword": "phantom"
    },
    {
      "headword": "pharmacist"
    },
    {
      "headword": "pharmacy"
    },
    {
      "headword": "phase"
    },
    {
      "headword": "phenomenon"
    },
    {
      "headword": "philosopher"
    },
    {
      "headword": "philosophical"
    },
    {
      "headword": "philosophy"
    },
    {
      "headword": "phoenix"
    },
    {
      "headword": "phone"
    },
    {
      "headword": "phone"
    },
    {
      "headword": "photo"
    },
    {
      "headword": "photocopy"
    },
    {
      "headword": "photograph"
    },
    {
      "headword": "photograph"
    },
    {
      "headword": "photographer"
    },
    {
      "headword": "photography"
    },
    {
      "headword": "phrasal verb"
    },
    {
      "headword": "phrase"
    },
    {
      "headword": "physical"
    },
    {
      "headword": "physically"
    },
    {
      "headword": "physician"
    },
    {
      "headword": "physics"
    },
    {
      "headword": "pi"
    },
    {
      "headword": "piano"
    },
    {
      "headword": "pick"
    },
    {
      "headword": "pick"
    },
    {
      "headword": "pickle"
    },
    {
      "headword": "picky"
    },
    {
      "headword": "picnic"
    },
    {
      "headword": "picture"
    },
    {
      "headword": "picture"
    },
    {
      "headword": "picturesque"
    },
    {
      "headword": "pie"
    },
    {
      "headword": "piece"
    },
    {
      "headword": "piety"
    },
    {
      "headword": "pig"
    },
    {
      "headword": "pile"
    },
    {
      "headword": "pilgrim"
    },
    {
      "headword": "pill"
    },
    {
      "headword": "pillow"
    },
    {
      "headword": "pillowcase"
    },
    {
      "headword": "pilot"
    },
    {
      "headword": "pin"
    },
    {
      "headword": "pin"
    },
    {
      "headword": "pine"
    },
    {
      "headword": "pineapple"
    },
    {
      "headword": "pink"
    },
    {
      "headword": "pink"
    },
    {
      "headword": "pint"
    },
    {
      "headword": "pipe"
    },
    {
      "headword": "piracy"
    },
    {
      "headword": "pirate"
    },
    {
      "headword": "pit"
    },
    {
      "headword": "pitch"
    },
    {
      "headword": "pitch"
    },
    {
      "headword": "pity"
    },
    {
      "headword": "pizza"
    },
    {
      "headword": "place"
    },
    {
      "headword": "place"
    },
    {
      "headword": "plague"
    },
    {
      "headword": "plain"
    },
    {
      "headword": "plan"
    },
    {
      "headword": "plan"
    },
    {
      "headword": "plane"
    },
    {
      "headword": "planet"
    },
    {
      "headword": "planning"
    },
    {
      "headword": "plant"
    },
    {
      "headword": "plant"
    },
    {
      "headword": "plastic"
    },
    {
      "headword": "plastic"
    },
    {
      "headword": "plate"
    },
    {
      "headword": "platform"
    },
    {
      "headword": "play"
    },
    {
      "headword": "play"
    },
    {
      "headword": "player"
    },
    {
      "headword": "playful"
    },
    {
      "headword": "playground"
    },
    {
      "headword": "playmate"
    },
    {
      "headword": "playwright"
    },
    {
      "headword": "plead"
    },
    {
      "headword": "pleasant"
    },
    {
      "headword": "pleasantly"
    },
    {
      "headword": "please"
    },
    {
      "headword": "please"
    },
    {
      "headword": "pleased"
    },
    {
      "headword": "pleasing"
    },
    {
      "headword": "pleasure"
    },
    {
      "headword": "plenty"
    },
    {
      "headword": "plenty"
    },
    {
      "headword": "plot"
    },
    {
      "headword": "pluck"
    },
    {
      "headword": "plug"
    },
    {
      "headword": "plug"
    },
    {
      "headword": "plum"
    },
    {
      "headword": "plumber"
    },
    {
      "headword": "plural"
    },
    {
      "headword": "plus"
    },
    {
      "headword": "plus"
    },
    {
      "headword": "plus"
    },
    {
      "headword": "pneumonia"
    },
    {
      "headword": "pocket"
    },
    {
      "headword": "pocket money"
    },
    {
      "headword": "poem"
    },
    {
      "headword": "poet"
    },
    {
      "headword": "poetry"
    },
    {
      "headword": "point"
    },
    {
      "headword": "point"
    },
    {
      "headword": "point of view"
    },
    {
      "headword": "pointless"
    },
    {
      "headword": "poison"
    },
    {
      "headword": "poison"
    },
    {
      "headword": "poisonous"
    },
    {
      "headword": "polar bear"
    },
    {
      "headword": "pole"
    },
    {
      "headword": "police"
    },
    {
      "headword": "police officer"
    },
    {
      "headword": "police station"
    },
    {
      "headword": "policeman"
    },
    {
      "headword": "policewoman"
    },
    {
      "headword": "policy"
    },
    {
      "headword": "polio"
    },
    {
      "headword": "polish"
    },
    {
      "headword": "polite"
    },
    {
      "headword": "politely"
    },
    {
      "headword": "politeness"
    },
    {
      "headword": "political"
    },
    {
      "headword": "politically"
    },
    {
      "headword": "politician"
    },
    {
      "headword": "politics"
    },
    {
      "headword": "polity"
    },
    {
      "headword": "pollutant"
    },
    {
      "headword": "pollute"
    },
    {
      "headword": "pollution"
    },
    {
      "headword": "polo"
    },
    {
      "headword": "pond"
    },
    {
      "headword": "ponder"
    },
    {
      "headword": "pool"
    },
    {
      "headword": "poor"
    },
    {
      "headword": "pop"
    },
    {
      "headword": "pop"
    },
    {
      "headword": "popcorn"
    },
    {
      "headword": "popular"
    },
    {
      "headword": "popularity"
    },
    {
      "headword": "popularize/popularise"
    },
    {
      "headword": "population"
    },
    {
      "headword": "porch"
    },
    {
      "headword": "pork"
    },
    {
      "headword": "port"
    },
    {
      "headword": "portion"
    },
    {
      "headword": "portrait"
    },
    {
      "headword": "pose"
    },
    {
      "headword": "posh"
    },
    {
      "headword": "position"
    },
    {
      "headword": "positive"
    },
    {
      "headword": "positively"
    },
    {
      "headword": "possess"
    },
    {
      "headword": "possessed"
    },
    {
      "headword": "possession"
    },
    {
      "headword": "possessive"
    },
    {
      "headword": "possibility"
    },
    {
      "headword": "possible"
    },
    {
      "headword": "possibly"
    },
    {
      "headword": "post"
    },
    {
      "headword": "post"
    },
    {
      "headword": "post office"
    },
    {
      "headword": "postal"
    },
    {
      "headword": "postcard"
    },
    {
      "headword": "poster"
    },
    {
      "headword": "postman"
    },
    {
      "headword": "postpone"
    },
    {
      "headword": "pot"
    },
    {
      "headword": "potato"
    },
    {
      "headword": "potent"
    },
    {
      "headword": "potential"
    },
    {
      "headword": "potential"
    },
    {
      "headword": "potentially"
    },
    {
      "headword": "pottery"
    },
    {
      "headword": "pound"
    },
    {
      "headword": "pound"
    },
    {
      "headword": "pour"
    },
    {
      "headword": "poverty"
    },
    {
      "headword": "powder"
    },
    {
      "headword": "powder"
    },
    {
      "headword": "power"
    },
    {
      "headword": "powerful"
    },
    {
      "headword": "powerfully"
    },
    {
      "headword": "practical"
    },
    {
      "headword": "practicality"
    },
    {
      "headword": "practically"
    },
    {
      "headword": "practice"
    },
    {
      "headword": "practice/practise"
    },
    {
      "headword": "praise"
    },
    {
      "headword": "praise"
    },
    {
      "headword": "prance"
    },
    {
      "headword": "prawn"
    },
    {
      "headword": "pray"
    },
    {
      "headword": "prayer"
    },
    {
      "headword": "precede"
    },
    {
      "headword": "precious"
    },
    {
      "headword": "precise"
    },
    {
      "headword": "precisely"
    },
    {
      "headword": "predicament"
    },
    {
      "headword": "predicate"
    },
    {
      "headword": "predicative"
    },
    {
      "headword": "predict"
    },
    {
      "headword": "predictable"
    },
    {
      "headword": "prediction"
    },
    {
      "headword": "predictive"
    },
    {
      "headword": "predictor"
    },
    {
      "headword": "prefect"
    },
    {
      "headword": "prefer"
    },
    {
      "headword": "preferable"
    },
    {
      "headword": "preferably"
    },
    {
      "headword": "preference"
    },
    {
      "headword": "prefix"
    },
    {
      "headword": "pregnant"
    },
    {
      "headword": "prehistoric"
    },
    {
      "headword": "prehuman"
    },
    {
      "headword": "preindustrial"
    },
    {
      "headword": "prejudge"
    },
    {
      "headword": "prejudice"
    },
    {
      "headword": "preliminary"
    },
    {
      "headword": "preoccupy"
    },
    {
      "headword": "preparation"
    },
    {
      "headword": "prepare"
    },
    {
      "headword": "prepared"
    },
    {
      "headword": "preposition"
    },
    {
      "headword": "preschool"
    },
    {
      "headword": "prescribe"
    },
    {
      "headword": "prescription"
    },
    {
      "headword": "presence"
    },
    {
      "headword": "present"
    },
    {
      "headword": "present"
    },
    {
      "headword": "present"
    },
    {
      "headword": "presentation"
    },
    {
      "headword": "presenter"
    },
    {
      "headword": "preservation"
    },
    {
      "headword": "preserve"
    },
    {
      "headword": "presidency"
    },
    {
      "headword": "president"
    },
    {
      "headword": "presidential"
    },
    {
      "headword": "press"
    },
    {
      "headword": "press"
    },
    {
      "headword": "pressure"
    },
    {
      "headword": "prestige"
    },
    {
      "headword": "prestigious"
    },
    {
      "headword": "presumably"
    },
    {
      "headword": "pretend"
    },
    {
      "headword": "pretend"
    },
    {
      "headword": "pretty"
    },
    {
      "headword": "pretty"
    },
    {
      "headword": "prevail"
    },
    {
      "headword": "prevent"
    },
    {
      "headword": "prevention"
    },
    {
      "headword": "preventive"
    },
    {
      "headword": "previous"
    },
    {
      "headword": "previously"
    },
    {
      "headword": "price"
    },
    {
      "headword": "price"
    },
    {
      "headword": "priceless"
    },
    {
      "headword": "prick"
    },
    {
      "headword": "pride"
    },
    {
      "headword": "priest"
    },
    {
      "headword": "primarily"
    },
    {
      "headword": "primary"
    },
    {
      "headword": "primary school"
    },
    {
      "headword": "prime"
    },
    {
      "headword": "prime minister"
    },
    {
      "headword": "primitive"
    },
    {
      "headword": "prince"
    },
    {
      "headword": "princess"
    },
    {
      "headword": "principal"
    },
    {
      "headword": "principal"
    },
    {
      "headword": "principle"
    },
    {
      "headword": "print"
    },
    {
      "headword": "print"
    },
    {
      "headword": "printer"
    },
    {
      "headword": "prior"
    },
    {
      "headword": "priority"
    },
    {
      "headword": "prison"
    },
    {
      "headword": "prisoner"
    },
    {
      "headword": "privacy"
    },
    {
      "headword": "private"
    },
    {
      "headword": "privately"
    },
    {
      "headword": "privilege"
    },
    {
      "headword": "prize"
    },
    {
      "headword": "pro"
    },
    {
      "headword": "probability"
    },
    {
      "headword": "probable"
    },
    {
      "headword": "probably"
    },
    {
      "headword": "probe"
    },
    {
      "headword": "problem"
    },
    {
      "headword": "procedure"
    },
    {
      "headword": "proceed"
    },
    {
      "headword": "process"
    },
    {
      "headword": "process"
    },
    {
      "headword": "proclaim"
    },
    {
      "headword": "procrastination"
    },
    {
      "headword": "produce"
    },
    {
      "headword": "producer"
    },
    {
      "headword": "product"
    },
    {
      "headword": "production"
    },
    {
      "headword": "productive"
    },
    {
      "headword": "profession"
    },
    {
      "headword": "professional"
    },
    {
      "headword": "professional"
    },
    {
      "headword": "professor"
    },
    {
      "headword": "profile"
    },
    {
      "headword": "profit"
    },
    {
      "headword": "profitable"
    },
    {
      "headword": "program/programme"
    },
    {
      "headword": "program/programme"
    },
    {
      "headword": "programmer"
    },
    {
      "headword": "programming"
    },
    {
      "headword": "progress"
    },
    {
      "headword": "progress"
    },
    {
      "headword": "progressive"
    },
    {
      "headword": "prohibit"
    },
    {
      "headword": "prohibition"
    },
    {
      "headword": "project"
    },
    {
      "headword": "project"
    },
    {
      "headword": "projection"
    },
    {
      "headword": "prom"
    },
    {
      "headword": "prominence"
    },
    {
      "headword": "prominent"
    },
    {
      "headword": "promise"
    },
    {
      "headword": "promise"
    },
    {
      "headword": "promote"
    },
    {
      "headword": "promotion"
    },
    {
      "headword": "prompt"
    },
    {
      "headword": "prompt"
    },
    {
      "headword": "prompt"
    },
    {
      "headword": "promptly"
    },
    {
      "headword": "pronoun"
    },
    {
      "headword": "pronounce"
    },
    {
      "headword": "pronunciation"
    },
    {
      "headword": "proof"
    },
    {
      "headword": "proper"
    },
    {
      "headword": "properly"
    },
    {
      "headword": "property"
    },
    {
      "headword": "proponent"
    },
    {
      "headword": "proportion"
    },
    {
      "headword": "proposal"
    },
    {
      "headword": "propose"
    },
    {
      "headword": "proposed"
    },
    {
      "headword": "prose"
    },
    {
      "headword": "prosecute"
    },
    {
      "headword": "prospect"
    },
    {
      "headword": "prosper"
    },
    {
      "headword": "prosperity"
    },
    {
      "headword": "prosperous"
    },
    {
      "headword": "protect"
    },
    {
      "headword": "protection"
    },
    {
      "headword": "protective"
    },
    {
      "headword": "protest"
    },
    {
      "headword": "protest"
    },
    {
      "headword": "proud"
    },
    {
      "headword": "proudly"
    },
    {
      "headword": "prove"
    },
    {
      "headword": "proven"
    },
    {
      "headword": "proverb"
    },
    {
      "headword": "provide"
    },
    {
      "headword": "provided"
    },
    {
      "headword": "province"
    },
    {
      "headword": "provision"
    },
    {
      "headword": "proximity"
    },
    {
      "headword": "psychological"
    },
    {
      "headword": "psychologically"
    },
    {
      "headword": "psychologist"
    },
    {
      "headword": "psychology"
    },
    {
      "headword": "pub"
    },
    {
      "headword": "public"
    },
    {
      "headword": "public"
    },
    {
      "headword": "public transport"
    },
    {
      "headword": "publication"
    },
    {
      "headword": "publicity"
    },
    {
      "headword": "publicize/publicise"
    },
    {
      "headword": "publicly"
    },
    {
      "headword": "publish"
    },
    {
      "headword": "publisher"
    },
    {
      "headword": "pudding"
    },
    {
      "headword": "pull"
    },
    {
      "headword": "pullover"
    },
    {
      "headword": "pulse"
    },
    {
      "headword": "pump"
    },
    {
      "headword": "pumpkin"
    },
    {
      "headword": "punch"
    },
    {
      "headword": "punch"
    },
    {
      "headword": "punctual"
    },
    {
      "headword": "punctuality"
    },
    {
      "headword": "punctuation"
    },
    {
      "headword": "punish"
    },
    {
      "headword": "punishment"
    },
    {
      "headword": "pupil"
    },
    {
      "headword": "puppy"
    },
    {
      "headword": "purchase"
    },
    {
      "headword": "purchase"
    },
    {
      "headword": "pure"
    },
    {
      "headword": "purify"
    },
    {
      "headword": "purple"
    },
    {
      "headword": "purple"
    },
    {
      "headword": "purpose"
    },
    {
      "headword": "purposeful"
    },
    {
      "headword": "purse"
    },
    {
      "headword": "pursue"
    },
    {
      "headword": "pursuit"
    },
    {
      "headword": "push"
    },
    {
      "headword": "push"
    },
    {
      "headword": "put"
    },
    {
      "headword": "puzzle"
    },
    {
      "headword": "puzzled"
    },
    {
      "headword": "quake"
    },
    {
      "headword": "qualification"
    },
    {
      "headword": "qualified"
    },
    {
      "headword": "qualify"
    },
    {
      "headword": "quality"
    },
    {
      "headword": "quality"
    },
    {
      "headword": "quantify"
    },
    {
      "headword": "quantity"
    },
    {
      "headword": "quarantine"
    },
    {
      "headword": "quarrel"
    },
    {
      "headword": "quarrel"
    },
    {
      "headword": "quarrelsome"
    },
    {
      "headword": "quarter"
    },
    {
      "headword": "queen"
    },
    {
      "headword": "queer"
    },
    {
      "headword": "query"
    },
    {
      "headword": "question"
    },
    {
      "headword": "question"
    },
    {
      "headword": "question mark"
    },
    {
      "headword": "questionnaire"
    },
    {
      "headword": "queue"
    },
    {
      "headword": "queue"
    },
    {
      "headword": "quick"
    },
    {
      "headword": "quickly"
    },
    {
      "headword": "quiet"
    },
    {
      "headword": "quiet"
    },
    {
      "headword": "quietly"
    },
    {
      "headword": "quit"
    },
    {
      "headword": "quit"
    },
    {
      "headword": "quite"
    },
    {
      "headword": "quiz"
    },
    {
      "headword": "quotable"
    },
    {
      "headword": "quotation"
    },
    {
      "headword": "quote"
    },
    {
      "headword": "quote"
    },
    {
      "headword": "rabbit"
    },
    {
      "headword": "race"
    },
    {
      "headword": "race"
    },
    {
      "headword": "racial"
    },
    {
      "headword": "racism"
    },
    {
      "headword": "racist"
    },
    {
      "headword": "rack"
    },
    {
      "headword": "racket"
    },
    {
      "headword": "radar"
    },
    {
      "headword": "radiate"
    },
    {
      "headword": "radiation"
    },
    {
      "headword": "radical"
    },
    {
      "headword": "radically"
    },
    {
      "headword": "radio"
    },
    {
      "headword": "radium"
    },
    {
      "headword": "rafter"
    },
    {
      "headword": "rag"
    },
    {
      "headword": "rage"
    },
    {
      "headword": "rail"
    },
    {
      "headword": "railroad"
    },
    {
      "headword": "railway"
    },
    {
      "headword": "rain"
    },
    {
      "headword": "rain"
    },
    {
      "headword": "rainbow"
    },
    {
      "headword": "raincoat"
    },
    {
      "headword": "rainfall"
    },
    {
      "headword": "rainforest"
    },
    {
      "headword": "rainstorm"
    },
    {
      "headword": "rainy"
    },
    {
      "headword": "raise"
    },
    {
      "headword": "rally"
    },
    {
      "headword": "ram"
    },
    {
      "headword": "ramp"
    },
    {
      "headword": "range"
    },
    {
      "headword": "range"
    },
    {
      "headword": "ranger"
    },
    {
      "headword": "rank"
    },
    {
      "headword": "rap"
    },
    {
      "headword": "rap"
    },
    {
      "headword": "rape"
    },
    {
      "headword": "rape"
    },
    {
      "headword": "rapid"
    },
    {
      "headword": "rapidly"
    },
    {
      "headword": "rare"
    },
    {
      "headword": "rarely"
    },
    {
      "headword": "rash"
    },
    {
      "headword": "raspberry"
    },
    {
      "headword": "rat"
    },
    {
      "headword": "rate"
    },
    {
      "headword": "rate"
    },
    {
      "headword": "rather"
    },
    {
      "headword": "rating"
    },
    {
      "headword": "ration"
    },
    {
      "headword": "rational"
    },
    {
      "headword": "rattle"
    },
    {
      "headword": "ravage"
    },
    {
      "headword": "raw"
    },
    {
      "headword": "ray"
    },
    {
      "headword": "razor"
    },
    {
      "headword": "re"
    },
    {
      "headword": "reach"
    },
    {
      "headword": "reach"
    },
    {
      "headword": "react"
    },
    {
      "headword": "reaction"
    },
    {
      "headword": "read"
    },
    {
      "headword": "reader"
    },
    {
      "headword": "readily"
    },
    {
      "headword": "reading"
    },
    {
      "headword": "ready"
    },
    {
      "headword": "real"
    },
    {
      "headword": "real"
    },
    {
      "headword": "real estate"
    },
    {
      "headword": "realistic"
    },
    {
      "headword": "reality"
    },
    {
      "headword": "realization/realisation"
    },
    {
      "headword": "realize/realise"
    },
    {
      "headword": "really"
    },
    {
      "headword": "rear"
    },
    {
      "headword": "rearrange"
    },
    {
      "headword": "reason"
    },
    {
      "headword": "reasonable"
    },
    {
      "headword": "reasonably"
    },
    {
      "headword": "rebel"
    },
    {
      "headword": "rebel"
    },
    {
      "headword": "rebellious"
    },
    {
      "headword": "rebuild"
    },
    {
      "headword": "recall"
    },
    {
      "headword": "receipt"
    },
    {
      "headword": "receive"
    },
    {
      "headword": "recent"
    },
    {
      "headword": "recently"
    },
    {
      "headword": "reception"
    },
    {
      "headword": "receptionist"
    },
    {
      "headword": "recession"
    },
    {
      "headword": "recipe"
    },
    {
      "headword": "recite"
    },
    {
      "headword": "reckon"
    },
    {
      "headword": "reclaim"
    },
    {
      "headword": "recognition"
    },
    {
      "headword": "recognize/recognise"
    },
    {
      "headword": "recollect"
    },
    {
      "headword": "recollection"
    },
    {
      "headword": "recommend"
    },
    {
      "headword": "recommendable"
    },
    {
      "headword": "recommendation"
    },
    {
      "headword": "reconsider"
    },
    {
      "headword": "record"
    },
    {
      "headword": "record"
    },
    {
      "headword": "recording"
    },
    {
      "headword": "recover"
    },
    {
      "headword": "recovery"
    },
    {
      "headword": "recreation"
    },
    {
      "headword": "recruit"
    },
    {
      "headword": "rectangular"
    },
    {
      "headword": "recycle"
    },
    {
      "headword": "recycled"
    },
    {
      "headword": "recycling"
    },
    {
      "headword": "red"
    },
    {
      "headword": "red"
    },
    {
      "headword": "redo"
    },
    {
      "headword": "reduce"
    },
    {
      "headword": "reduction"
    },
    {
      "headword": "redundant"
    },
    {
      "headword": "reed"
    },
    {
      "headword": "reef"
    },
    {
      "headword": "refer"
    },
    {
      "headword": "referee"
    },
    {
      "headword": "reference"
    },
    {
      "headword": "referent"
    },
    {
      "headword": "refinery"
    },
    {
      "headword": "reflect"
    },
    {
      "headword": "reflection"
    },
    {
      "headword": "reflective"
    },
    {
      "headword": "reform"
    },
    {
      "headword": "refrain"
    },
    {
      "headword": "refresh"
    },
    {
      "headword": "refreshments"
    },
    {
      "headword": "refrigerator"
    },
    {
      "headword": "refuge"
    },
    {
      "headword": "refugee"
    },
    {
      "headword": "refund"
    },
    {
      "headword": "refusal"
    },
    {
      "headword": "refuse"
    },
    {
      "headword": "refuse"
    },
    {
      "headword": "refute"
    },
    {
      "headword": "regain"
    },
    {
      "headword": "regard"
    },
    {
      "headword": "regard"
    },
    {
      "headword": "regarding"
    },
    {
      "headword": "regardless"
    },
    {
      "headword": "reggae"
    },
    {
      "headword": "regime"
    },
    {
      "headword": "region"
    },
    {
      "headword": "regional"
    },
    {
      "headword": "register"
    },
    {
      "headword": "register"
    },
    {
      "headword": "registration"
    },
    {
      "headword": "regret"
    },
    {
      "headword": "regret"
    },
    {
      "headword": "regrettably"
    },
    {
      "headword": "regular"
    },
    {
      "headword": "regularly"
    },
    {
      "headword": "regulate"
    },
    {
      "headword": "regulation"
    },
    {
      "headword": "rehearsal"
    },
    {
      "headword": "reinforce"
    },
    {
      "headword": "reinforcement"
    },
    {
      "headword": "reject"
    },
    {
      "headword": "rejection"
    },
    {
      "headword": "rejoin"
    },
    {
      "headword": "relate"
    },
    {
      "headword": "related"
    },
    {
      "headword": "relation"
    },
    {
      "headword": "relationship"
    },
    {
      "headword": "relative"
    },
    {
      "headword": "relative"
    },
    {
      "headword": "relatively"
    },
    {
      "headword": "relativity"
    },
    {
      "headword": "relax"
    },
    {
      "headword": "relaxation"
    },
    {
      "headword": "relaxed"
    },
    {
      "headword": "relaxing"
    },
    {
      "headword": "relay"
    },
    {
      "headword": "release"
    },
    {
      "headword": "release"
    },
    {
      "headword": "relevant"
    },
    {
      "headword": "reliable"
    },
    {
      "headword": "relic"
    },
    {
      "headword": "relief"
    },
    {
      "headword": "relieve"
    },
    {
      "headword": "relieved"
    },
    {
      "headword": "religion"
    },
    {
      "headword": "religious"
    },
    {
      "headword": "reluctant"
    },
    {
      "headword": "rely"
    },
    {
      "headword": "remain"
    },
    {
      "headword": "remainder"
    },
    {
      "headword": "remaining"
    },
    {
      "headword": "remains"
    },
    {
      "headword": "remark"
    },
    {
      "headword": "remark"
    },
    {
      "headword": "remarkable"
    },
    {
      "headword": "remarkably"
    },
    {
      "headword": "remedy"
    },
    {
      "headword": "remember"
    },
    {
      "headword": "remembrance"
    },
    {
      "headword": "remind"
    },
    {
      "headword": "reminder"
    },
    {
      "headword": "remote"
    },
    {
      "headword": "remote control"
    },
    {
      "headword": "remove"
    },
    {
      "headword": "renew"
    },
    {
      "headword": "rent"
    },
    {
      "headword": "rent"
    },
    {
      "headword": "rental"
    },
    {
      "headword": "reorganize/reorganise"
    },
    {
      "headword": "repaint"
    },
    {
      "headword": "repair"
    },
    {
      "headword": "repair"
    },
    {
      "headword": "repay"
    },
    {
      "headword": "repeat"
    },
    {
      "headword": "repeatedly"
    },
    {
      "headword": "repertoire"
    },
    {
      "headword": "repetition"
    },
    {
      "headword": "replace"
    },
    {
      "headword": "replacement"
    },
    {
      "headword": "replica"
    },
    {
      "headword": "reply"
    },
    {
      "headword": "reply"
    },
    {
      "headword": "report"
    },
    {
      "headword": "report"
    },
    {
      "headword": "reporter"
    },
    {
      "headword": "represent"
    },
    {
      "headword": "representative"
    },
    {
      "headword": "repress"
    },
    {
      "headword": "repression"
    },
    {
      "headword": "reprint"
    },
    {
      "headword": "reproduce"
    },
    {
      "headword": "reprove"
    },
    {
      "headword": "republic"
    },
    {
      "headword": "reputation"
    },
    {
      "headword": "request"
    },
    {
      "headword": "request"
    },
    {
      "headword": "require"
    },
    {
      "headword": "requirement"
    },
    {
      "headword": "rescue"
    },
    {
      "headword": "rescue"
    },
    {
      "headword": "research"
    },
    {
      "headword": "research"
    },
    {
      "headword": "researcher"
    },
    {
      "headword": "resemble"
    },
    {
      "headword": "reservation"
    },
    {
      "headword": "reserve"
    },
    {
      "headword": "reserve"
    },
    {
      "headword": "residence"
    },
    {
      "headword": "resident"
    },
    {
      "headword": "resident"
    },
    {
      "headword": "residential"
    },
    {
      "headword": "resign"
    },
    {
      "headword": "resignation"
    },
    {
      "headword": "resist"
    },
    {
      "headword": "resistance"
    },
    {
      "headword": "resolution"
    },
    {
      "headword": "resolve"
    },
    {
      "headword": "resonant"
    },
    {
      "headword": "resort"
    },
    {
      "headword": "resource"
    },
    {
      "headword": "respect"
    },
    {
      "headword": "respect"
    },
    {
      "headword": "respectable"
    },
    {
      "headword": "respectably"
    },
    {
      "headword": "respected"
    },
    {
      "headword": "respiration"
    },
    {
      "headword": "respiratory"
    },
    {
      "headword": "respond"
    },
    {
      "headword": "response"
    },
    {
      "headword": "responsibility"
    },
    {
      "headword": "responsible"
    },
    {
      "headword": "rest"
    },
    {
      "headword": "rest"
    },
    {
      "headword": "restaurant"
    },
    {
      "headword": "restore"
    },
    {
      "headword": "restrict"
    },
    {
      "headword": "restriction"
    },
    {
      "headword": "result"
    },
    {
      "headword": "result"
    },
    {
      "headword": "resume"
    },
    {
      "headword": "retail"
    },
    {
      "headword": "retailer"
    },
    {
      "headword": "retain"
    },
    {
      "headword": "retard"
    },
    {
      "headword": "retell"
    },
    {
      "headword": "retina"
    },
    {
      "headword": "retire"
    },
    {
      "headword": "retired"
    },
    {
      "headword": "retirement"
    },
    {
      "headword": "retreat"
    },
    {
      "headword": "retreat"
    },
    {
      "headword": "retrieve"
    },
    {
      "headword": "retrospect"
    },
    {
      "headword": "return"
    },
    {
      "headword": "return"
    },
    {
      "headword": "reunification"
    },
    {
      "headword": "reunify"
    },
    {
      "headword": "reunion"
    },
    {
      "headword": "reveal"
    },
    {
      "headword": "revelation"
    },
    {
      "headword": "revenge"
    },
    {
      "headword": "revenue"
    },
    {
      "headword": "reverence"
    },
    {
      "headword": "reverse"
    },
    {
      "headword": "review"
    },
    {
      "headword": "review"
    },
    {
      "headword": "revise"
    },
    {
      "headword": "revision"
    },
    {
      "headword": "revival"
    },
    {
      "headword": "revive"
    },
    {
      "headword": "revolution"
    },
    {
      "headword": "revolutionary"
    },
    {
      "headword": "revolutionize/revolutionise"
    },
    {
      "headword": "revolve"
    },
    {
      "headword": "reward"
    },
    {
      "headword": "reward"
    },
    {
      "headword": "rewrite"
    },
    {
      "headword": "rhinoceros"
    },
    {
      "headword": "rhyme"
    },
    {
      "headword": "rhythm"
    },
    {
      "headword": "rhythmic"
    },
    {
      "headword": "rib"
    },
    {
      "headword": "ribbon"
    },
    {
      "headword": "rice"
    },
    {
      "headword": "rich"
    },
    {
      "headword": "rid"
    },
    {
      "headword": "riddle"
    },
    {
      "headword": "riddle"
    },
    {
      "headword": "ride"
    },
    {
      "headword": "ride"
    },
    {
      "headword": "rider"
    },
    {
      "headword": "ridge"
    },
    {
      "headword": "ridiculous"
    },
    {
      "headword": "right"
    },
    {
      "headword": "right"
    },
    {
      "headword": "right"
    },
    {
      "headword": "righteousness"
    },
    {
      "headword": "right-hand"
    },
    {
      "headword": "rightly"
    },
    {
      "headword": "rim"
    },
    {
      "headword": "ring"
    },
    {
      "headword": "ring"
    },
    {
      "headword": "rip"
    },
    {
      "headword": "ripe"
    },
    {
      "headword": "rise"
    },
    {
      "headword": "rise"
    },
    {
      "headword": "risk"
    },
    {
      "headword": "risk"
    },
    {
      "headword": "risky"
    },
    {
      "headword": "rite"
    },
    {
      "headword": "ritual"
    },
    {
      "headword": "rival"
    },
    {
      "headword": "river"
    },
    {
      "headword": "road"
    },
    {
      "headword": "roadside"
    },
    {
      "headword": "roam"
    },
    {
      "headword": "roar"
    },
    {
      "headword": "roast"
    },
    {
      "headword": "roast"
    },
    {
      "headword": "rob"
    },
    {
      "headword": "robbery"
    },
    {
      "headword": "robin"
    },
    {
      "headword": "robot"
    },
    {
      "headword": "rock"
    },
    {
      "headword": "rock"
    },
    {
      "headword": "rocket"
    },
    {
      "headword": "rocky"
    },
    {
      "headword": "role"
    },
    {
      "headword": "roll"
    },
    {
      "headword": "roll"
    },
    {
      "headword": "rolling"
    },
    {
      "headword": "romance"
    },
    {
      "headword": "romantic"
    },
    {
      "headword": "roof"
    },
    {
      "headword": "room"
    },
    {
      "headword": "room"
    },
    {
      "headword": "roommate"
    },
    {
      "headword": "root"
    },
    {
      "headword": "rope"
    },
    {
      "headword": "rose"
    },
    {
      "headword": "rosy"
    },
    {
      "headword": "rotten"
    },
    {
      "headword": "rough"
    },
    {
      "headword": "roughly"
    },
    {
      "headword": "round"
    },
    {
      "headword": "round"
    },
    {
      "headword": "round"
    },
    {
      "headword": "round"
    },
    {
      "headword": "round"
    },
    {
      "headword": "roundabout"
    },
    {
      "headword": "route"
    },
    {
      "headword": "routine"
    },
    {
      "headword": "row"
    },
    {
      "headword": "row"
    },
    {
      "headword": "royal"
    },
    {
      "headword": "royalty"
    },
    {
      "headword": "rub"
    },
    {
      "headword": "rubber"
    },
    {
      "headword": "rubbish"
    },
    {
      "headword": "rubble"
    },
    {
      "headword": "rude"
    },
    {
      "headword": "rudely"
    },
    {
      "headword": "rug"
    },
    {
      "headword": "rugby"
    },
    {
      "headword": "ruin"
    },
    {
      "headword": "ruin"
    },
    {
      "headword": "ruinous"
    },
    {
      "headword": "rule"
    },
    {
      "headword": "rule"
    },
    {
      "headword": "ruler"
    },
    {
      "headword": "rumor/rumour"
    },
    {
      "headword": "run"
    },
    {
      "headword": "run"
    },
    {
      "headword": "runaway"
    },
    {
      "headword": "runner"
    },
    {
      "headword": "running"
    },
    {
      "headword": "runway"
    },
    {
      "headword": "rural"
    },
    {
      "headword": "rush"
    },
    {
      "headword": "rush"
    },
    {
      "headword": "rush hour"
    },
    {
      "headword": "rusty"
    },
    {
      "headword": "s"
    },
    {
      "headword": "sack"
    },
    {
      "headword": "sacred"
    },
    {
      "headword": "sad"
    },
    {
      "headword": "sadly"
    },
    {
      "headword": "sadness"
    },
    {
      "headword": "safari"
    },
    {
      "headword": "safe"
    },
    {
      "headword": "safeguard"
    },
    {
      "headword": "safeguard"
    },
    {
      "headword": "safely"
    },
    {
      "headword": "safety"
    },
    {
      "headword": "sag"
    },
    {
      "headword": "sage"
    },
    {
      "headword": "sail"
    },
    {
      "headword": "sailing"
    },
    {
      "headword": "sailor"
    },
    {
      "headword": "sake"
    },
    {
      "headword": "salad"
    },
    {
      "headword": "salary"
    },
    {
      "headword": "sale"
    },
    {
      "headword": "salesman"
    },
    {
      "headword": "salesmanship"
    },
    {
      "headword": "salesperson"
    },
    {
      "headword": "saleswoman"
    },
    {
      "headword": "salmon"
    },
    {
      "headword": "salon"
    },
    {
      "headword": "salsa"
    },
    {
      "headword": "salt"
    },
    {
      "headword": "salty"
    },
    {
      "headword": "same"
    },
    {
      "headword": "same"
    },
    {
      "headword": "same"
    },
    {
      "headword": "sample"
    },
    {
      "headword": "sand"
    },
    {
      "headword": "sandal"
    },
    {
      "headword": "sandstone"
    },
    {
      "headword": "sandwich"
    },
    {
      "headword": "sandy"
    },
    {
      "headword": "sanitary"
    },
    {
      "headword": "sanitation"
    },
    {
      "headword": "satellite"
    },
    {
      "headword": "satisfaction"
    },
    {
      "headword": "satisfactory"
    },
    {
      "headword": "satisfied"
    },
    {
      "headword": "satisfy"
    },
    {
      "headword": "Saturday"
    },
    {
      "headword": "sauce"
    },
    {
      "headword": "saucepan"
    },
    {
      "headword": "saucer"
    },
    {
      "headword": "sausage"
    },
    {
      "headword": "save"
    },
    {
      "headword": "saving/savings"
    },
    {
      "headword": "saw"
    },
    {
      "headword": "saw"
    },
    {
      "headword": "say"
    },
    {
      "headword": "say"
    },
    {
      "headword": "scale"
    },
    {
      "headword": "scan"
    },
    {
      "headword": "scan"
    },
    {
      "headword": "scandal"
    },
    {
      "headword": "scar"
    },
    {
      "headword": "scarcely"
    },
    {
      "headword": "scare"
    },
    {
      "headword": "scared"
    },
    {
      "headword": "scarf"
    },
    {
      "headword": "scarlet"
    },
    {
      "headword": "scary"
    },
    {
      "headword": "scatter"
    },
    {
      "headword": "scene"
    },
    {
      "headword": "scenery"
    },
    {
      "headword": "scenic"
    },
    {
      "headword": "scent"
    },
    {
      "headword": "schedule"
    },
    {
      "headword": "schedule"
    },
    {
      "headword": "scheduled"
    },
    {
      "headword": "scheme"
    },
    {
      "headword": "scholar"
    },
    {
      "headword": "scholarship"
    },
    {
      "headword": "scholasticism"
    },
    {
      "headword": "school"
    },
    {
      "headword": "schoolchild"
    },
    {
      "headword": "schoolgirl"
    },
    {
      "headword": "schoolmate"
    },
    {
      "headword": "schoolteacher"
    },
    {
      "headword": "schoolwork"
    },
    {
      "headword": "science"
    },
    {
      "headword": "science fiction"
    },
    {
      "headword": "scientific"
    },
    {
      "headword": "scientifically"
    },
    {
      "headword": "scientist"
    },
    {
      "headword": "scissors"
    },
    {
      "headword": "scold"
    },
    {
      "headword": "scooter"
    },
    {
      "headword": "scope"
    },
    {
      "headword": "score"
    },
    {
      "headword": "score"
    },
    {
      "headword": "scramble"
    },
    {
      "headword": "scratch"
    },
    {
      "headword": "scratch"
    },
    {
      "headword": "scream"
    },
    {
      "headword": "scream"
    },
    {
      "headword": "screen"
    },
    {
      "headword": "screen"
    },
    {
      "headword": "screw"
    },
    {
      "headword": "screw"
    },
    {
      "headword": "scribble"
    },
    {
      "headword": "script"
    },
    {
      "headword": "scrooge"
    },
    {
      "headword": "scuba"
    },
    {
      "headword": "sculpture"
    },
    {
      "headword": "scythe"
    },
    {
      "headword": "sea"
    },
    {
      "headword": "seafood"
    },
    {
      "headword": "seal"
    },
    {
      "headword": "search"
    },
    {
      "headword": "search"
    },
    {
      "headword": "seaside"
    },
    {
      "headword": "season"
    },
    {
      "headword": "seasonal"
    },
    {
      "headword": "seat"
    },
    {
      "headword": "seawater"
    },
    {
      "headword": "seaweed"
    },
    {
      "headword": "second"
    },
    {
      "headword": "second"
    },
    {
      "headword": "second"
    },
    {
      "headword": "second"
    },
    {
      "headword": "second person"
    },
    {
      "headword": "secondary"
    },
    {
      "headword": "secondary school"
    },
    {
      "headword": "second-hand"
    },
    {
      "headword": "second-hand"
    },
    {
      "headword": "secondly"
    },
    {
      "headword": "secret"
    },
    {
      "headword": "secret"
    },
    {
      "headword": "secretary"
    },
    {
      "headword": "secretly"
    },
    {
      "headword": "section"
    },
    {
      "headword": "sector"
    },
    {
      "headword": "secure"
    },
    {
      "headword": "security"
    },
    {
      "headword": "see"
    },
    {
      "headword": "seed"
    },
    {
      "headword": "seek"
    },
    {
      "headword": "seem"
    },
    {
      "headword": "seesaw"
    },
    {
      "headword": "segment"
    },
    {
      "headword": "seize"
    },
    {
      "headword": "seldom"
    },
    {
      "headword": "select"
    },
    {
      "headword": "select"
    },
    {
      "headword": "selection"
    },
    {
      "headword": "self"
    },
    {
      "headword": "self-confidence"
    },
    {
      "headword": "self-confident"
    },
    {
      "headword": "selfish"
    },
    {
      "headword": "selfless"
    },
    {
      "headword": "self-service"
    },
    {
      "headword": "sell"
    },
    {
      "headword": "seller"
    },
    {
      "headword": "semester"
    },
    {
      "headword": "semicolon"
    },
    {
      "headword": "semi-final"
    },
    {
      "headword": "seminar"
    },
    {
      "headword": "senator"
    },
    {
      "headword": "send"
    },
    {
      "headword": "senior"
    },
    {
      "headword": "senior"
    },
    {
      "headword": "sensation"
    },
    {
      "headword": "sense"
    },
    {
      "headword": "sense"
    },
    {
      "headword": "sensible"
    },
    {
      "headword": "sensitive"
    },
    {
      "headword": "sentence"
    },
    {
      "headword": "sentence"
    },
    {
      "headword": "separate"
    },
    {
      "headword": "separate"
    },
    {
      "headword": "separately"
    },
    {
      "headword": "separation"
    },
    {
      "headword": "September"
    },
    {
      "headword": "sequence"
    },
    {
      "headword": "serene"
    },
    {
      "headword": "serial"
    },
    {
      "headword": "series"
    },
    {
      "headword": "serious"
    },
    {
      "headword": "seriously"
    },
    {
      "headword": "servant"
    },
    {
      "headword": "serve"
    },
    {
      "headword": "server"
    },
    {
      "headword": "service"
    },
    {
      "headword": "service"
    },
    {
      "headword": "session"
    },
    {
      "headword": "set"
    },
    {
      "headword": "set"
    },
    {
      "headword": "setback"
    },
    {
      "headword": "setting"
    },
    {
      "headword": "settle"
    },
    {
      "headword": "settlement"
    },
    {
      "headword": "settler"
    },
    {
      "headword": "seven"
    },
    {
      "headword": "seventeen"
    },
    {
      "headword": "seventy"
    },
    {
      "headword": "several"
    },
    {
      "headword": "several"
    },
    {
      "headword": "severe"
    },
    {
      "headword": "severely"
    },
    {
      "headword": "sew"
    },
    {
      "headword": "sex"
    },
    {
      "headword": "sexism"
    },
    {
      "headword": "sexual"
    },
    {
      "headword": "sexy"
    },
    {
      "headword": "shabby"
    },
    {
      "headword": "shade"
    },
    {
      "headword": "shadow"
    },
    {
      "headword": "shadow"
    },
    {
      "headword": "shadowy"
    },
    {
      "headword": "shake"
    },
    {
      "headword": "shake"
    },
    {
      "headword": "shaken"
    },
    {
      "headword": "Shakespearean"
    },
    {
      "headword": "shaky"
    },
    {
      "headword": "shall"
    },
    {
      "headword": "shallow"
    },
    {
      "headword": "shame"
    },
    {
      "headword": "shameful"
    },
    {
      "headword": "shampoo"
    },
    {
      "headword": "shape"
    },
    {
      "headword": "shape"
    },
    {
      "headword": "share"
    },
    {
      "headword": "share"
    },
    {
      "headword": "sharp"
    },
    {
      "headword": "sharp"
    },
    {
      "headword": "sharply"
    },
    {
      "headword": "shatter"
    },
    {
      "headword": "shave"
    },
    {
      "headword": "she"
    },
    {
      "headword": "shed"
    },
    {
      "headword": "sheep"
    },
    {
      "headword": "sheer"
    },
    {
      "headword": "sheet"
    },
    {
      "headword": "shelf"
    },
    {
      "headword": "shell"
    },
    {
      "headword": "shell"
    },
    {
      "headword": "shelter"
    },
    {
      "headword": "sheriff"
    },
    {
      "headword": "shield"
    },
    {
      "headword": "shift"
    },
    {
      "headword": "shift"
    },
    {
      "headword": "shine"
    },
    {
      "headword": "shiny"
    },
    {
      "headword": "ship"
    },
    {
      "headword": "ship"
    },
    {
      "headword": "shipping"
    },
    {
      "headword": "shipwreck"
    },
    {
      "headword": "shirt"
    },
    {
      "headword": "shiver"
    },
    {
      "headword": "shock"
    },
    {
      "headword": "shock"
    },
    {
      "headword": "shocked"
    },
    {
      "headword": "shocking"
    },
    {
      "headword": "shoe"
    },
    {
      "headword": "shoot"
    },
    {
      "headword": "shooting"
    },
    {
      "headword": "shop"
    },
    {
      "headword": "shop"
    },
    {
      "headword": "shop assistant"
    },
    {
      "headword": "shopkeeper"
    },
    {
      "headword": "shoplift"
    },
    {
      "headword": "shoplifter"
    },
    {
      "headword": "shoplifting"
    },
    {
      "headword": "shopper"
    },
    {
      "headword": "shopping"
    },
    {
      "headword": "shore"
    },
    {
      "headword": "short"
    },
    {
      "headword": "short"
    },
    {
      "headword": "short/shorts"
    },
    {
      "headword": "shortage"
    },
    {
      "headword": "shortly"
    },
    {
      "headword": "shortness"
    },
    {
      "headword": "short-term"
    },
    {
      "headword": "shot"
    },
    {
      "headword": "should"
    },
    {
      "headword": "shoulder"
    },
    {
      "headword": "shout"
    },
    {
      "headword": "shout"
    },
    {
      "headword": "show"
    },
    {
      "headword": "show"
    },
    {
      "headword": "showbiz"
    },
    {
      "headword": "showcase"
    },
    {
      "headword": "shower"
    },
    {
      "headword": "shower"
    },
    {
      "headword": "shrimp"
    },
    {
      "headword": "shrink"
    },
    {
      "headword": "shrink"
    },
    {
      "headword": "shrug"
    },
    {
      "headword": "shut"
    },
    {
      "headword": "shut"
    },
    {
      "headword": "shy"
    },
    {
      "headword": "sick"
    },
    {
      "headword": "sickness"
    },
    {
      "headword": "side"
    },
    {
      "headword": "sidewalk"
    },
    {
      "headword": "sigh"
    },
    {
      "headword": "sigh"
    },
    {
      "headword": "sight"
    },
    {
      "headword": "sightseeing"
    },
    {
      "headword": "sign"
    },
    {
      "headword": "sign"
    },
    {
      "headword": "signal"
    },
    {
      "headword": "signature"
    },
    {
      "headword": "significance"
    },
    {
      "headword": "significant"
    },
    {
      "headword": "significantly"
    },
    {
      "headword": "signify"
    },
    {
      "headword": "signpost"
    },
    {
      "headword": "silence"
    },
    {
      "headword": "silent"
    },
    {
      "headword": "silently"
    },
    {
      "headword": "silk"
    },
    {
      "headword": "silly"
    },
    {
      "headword": "silver"
    },
    {
      "headword": "silver"
    },
    {
      "headword": "silverware"
    },
    {
      "headword": "similar"
    },
    {
      "headword": "similarity"
    },
    {
      "headword": "similarly"
    },
    {
      "headword": "simple"
    },
    {
      "headword": "simplification"
    },
    {
      "headword": "simplify"
    },
    {
      "headword": "simply"
    },
    {
      "headword": "simultaneous"
    },
    {
      "headword": "simultaneously"
    },
    {
      "headword": "since"
    },
    {
      "headword": "since"
    },
    {
      "headword": "since"
    },
    {
      "headword": "sincere"
    },
    {
      "headword": "sincerity"
    },
    {
      "headword": "sing"
    },
    {
      "headword": "singer"
    },
    {
      "headword": "singing"
    },
    {
      "headword": "single"
    },
    {
      "headword": "single"
    },
    {
      "headword": "singular"
    },
    {
      "headword": "singular"
    },
    {
      "headword": "sink"
    },
    {
      "headword": "sink"
    },
    {
      "headword": "sir"
    },
    {
      "headword": "sister"
    },
    {
      "headword": "sister-in-law"
    },
    {
      "headword": "sit"
    },
    {
      "headword": "site"
    },
    {
      "headword": "sitting room"
    },
    {
      "headword": "situation"
    },
    {
      "headword": "six"
    },
    {
      "headword": "sixteen"
    },
    {
      "headword": "sixty"
    },
    {
      "headword": "size"
    },
    {
      "headword": "skate"
    },
    {
      "headword": "skate"
    },
    {
      "headword": "skateboard"
    },
    {
      "headword": "skateboarder"
    },
    {
      "headword": "skateboarding"
    },
    {
      "headword": "skating"
    },
    {
      "headword": "skeleton"
    },
    {
      "headword": "sketch"
    },
    {
      "headword": "ski"
    },
    {
      "headword": "ski"
    },
    {
      "headword": "skiing"
    },
    {
      "headword": "skill"
    },
    {
      "headword": "skilled"
    },
    {
      "headword": "skillful/skilful"
    },
    {
      "headword": "skillfully/skilfully"
    },
    {
      "headword": "skim"
    },
    {
      "headword": "skin"
    },
    {
      "headword": "skip"
    },
    {
      "headword": "skirt"
    },
    {
      "headword": "sky"
    },
    {
      "headword": "skylark"
    },
    {
      "headword": "skyscraper"
    },
    {
      "headword": "skyward"
    },
    {
      "headword": "slam"
    },
    {
      "headword": "slang"
    },
    {
      "headword": "slap"
    },
    {
      "headword": "slap"
    },
    {
      "headword": "slash"
    },
    {
      "headword": "slaughter"
    },
    {
      "headword": "slave"
    },
    {
      "headword": "slavery"
    },
    {
      "headword": "sleep"
    },
    {
      "headword": "sleep"
    },
    {
      "headword": "sleepless"
    },
    {
      "headword": "sleepy"
    },
    {
      "headword": "sleeve"
    },
    {
      "headword": "slice"
    },
    {
      "headword": "slice"
    },
    {
      "headword": "slide"
    },
    {
      "headword": "slide"
    },
    {
      "headword": "slight"
    },
    {
      "headword": "slight"
    },
    {
      "headword": "slightly"
    },
    {
      "headword": "slim"
    },
    {
      "headword": "slip"
    },
    {
      "headword": "slip"
    },
    {
      "headword": "sliver"
    },
    {
      "headword": "slogan"
    },
    {
      "headword": "slope"
    },
    {
      "headword": "sloppy"
    },
    {
      "headword": "slot"
    },
    {
      "headword": "slow"
    },
    {
      "headword": "slow"
    },
    {
      "headword": "slow"
    },
    {
      "headword": "slowly"
    },
    {
      "headword": "small"
    },
    {
      "headword": "smart"
    },
    {
      "headword": "smash"
    },
    {
      "headword": "smell"
    },
    {
      "headword": "smell"
    },
    {
      "headword": "smile"
    },
    {
      "headword": "smile"
    },
    {
      "headword": "smith"
    },
    {
      "headword": "smoke"
    },
    {
      "headword": "smoke"
    },
    {
      "headword": "smoker"
    },
    {
      "headword": "smokestack"
    },
    {
      "headword": "smoking"
    },
    {
      "headword": "smooth"
    },
    {
      "headword": "smoothly"
    },
    {
      "headword": "snack"
    },
    {
      "headword": "snake"
    },
    {
      "headword": "snap"
    },
    {
      "headword": "sneak"
    },
    {
      "headword": "sneer"
    },
    {
      "headword": "sneeze"
    },
    {
      "headword": "sneeze"
    },
    {
      "headword": "sniff"
    },
    {
      "headword": "snore"
    },
    {
      "headword": "snore"
    },
    {
      "headword": "snow"
    },
    {
      "headword": "snow"
    },
    {
      "headword": "snowball"
    },
    {
      "headword": "snowboard"
    },
    {
      "headword": "snowboarding"
    },
    {
      "headword": "snowstorm"
    },
    {
      "headword": "snowy"
    },
    {
      "headword": "so"
    },
    {
      "headword": "so"
    },
    {
      "headword": "soak"
    },
    {
      "headword": "soak"
    },
    {
      "headword": "soaked"
    },
    {
      "headword": "soaking"
    },
    {
      "headword": "soap"
    },
    {
      "headword": "soap opera"
    },
    {
      "headword": "soar"
    },
    {
      "headword": "sob"
    },
    {
      "headword": "so-called"
    },
    {
      "headword": "soccer"
    },
    {
      "headword": "sociable"
    },
    {
      "headword": "social"
    },
    {
      "headword": "social networking"
    },
    {
      "headword": "socialize/socialise"
    },
    {
      "headword": "socially"
    },
    {
      "headword": "society"
    },
    {
      "headword": "sock"
    },
    {
      "headword": "soda"
    },
    {
      "headword": "sofa"
    },
    {
      "headword": "soft"
    },
    {
      "headword": "soft drink"
    },
    {
      "headword": "softly"
    },
    {
      "headword": "softness"
    },
    {
      "headword": "software"
    },
    {
      "headword": "soil"
    },
    {
      "headword": "soil"
    },
    {
      "headword": "solar"
    },
    {
      "headword": "soldier"
    },
    {
      "headword": "solid"
    },
    {
      "headword": "solidity"
    },
    {
      "headword": "soliloquy"
    },
    {
      "headword": "solo"
    },
    {
      "headword": "solo"
    },
    {
      "headword": "solo"
    },
    {
      "headword": "solution"
    },
    {
      "headword": "solve"
    },
    {
      "headword": "solvent"
    },
    {
      "headword": "some"
    },
    {
      "headword": "some"
    },
    {
      "headword": "somebody"
    },
    {
      "headword": "someday"
    },
    {
      "headword": "somehow"
    },
    {
      "headword": "someone"
    },
    {
      "headword": "someplace"
    },
    {
      "headword": "something"
    },
    {
      "headword": "sometime"
    },
    {
      "headword": "sometimes"
    },
    {
      "headword": "somewhat"
    },
    {
      "headword": "somewhere"
    },
    {
      "headword": "son"
    },
    {
      "headword": "song"
    },
    {
      "headword": "son-in-law"
    },
    {
      "headword": "sonnet"
    },
    {
      "headword": "soon"
    },
    {
      "headword": "soothe"
    },
    {
      "headword": "sophisticated"
    },
    {
      "headword": "sophomore"
    },
    {
      "headword": "sore"
    },
    {
      "headword": "sorrow"
    },
    {
      "headword": "sorry"
    },
    {
      "headword": "sort"
    },
    {
      "headword": "sort"
    },
    {
      "headword": "soul"
    },
    {
      "headword": "sound"
    },
    {
      "headword": "sound"
    },
    {
      "headword": "sound"
    },
    {
      "headword": "soundtrack"
    },
    {
      "headword": "soup"
    },
    {
      "headword": "sour"
    },
    {
      "headword": "source"
    },
    {
      "headword": "south"
    },
    {
      "headword": "south"
    },
    {
      "headword": "south"
    },
    {
      "headword": "southeast"
    },
    {
      "headword": "southeast"
    },
    {
      "headword": "southern"
    },
    {
      "headword": "southward"
    },
    {
      "headword": "southwest"
    },
    {
      "headword": "southwest"
    },
    {
      "headword": "souvenir"
    },
    {
      "headword": "Soviet"
    },
    {
      "headword": "soybean"
    },
    {
      "headword": "spa"
    },
    {
      "headword": "space"
    },
    {
      "headword": "spaceship"
    },
    {
      "headword": "spaghetti"
    },
    {
      "headword": "span"
    },
    {
      "headword": "spare"
    },
    {
      "headword": "spare"
    },
    {
      "headword": "sparerib"
    },
    {
      "headword": "spark"
    },
    {
      "headword": "sparkle"
    },
    {
      "headword": "sparkling"
    },
    {
      "headword": "sparrow"
    },
    {
      "headword": "speak"
    },
    {
      "headword": "speaker"
    },
    {
      "headword": "special"
    },
    {
      "headword": "specialist"
    },
    {
      "headword": "specialize/specialise"
    },
    {
      "headword": "specially"
    },
    {
      "headword": "specialty"
    },
    {
      "headword": "species"
    },
    {
      "headword": "specific"
    },
    {
      "headword": "specifically"
    },
    {
      "headword": "specify"
    },
    {
      "headword": "spectacle"
    },
    {
      "headword": "spectacular"
    },
    {
      "headword": "spectator"
    },
    {
      "headword": "speech"
    },
    {
      "headword": "speed"
    },
    {
      "headword": "speed"
    },
    {
      "headword": "speeder"
    },
    {
      "headword": "spell"
    },
    {
      "headword": "spell"
    },
    {
      "headword": "spellbound"
    },
    {
      "headword": "spelling"
    },
    {
      "headword": "spend"
    },
    {
      "headword": "sphere"
    },
    {
      "headword": "spice"
    },
    {
      "headword": "spicy"
    },
    {
      "headword": "spider"
    },
    {
      "headword": "spill"
    },
    {
      "headword": "spin"
    },
    {
      "headword": "spinach"
    },
    {
      "headword": "spiral"
    },
    {
      "headword": "spirit"
    },
    {
      "headword": "spiritual"
    },
    {
      "headword": "spite"
    },
    {
      "headword": "splash"
    },
    {
      "headword": "splash"
    },
    {
      "headword": "splatter"
    },
    {
      "headword": "split"
    },
    {
      "headword": "split"
    },
    {
      "headword": "split"
    },
    {
      "headword": "spoil"
    },
    {
      "headword": "spokesman"
    },
    {
      "headword": "spokeswoman"
    },
    {
      "headword": "sponge"
    },
    {
      "headword": "sponsor"
    },
    {
      "headword": "sponsor"
    },
    {
      "headword": "spoon"
    },
    {
      "headword": "sport"
    },
    {
      "headword": "sports"
    },
    {
      "headword": "sports center/sports centre"
    },
    {
      "headword": "sportsmanship"
    },
    {
      "headword": "spot"
    },
    {
      "headword": "spot"
    },
    {
      "headword": "spray"
    },
    {
      "headword": "spray"
    },
    {
      "headword": "spread"
    },
    {
      "headword": "spread"
    },
    {
      "headword": "spreadsheet"
    },
    {
      "headword": "spring"
    },
    {
      "headword": "sprint"
    },
    {
      "headword": "spur"
    },
    {
      "headword": "spy"
    },
    {
      "headword": "squad"
    },
    {
      "headword": "square"
    },
    {
      "headword": "square"
    },
    {
      "headword": "squash"
    },
    {
      "headword": "squash"
    },
    {
      "headword": "squeeze"
    },
    {
      "headword": "stab"
    },
    {
      "headword": "stability"
    },
    {
      "headword": "stable"
    },
    {
      "headword": "stack"
    },
    {
      "headword": "stadium"
    },
    {
      "headword": "staff"
    },
    {
      "headword": "stage"
    },
    {
      "headword": "stagger"
    },
    {
      "headword": "stain"
    },
    {
      "headword": "stain"
    },
    {
      "headword": "stair"
    },
    {
      "headword": "stake"
    },
    {
      "headword": "stall"
    },
    {
      "headword": "stammer"
    },
    {
      "headword": "stamp"
    },
    {
      "headword": "stamp"
    },
    {
      "headword": "stand"
    },
    {
      "headword": "stand"
    },
    {
      "headword": "standard"
    },
    {
      "headword": "standard"
    },
    {
      "headword": "standby"
    },
    {
      "headword": "standstill"
    },
    {
      "headword": "stanza"
    },
    {
      "headword": "star"
    },
    {
      "headword": "star"
    },
    {
      "headword": "stare"
    },
    {
      "headword": "start"
    },
    {
      "headword": "start"
    },
    {
      "headword": "startle"
    },
    {
      "headword": "starvation"
    },
    {
      "headword": "starve"
    },
    {
      "headword": "starving"
    },
    {
      "headword": "state"
    },
    {
      "headword": "state"
    },
    {
      "headword": "state"
    },
    {
      "headword": "statement"
    },
    {
      "headword": "statesman"
    },
    {
      "headword": "statewide"
    },
    {
      "headword": "station"
    },
    {
      "headword": "statistics"
    },
    {
      "headword": "statue"
    },
    {
      "headword": "status"
    },
    {
      "headword": "stay"
    },
    {
      "headword": "stay"
    },
    {
      "headword": "steadily"
    },
    {
      "headword": "steady"
    },
    {
      "headword": "steak"
    },
    {
      "headword": "steal"
    },
    {
      "headword": "steam"
    },
    {
      "headword": "steel"
    },
    {
      "headword": "steely"
    },
    {
      "headword": "steep"
    },
    {
      "headword": "steer"
    },
    {
      "headword": "steering wheel"
    },
    {
      "headword": "stem"
    },
    {
      "headword": "step"
    },
    {
      "headword": "step"
    },
    {
      "headword": "stepfather"
    },
    {
      "headword": "stepmother"
    },
    {
      "headword": "stereotype"
    },
    {
      "headword": "stern"
    },
    {
      "headword": "stew"
    },
    {
      "headword": "stick"
    },
    {
      "headword": "stick"
    },
    {
      "headword": "sticker"
    },
    {
      "headword": "sticky"
    },
    {
      "headword": "stiff"
    },
    {
      "headword": "still"
    },
    {
      "headword": "still"
    },
    {
      "headword": "stimulant"
    },
    {
      "headword": "stimulate"
    },
    {
      "headword": "stimulation"
    },
    {
      "headword": "stingy"
    },
    {
      "headword": "stink"
    },
    {
      "headword": "stir"
    },
    {
      "headword": "stitch"
    },
    {
      "headword": "stock"
    },
    {
      "headword": "stock market"
    },
    {
      "headword": "stockpile"
    },
    {
      "headword": "stomach"
    },
    {
      "headword": "stomachache"
    },
    {
      "headword": "stone"
    },
    {
      "headword": "stonework"
    },
    {
      "headword": "stool"
    },
    {
      "headword": "stop"
    },
    {
      "headword": "stop"
    },
    {
      "headword": "stopover"
    },
    {
      "headword": "stopwatch"
    },
    {
      "headword": "storage"
    },
    {
      "headword": "store"
    },
    {
      "headword": "store"
    },
    {
      "headword": "storm"
    },
    {
      "headword": "stormy"
    },
    {
      "headword": "story"
    },
    {
      "headword": "storyteller"
    },
    {
      "headword": "stove"
    },
    {
      "headword": "straight"
    },
    {
      "headword": "straight"
    },
    {
      "headword": "straighten"
    },
    {
      "headword": "straightforward"
    },
    {
      "headword": "strain"
    },
    {
      "headword": "strain"
    },
    {
      "headword": "strait"
    },
    {
      "headword": "strand"
    },
    {
      "headword": "strange"
    },
    {
      "headword": "strangely"
    },
    {
      "headword": "stranger"
    },
    {
      "headword": "strangle"
    },
    {
      "headword": "strategic"
    },
    {
      "headword": "strategy"
    },
    {
      "headword": "straw"
    },
    {
      "headword": "strawberry"
    },
    {
      "headword": "stream"
    },
    {
      "headword": "stream"
    },
    {
      "headword": "street"
    },
    {
      "headword": "strength"
    },
    {
      "headword": "strengthen"
    },
    {
      "headword": "stress"
    },
    {
      "headword": "stress"
    },
    {
      "headword": "stressed"
    },
    {
      "headword": "stressful"
    },
    {
      "headword": "stretch"
    },
    {
      "headword": "stricken"
    },
    {
      "headword": "strict"
    },
    {
      "headword": "strictly"
    },
    {
      "headword": "stride"
    },
    {
      "headword": "strike"
    },
    {
      "headword": "strike"
    },
    {
      "headword": "striking"
    },
    {
      "headword": "string"
    },
    {
      "headword": "strip"
    },
    {
      "headword": "strip"
    },
    {
      "headword": "stripe"
    },
    {
      "headword": "strive"
    },
    {
      "headword": "stroke"
    },
    {
      "headword": "stroke"
    },
    {
      "headword": "strong"
    },
    {
      "headword": "strongly"
    },
    {
      "headword": "structure"
    },
    {
      "headword": "struggle"
    },
    {
      "headword": "struggle"
    },
    {
      "headword": "stubborn"
    },
    {
      "headword": "stubbornly"
    },
    {
      "headword": "stuck"
    },
    {
      "headword": "student"
    },
    {
      "headword": "studio"
    },
    {
      "headword": "study"
    },
    {
      "headword": "study"
    },
    {
      "headword": "stuff"
    },
    {
      "headword": "stuff"
    },
    {
      "headword": "stuffed"
    },
    {
      "headword": "stumble"
    },
    {
      "headword": "stun"
    },
    {
      "headword": "stunning"
    },
    {
      "headword": "stupid"
    },
    {
      "headword": "style"
    },
    {
      "headword": "stylish"
    },
    {
      "headword": "stylist"
    },
    {
      "headword": "subconscious"
    },
    {
      "headword": "subcontinent"
    },
    {
      "headword": "subculture"
    },
    {
      "headword": "subdivision"
    },
    {
      "headword": "subject"
    },
    {
      "headword": "subjunctive"
    },
    {
      "headword": "submarine"
    },
    {
      "headword": "submit"
    },
    {
      "headword": "subplot"
    },
    {
      "headword": "subside"
    },
    {
      "headword": "substance"
    },
    {
      "headword": "substantial"
    },
    {
      "headword": "substitute"
    },
    {
      "headword": "substitute"
    },
    {
      "headword": "subtitle"
    },
    {
      "headword": "subtle"
    },
    {
      "headword": "subtract"
    },
    {
      "headword": "suburb"
    },
    {
      "headword": "subway"
    },
    {
      "headword": "succeed"
    },
    {
      "headword": "success"
    },
    {
      "headword": "successful"
    },
    {
      "headword": "successfully"
    },
    {
      "headword": "successive"
    },
    {
      "headword": "such"
    },
    {
      "headword": "such"
    },
    {
      "headword": "suck"
    },
    {
      "headword": "sudden"
    },
    {
      "headword": "suddenly"
    },
    {
      "headword": "sue"
    },
    {
      "headword": "suffer"
    },
    {
      "headword": "suffering"
    },
    {
      "headword": "sufficient"
    },
    {
      "headword": "sufficiently"
    },
    {
      "headword": "suffix"
    },
    {
      "headword": "sugar"
    },
    {
      "headword": "suggest"
    },
    {
      "headword": "suggestion"
    },
    {
      "headword": "suicide"
    },
    {
      "headword": "suit"
    },
    {
      "headword": "suit"
    },
    {
      "headword": "suitable"
    },
    {
      "headword": "suitably"
    },
    {
      "headword": "suitcase"
    },
    {
      "headword": "sulfur/sulphur"
    },
    {
      "headword": "sum"
    },
    {
      "headword": "summarize/summarise"
    },
    {
      "headword": "summary"
    },
    {
      "headword": "summer"
    },
    {
      "headword": "summit"
    },
    {
      "headword": "sun"
    },
    {
      "headword": "sunbathe"
    },
    {
      "headword": "sunbeam"
    },
    {
      "headword": "Sunday"
    },
    {
      "headword": "sundial"
    },
    {
      "headword": "sunflower"
    },
    {
      "headword": "sunglasses"
    },
    {
      "headword": "sunlight"
    },
    {
      "headword": "sunny"
    },
    {
      "headword": "sunrise"
    },
    {
      "headword": "sunset"
    },
    {
      "headword": "sunshine"
    },
    {
      "headword": "super"
    },
    {
      "headword": "superb"
    },
    {
      "headword": "superintendent"
    },
    {
      "headword": "superior"
    },
    {
      "headword": "superlative"
    },
    {
      "headword": "supermarket"
    },
    {
      "headword": "supernatural"
    },
    {
      "headword": "superstar"
    },
    {
      "headword": "superstition"
    },
    {
      "headword": "supervise"
    },
    {
      "headword": "supervision"
    },
    {
      "headword": "supervisor"
    },
    {
      "headword": "supper"
    },
    {
      "headword": "supplement"
    },
    {
      "headword": "supplier"
    },
    {
      "headword": "supply"
    },
    {
      "headword": "supply"
    },
    {
      "headword": "support"
    },
    {
      "headword": "support"
    },
    {
      "headword": "supporter"
    },
    {
      "headword": "supportive"
    },
    {
      "headword": "suppose"
    },
    {
      "headword": "supposedly"
    },
    {
      "headword": "suppress"
    },
    {
      "headword": "sure"
    },
    {
      "headword": "sure"
    },
    {
      "headword": "surely"
    },
    {
      "headword": "surf"
    },
    {
      "headword": "surf"
    },
    {
      "headword": "surface"
    },
    {
      "headword": "surfing"
    },
    {
      "headword": "surge"
    },
    {
      "headword": "surgeon"
    },
    {
      "headword": "surgery"
    },
    {
      "headword": "surname"
    },
    {
      "headword": "surprise"
    },
    {
      "headword": "surprise"
    },
    {
      "headword": "surprised"
    },
    {
      "headword": "surprising"
    },
    {
      "headword": "surprisingly"
    },
    {
      "headword": "surrender"
    },
    {
      "headword": "surround"
    },
    {
      "headword": "surrounding"
    },
    {
      "headword": "surroundings"
    },
    {
      "headword": "surveillance"
    },
    {
      "headword": "survey"
    },
    {
      "headword": "survival"
    },
    {
      "headword": "survive"
    },
    {
      "headword": "survivor"
    },
    {
      "headword": "suspect"
    },
    {
      "headword": "suspect"
    },
    {
      "headword": "suspend"
    },
    {
      "headword": "suspicion"
    },
    {
      "headword": "suspicious"
    },
    {
      "headword": "suspiciously"
    },
    {
      "headword": "sustain"
    },
    {
      "headword": "swallow"
    },
    {
      "headword": "swan"
    },
    {
      "headword": "swarm"
    },
    {
      "headword": "swear"
    },
    {
      "headword": "sweat"
    },
    {
      "headword": "sweat"
    },
    {
      "headword": "sweater"
    },
    {
      "headword": "sweatshirt"
    },
    {
      "headword": "sweep"
    },
    {
      "headword": "sweet"
    },
    {
      "headword": "sweet"
    },
    {
      "headword": "sweetheart"
    },
    {
      "headword": "swell"
    },
    {
      "headword": "swift"
    },
    {
      "headword": "swim"
    },
    {
      "headword": "swim"
    },
    {
      "headword": "swimmer"
    },
    {
      "headword": "swimming"
    },
    {
      "headword": "swimming costume"
    },
    {
      "headword": "swimming pool"
    },
    {
      "headword": "swimsuit"
    },
    {
      "headword": "swing"
    },
    {
      "headword": "swing"
    },
    {
      "headword": "switch"
    },
    {
      "headword": "switch"
    },
    {
      "headword": "swollen"
    },
    {
      "headword": "sword"
    },
    {
      "headword": "syllable"
    },
    {
      "headword": "symbol"
    },
    {
      "headword": "symbolic"
    },
    {
      "headword": "sympathetic"
    },
    {
      "headword": "sympathize/sympathise"
    },
    {
      "headword": "sympathy"
    },
    {
      "headword": "symphony"
    },
    {
      "headword": "symptom"
    },
    {
      "headword": "syndrome"
    },
    {
      "headword": "synonym"
    },
    {
      "headword": "system"
    },
    {
      "headword": "systematic"
    },
    {
      "headword": "table"
    },
    {
      "headword": "table tennis"
    },
    {
      "headword": "tablecloth"
    },
    {
      "headword": "tablespoon"
    },
    {
      "headword": "tablet"
    },
    {
      "headword": "tabloid"
    },
    {
      "headword": "tabloid"
    },
    {
      "headword": "tack"
    },
    {
      "headword": "tackle"
    },
    {
      "headword": "tactile"
    },
    {
      "headword": "tag"
    },
    {
      "headword": "tail"
    },
    {
      "headword": "take"
    },
    {
      "headword": "take"
    },
    {
      "headword": "takeaway"
    },
    {
      "headword": "takeoff/take-off"
    },
    {
      "headword": "tale"
    },
    {
      "headword": "talent"
    },
    {
      "headword": "talented"
    },
    {
      "headword": "talk"
    },
    {
      "headword": "talk"
    },
    {
      "headword": "talkative"
    },
    {
      "headword": "tall"
    },
    {
      "headword": "tame"
    },
    {
      "headword": "tan"
    },
    {
      "headword": "tank"
    },
    {
      "headword": "tanned"
    },
    {
      "headword": "tap"
    },
    {
      "headword": "tap"
    },
    {
      "headword": "tape"
    },
    {
      "headword": "tape"
    },
    {
      "headword": "target"
    },
    {
      "headword": "task"
    },
    {
      "headword": "taste"
    },
    {
      "headword": "taste"
    },
    {
      "headword": "tasteless"
    },
    {
      "headword": "tasty"
    },
    {
      "headword": "tatter"
    },
    {
      "headword": "tattoo"
    },
    {
      "headword": "taunt"
    },
    {
      "headword": "tax"
    },
    {
      "headword": "taxi"
    },
    {
      "headword": "tea"
    },
    {
      "headword": "teach"
    },
    {
      "headword": "teacher"
    },
    {
      "headword": "teaching"
    },
    {
      "headword": "team"
    },
    {
      "headword": "teammate"
    },
    {
      "headword": "teamwork"
    },
    {
      "headword": "tear"
    },
    {
      "headword": "tear"
    },
    {
      "headword": "tease"
    },
    {
      "headword": "tease"
    },
    {
      "headword": "teaspoon"
    },
    {
      "headword": "technical"
    },
    {
      "headword": "technically"
    },
    {
      "headword": "technique"
    },
    {
      "headword": "technological"
    },
    {
      "headword": "technology"
    },
    {
      "headword": "teen"
    },
    {
      "headword": "teenage"
    },
    {
      "headword": "teenager"
    },
    {
      "headword": "telecommunications"
    },
    {
      "headword": "telegram"
    },
    {
      "headword": "telephone"
    },
    {
      "headword": "telephone"
    },
    {
      "headword": "telescope"
    },
    {
      "headword": "television"
    },
    {
      "headword": "tell"
    },
    {
      "headword": "teller"
    },
    {
      "headword": "temper"
    },
    {
      "headword": "temperate"
    },
    {
      "headword": "temperature"
    },
    {
      "headword": "temple"
    },
    {
      "headword": "temporarily"
    },
    {
      "headword": "temporary"
    },
    {
      "headword": "tempt"
    },
    {
      "headword": "temptation"
    },
    {
      "headword": "ten"
    },
    {
      "headword": "tend"
    },
    {
      "headword": "tendency"
    },
    {
      "headword": "tender"
    },
    {
      "headword": "tenderly"
    },
    {
      "headword": "tenderness"
    },
    {
      "headword": "tennis"
    },
    {
      "headword": "tense"
    },
    {
      "headword": "tense"
    },
    {
      "headword": "tension"
    },
    {
      "headword": "tent"
    },
    {
      "headword": "term"
    },
    {
      "headword": "terminal"
    },
    {
      "headword": "terrace"
    },
    {
      "headword": "terrible"
    },
    {
      "headword": "terribly"
    },
    {
      "headword": "terrific"
    },
    {
      "headword": "terrified"
    },
    {
      "headword": "terrify"
    },
    {
      "headword": "terrifying"
    },
    {
      "headword": "territory"
    },
    {
      "headword": "terror"
    },
    {
      "headword": "terrorism"
    },
    {
      "headword": "terrorist"
    },
    {
      "headword": "terrorist"
    },
    {
      "headword": "test"
    },
    {
      "headword": "test"
    },
    {
      "headword": "testify"
    },
    {
      "headword": "testimony"
    },
    {
      "headword": "text"
    },
    {
      "headword": "text"
    },
    {
      "headword": "text message"
    },
    {
      "headword": "textbook"
    },
    {
      "headword": "than"
    },
    {
      "headword": "than"
    },
    {
      "headword": "thank"
    },
    {
      "headword": "thankful"
    },
    {
      "headword": "thanks"
    },
    {
      "headword": "that"
    },
    {
      "headword": "that"
    },
    {
      "headword": "that"
    },
    {
      "headword": "that"
    },
    {
      "headword": "the"
    },
    {
      "headword": "theater/theatre"
    },
    {
      "headword": "theft"
    },
    {
      "headword": "their"
    },
    {
      "headword": "theirs"
    },
    {
      "headword": "them"
    },
    {
      "headword": "theme"
    },
    {
      "headword": "themselves"
    },
    {
      "headword": "then"
    },
    {
      "headword": "theorist"
    },
    {
      "headword": "theory"
    },
    {
      "headword": "therapist"
    },
    {
      "headword": "therapy"
    },
    {
      "headword": "there"
    },
    {
      "headword": "thereafter"
    },
    {
      "headword": "therefore"
    },
    {
      "headword": "thermometer"
    },
    {
      "headword": "these"
    },
    {
      "headword": "these"
    },
    {
      "headword": "thesis"
    },
    {
      "headword": "they"
    },
    {
      "headword": "thick"
    },
    {
      "headword": "thickly"
    },
    {
      "headword": "thickness"
    },
    {
      "headword": "thief"
    },
    {
      "headword": "thigh"
    },
    {
      "headword": "thin"
    },
    {
      "headword": "thing"
    },
    {
      "headword": "think"
    },
    {
      "headword": "thinker"
    },
    {
      "headword": "third"
    },
    {
      "headword": "third person"
    },
    {
      "headword": "thirdly"
    },
    {
      "headword": "thirst"
    },
    {
      "headword": "thirst"
    },
    {
      "headword": "thirsty"
    },
    {
      "headword": "thirteen"
    },
    {
      "headword": "thirty"
    },
    {
      "headword": "this"
    },
    {
      "headword": "this"
    },
    {
      "headword": "thorough"
    },
    {
      "headword": "thoroughly"
    },
    {
      "headword": "those"
    },
    {
      "headword": "those"
    },
    {
      "headword": "though"
    },
    {
      "headword": "though"
    },
    {
      "headword": "thought"
    },
    {
      "headword": "thoughtful"
    },
    {
      "headword": "thoughtless"
    },
    {
      "headword": "thousand"
    },
    {
      "headword": "thread"
    },
    {
      "headword": "threat"
    },
    {
      "headword": "threaten"
    },
    {
      "headword": "threatening"
    },
    {
      "headword": "three"
    },
    {
      "headword": "thrill"
    },
    {
      "headword": "thrilled"
    },
    {
      "headword": "thriller"
    },
    {
      "headword": "thrilling"
    },
    {
      "headword": "throat"
    },
    {
      "headword": "through"
    },
    {
      "headword": "through"
    },
    {
      "headword": "throughout"
    },
    {
      "headword": "throw"
    },
    {
      "headword": "throw"
    },
    {
      "headword": "thumb"
    },
    {
      "headword": "thump"
    },
    {
      "headword": "thunder"
    },
    {
      "headword": "thunderous"
    },
    {
      "headword": "thunderstorm"
    },
    {
      "headword": "Thursday"
    },
    {
      "headword": "thus"
    },
    {
      "headword": "tick"
    },
    {
      "headword": "tick"
    },
    {
      "headword": "ticket"
    },
    {
      "headword": "tickle"
    },
    {
      "headword": "tide"
    },
    {
      "headword": "tidy"
    },
    {
      "headword": "tidy"
    },
    {
      "headword": "tie"
    },
    {
      "headword": "tie"
    },
    {
      "headword": "tiger"
    },
    {
      "headword": "tight"
    },
    {
      "headword": "tight"
    },
    {
      "headword": "tighten"
    },
    {
      "headword": "tightly"
    },
    {
      "headword": "tightrope"
    },
    {
      "headword": "tights"
    },
    {
      "headword": "tile"
    },
    {
      "headword": "till"
    },
    {
      "headword": "till"
    },
    {
      "headword": "time"
    },
    {
      "headword": "time"
    },
    {
      "headword": "timeless"
    },
    {
      "headword": "timeliness"
    },
    {
      "headword": "timely"
    },
    {
      "headword": "times"
    },
    {
      "headword": "timetable"
    },
    {
      "headword": "timing"
    },
    {
      "headword": "tin"
    },
    {
      "headword": "tiny"
    },
    {
      "headword": "tip"
    },
    {
      "headword": "tip"
    },
    {
      "headword": "tiptoe"
    },
    {
      "headword": "tire"
    },
    {
      "headword": "tired"
    },
    {
      "headword": "tiredness"
    },
    {
      "headword": "tiresome"
    },
    {
      "headword": "tiring"
    },
    {
      "headword": "tissue"
    },
    {
      "headword": "title"
    },
    {
      "headword": "to"
    },
    {
      "headword": "to"
    },
    {
      "headword": "toast"
    },
    {
      "headword": "tobacco"
    },
    {
      "headword": "today"
    },
    {
      "headword": "today"
    },
    {
      "headword": "toe"
    },
    {
      "headword": "toenail"
    },
    {
      "headword": "together"
    },
    {
      "headword": "toil"
    },
    {
      "headword": "toilet"
    },
    {
      "headword": "tolerant"
    },
    {
      "headword": "tolerate"
    },
    {
      "headword": "toll"
    },
    {
      "headword": "tomato"
    },
    {
      "headword": "tomb"
    },
    {
      "headword": "tomorrow"
    },
    {
      "headword": "tomorrow"
    },
    {
      "headword": "ton"
    },
    {
      "headword": "tone"
    },
    {
      "headword": "tongue"
    },
    {
      "headword": "tonight"
    },
    {
      "headword": "tonight"
    },
    {
      "headword": "too"
    },
    {
      "headword": "tool"
    },
    {
      "headword": "tooth"
    },
    {
      "headword": "toothache"
    },
    {
      "headword": "toothbrush"
    },
    {
      "headword": "toothpaste"
    },
    {
      "headword": "top"
    },
    {
      "headword": "top"
    },
    {
      "headword": "topic"
    },
    {
      "headword": "torch"
    },
    {
      "headword": "tornado"
    },
    {
      "headword": "tortoiseshell"
    },
    {
      "headword": "torture"
    },
    {
      "headword": "toss"
    },
    {
      "headword": "total"
    },
    {
      "headword": "total"
    },
    {
      "headword": "totally"
    },
    {
      "headword": "touch"
    },
    {
      "headword": "touch"
    },
    {
      "headword": "tough"
    },
    {
      "headword": "tour"
    },
    {
      "headword": "tour"
    },
    {
      "headword": "tour guide"
    },
    {
      "headword": "tourism"
    },
    {
      "headword": "tourist"
    },
    {
      "headword": "tournament"
    },
    {
      "headword": "toward/towards"
    },
    {
      "headword": "towel"
    },
    {
      "headword": "tower"
    },
    {
      "headword": "town"
    },
    {
      "headword": "toxic"
    },
    {
      "headword": "toy"
    },
    {
      "headword": "trace"
    },
    {
      "headword": "trace"
    },
    {
      "headword": "track"
    },
    {
      "headword": "track"
    },
    {
      "headword": "tracksuit"
    },
    {
      "headword": "trade"
    },
    {
      "headword": "trade"
    },
    {
      "headword": "trader"
    },
    {
      "headword": "tradition"
    },
    {
      "headword": "traditional"
    },
    {
      "headword": "traditionally"
    },
    {
      "headword": "traffic"
    },
    {
      "headword": "traffic jam"
    },
    {
      "headword": "traffic light"
    },
    {
      "headword": "tragedy"
    },
    {
      "headword": "tragic"
    },
    {
      "headword": "trail"
    },
    {
      "headword": "trail"
    },
    {
      "headword": "trailer"
    },
    {
      "headword": "train"
    },
    {
      "headword": "train"
    },
    {
      "headword": "trainee"
    },
    {
      "headword": "trainer"
    },
    {
      "headword": "training"
    },
    {
      "headword": "trait"
    },
    {
      "headword": "traitor"
    },
    {
      "headword": "tram"
    },
    {
      "headword": "tramp"
    },
    {
      "headword": "trample"
    },
    {
      "headword": "transcript"
    },
    {
      "headword": "transfer"
    },
    {
      "headword": "transfer"
    },
    {
      "headword": "transform"
    },
    {
      "headword": "transformation"
    },
    {
      "headword": "transfusion"
    },
    {
      "headword": "transient"
    },
    {
      "headword": "transistor"
    },
    {
      "headword": "transition"
    },
    {
      "headword": "transitional"
    },
    {
      "headword": "transitive"
    },
    {
      "headword": "translate"
    },
    {
      "headword": "translation"
    },
    {
      "headword": "translator"
    },
    {
      "headword": "transmission"
    },
    {
      "headword": "transmit"
    },
    {
      "headword": "transparent"
    },
    {
      "headword": "transport"
    },
    {
      "headword": "transport"
    },
    {
      "headword": "transportation"
    },
    {
      "headword": "trap"
    },
    {
      "headword": "trash"
    },
    {
      "headword": "travel"
    },
    {
      "headword": "travel"
    },
    {
      "headword": "travel agent"
    },
    {
      "headword": "traveler/traveller"
    },
    {
      "headword": "traverse"
    },
    {
      "headword": "tray"
    },
    {
      "headword": "tread"
    },
    {
      "headword": "treasure"
    },
    {
      "headword": "treat"
    },
    {
      "headword": "treat"
    },
    {
      "headword": "treatment"
    },
    {
      "headword": "treaty"
    },
    {
      "headword": "tree"
    },
    {
      "headword": "trek"
    },
    {
      "headword": "tremble"
    },
    {
      "headword": "tremendous"
    },
    {
      "headword": "tremendously"
    },
    {
      "headword": "tremor"
    },
    {
      "headword": "trend"
    },
    {
      "headword": "trial"
    },
    {
      "headword": "triangle"
    },
    {
      "headword": "tribe"
    },
    {
      "headword": "trick"
    },
    {
      "headword": "trick"
    },
    {
      "headword": "tricky"
    },
    {
      "headword": "trigger"
    },
    {
      "headword": "trim"
    },
    {
      "headword": "trio"
    },
    {
      "headword": "trip"
    },
    {
      "headword": "trip"
    },
    {
      "headword": "triumph"
    },
    {
      "headword": "trivial"
    },
    {
      "headword": "trolley"
    },
    {
      "headword": "troop"
    },
    {
      "headword": "trophy"
    },
    {
      "headword": "tropic"
    },
    {
      "headword": "tropical"
    },
    {
      "headword": "trouble"
    },
    {
      "headword": "trouble"
    },
    {
      "headword": "troublesome"
    },
    {
      "headword": "trousers"
    },
    {
      "headword": "truck"
    },
    {
      "headword": "TRUE"
    },
    {
      "headword": "truly"
    },
    {
      "headword": "trumpet"
    },
    {
      "headword": "trunk"
    },
    {
      "headword": "trust"
    },
    {
      "headword": "trust"
    },
    {
      "headword": "trustworthy"
    },
    {
      "headword": "trusty"
    },
    {
      "headword": "truth"
    },
    {
      "headword": "truthful"
    },
    {
      "headword": "truthfulness"
    },
    {
      "headword": "try"
    },
    {
      "headword": "try"
    },
    {
      "headword": "T-shirt/tee-shirt"
    },
    {
      "headword": "tub"
    },
    {
      "headword": "tube"
    },
    {
      "headword": "tuberculosis"
    },
    {
      "headword": "Tuesday"
    },
    {
      "headword": "tug"
    },
    {
      "headword": "tuition"
    },
    {
      "headword": "tulip"
    },
    {
      "headword": "tumble"
    },
    {
      "headword": "tumor/tumour"
    },
    {
      "headword": "tuna"
    },
    {
      "headword": "tune"
    },
    {
      "headword": "tunnel"
    },
    {
      "headword": "turbulence"
    },
    {
      "headword": "turbulent"
    },
    {
      "headword": "turkey"
    },
    {
      "headword": "turn"
    },
    {
      "headword": "turn"
    },
    {
      "headword": "turning"
    },
    {
      "headword": "turtle"
    },
    {
      "headword": "tutor"
    },
    {
      "headword": "TV"
    },
    {
      "headword": "twelve"
    },
    {
      "headword": "twenty"
    },
    {
      "headword": "twice"
    },
    {
      "headword": "twin"
    },
    {
      "headword": "twinkle"
    },
    {
      "headword": "twist"
    },
    {
      "headword": "twist"
    },
    {
      "headword": "twisted"
    },
    {
      "headword": "two"
    },
    {
      "headword": "type"
    },
    {
      "headword": "type"
    },
    {
      "headword": "typhoid"
    },
    {
      "headword": "typical"
    },
    {
      "headword": "typically"
    },
    {
      "headword": "tyranny"
    },
    {
      "headword": "tyrant"
    },
    {
      "headword": "ugly"
    },
    {
      "headword": "ultimate"
    },
    {
      "headword": "ultimately"
    },
    {
      "headword": "umbrella"
    },
    {
      "headword": "unable"
    },
    {
      "headword": "unacceptable"
    },
    {
      "headword": "unafraid"
    },
    {
      "headword": "unashamedly"
    },
    {
      "headword": "unattractive"
    },
    {
      "headword": "unauthorized/unauthorised"
    },
    {
      "headword": "unavailable"
    },
    {
      "headword": "unaware"
    },
    {
      "headword": "unbearable"
    },
    {
      "headword": "unbeatable"
    },
    {
      "headword": "unbelievable"
    },
    {
      "headword": "uncertain"
    },
    {
      "headword": "uncertainty"
    },
    {
      "headword": "unchanged"
    },
    {
      "headword": "uncharacteristic"
    },
    {
      "headword": "uncle"
    },
    {
      "headword": "unclear"
    },
    {
      "headword": "unclearly"
    },
    {
      "headword": "uncomfortable"
    },
    {
      "headword": "uncomfortably"
    },
    {
      "headword": "uncommon"
    },
    {
      "headword": "unconcerned"
    },
    {
      "headword": "unconscious"
    },
    {
      "headword": "uncontrollable"
    },
    {
      "headword": "uncover"
    },
    {
      "headword": "under"
    },
    {
      "headword": "underage"
    },
    {
      "headword": "underestimate"
    },
    {
      "headword": "undergo"
    },
    {
      "headword": "undergraduate"
    },
    {
      "headword": "underground"
    },
    {
      "headword": "underground"
    },
    {
      "headword": "underline"
    },
    {
      "headword": "underline"
    },
    {
      "headword": "underneath"
    },
    {
      "headword": "underneath"
    },
    {
      "headword": "underpants"
    },
    {
      "headword": "undersea"
    },
    {
      "headword": "understand"
    },
    {
      "headword": "understandable"
    },
    {
      "headword": "understanding"
    },
    {
      "headword": "understanding"
    },
    {
      "headword": "undertake"
    },
    {
      "headword": "underwater"
    },
    {
      "headword": "underwater"
    },
    {
      "headword": "underwear"
    },
    {
      "headword": "undo"
    },
    {
      "headword": "undoubtedly"
    },
    {
      "headword": "undreamed"
    },
    {
      "headword": "undress"
    },
    {
      "headword": "undressed"
    },
    {
      "headword": "unease"
    },
    {
      "headword": "uneasily"
    },
    {
      "headword": "uneasy"
    },
    {
      "headword": "unemployed"
    },
    {
      "headword": "unemployment"
    },
    {
      "headword": "unenthusiastic"
    },
    {
      "headword": "uneven"
    },
    {
      "headword": "unexpected"
    },
    {
      "headword": "unexpectedly"
    },
    {
      "headword": "unfair"
    },
    {
      "headword": "unfairly"
    },
    {
      "headword": "unfamiliar"
    },
    {
      "headword": "unfashionable"
    },
    {
      "headword": "unfit"
    },
    {
      "headword": "unfold"
    },
    {
      "headword": "unforeseen"
    },
    {
      "headword": "unforgettable"
    },
    {
      "headword": "unfortunate"
    },
    {
      "headword": "unfortunately"
    },
    {
      "headword": "unfriendly"
    },
    {
      "headword": "ungodly"
    },
    {
      "headword": "unhappiness"
    },
    {
      "headword": "unhappy"
    },
    {
      "headword": "unhealthy"
    },
    {
      "headword": "unheard"
    },
    {
      "headword": "unhelpful"
    },
    {
      "headword": "uniform"
    },
    {
      "headword": "uniform"
    },
    {
      "headword": "unify"
    },
    {
      "headword": "unimaginable"
    },
    {
      "headword": "unimaginably"
    },
    {
      "headword": "unimportant"
    },
    {
      "headword": "uninterested"
    },
    {
      "headword": "uninteresting"
    },
    {
      "headword": "union"
    },
    {
      "headword": "unique"
    },
    {
      "headword": "unit"
    },
    {
      "headword": "unite"
    },
    {
      "headword": "united"
    },
    {
      "headword": "universal"
    },
    {
      "headword": "universe"
    },
    {
      "headword": "university"
    },
    {
      "headword": "unjustly"
    },
    {
      "headword": "unkind"
    },
    {
      "headword": "unknown"
    },
    {
      "headword": "unless"
    },
    {
      "headword": "unlike"
    },
    {
      "headword": "unlike"
    },
    {
      "headword": "unlikely"
    },
    {
      "headword": "unlimited"
    },
    {
      "headword": "unload"
    },
    {
      "headword": "unlock"
    },
    {
      "headword": "unlucky"
    },
    {
      "headword": "unmistakable"
    },
    {
      "headword": "unmistakably"
    },
    {
      "headword": "unnatural"
    },
    {
      "headword": "unnecessary"
    },
    {
      "headword": "unofficial"
    },
    {
      "headword": "unpack"
    },
    {
      "headword": "unpleasant"
    },
    {
      "headword": "unpopular"
    },
    {
      "headword": "unpredictable"
    },
    {
      "headword": "unrealistic"
    },
    {
      "headword": "unreasonable"
    },
    {
      "headword": "unrelated"
    },
    {
      "headword": "unreliable"
    },
    {
      "headword": "unrest"
    },
    {
      "headword": "unsafe"
    },
    {
      "headword": "unsatisfactory"
    },
    {
      "headword": "unselfish"
    },
    {
      "headword": "unstoppable"
    },
    {
      "headword": "unsuccessful"
    },
    {
      "headword": "unsuitable"
    },
    {
      "headword": "unsure"
    },
    {
      "headword": "untalented"
    },
    {
      "headword": "unthinkably"
    },
    {
      "headword": "untidy"
    },
    {
      "headword": "untie"
    },
    {
      "headword": "until"
    },
    {
      "headword": "until"
    },
    {
      "headword": "unto"
    },
    {
      "headword": "untreated"
    },
    {
      "headword": "untrimmed"
    },
    {
      "headword": "unusual"
    },
    {
      "headword": "unusually"
    },
    {
      "headword": "unusualness"
    },
    {
      "headword": "unwanted"
    },
    {
      "headword": "unwell"
    },
    {
      "headword": "unwilling"
    },
    {
      "headword": "unwise"
    },
    {
      "headword": "unworldly"
    },
    {
      "headword": "up"
    },
    {
      "headword": "up"
    },
    {
      "headword": "upbringing"
    },
    {
      "headword": "update"
    },
    {
      "headword": "update"
    },
    {
      "headword": "upgrade"
    },
    {
      "headword": "upgrade"
    },
    {
      "headword": "uplifted"
    },
    {
      "headword": "upload"
    },
    {
      "headword": "upon"
    },
    {
      "headword": "upper"
    },
    {
      "headword": "upright"
    },
    {
      "headword": "upright"
    },
    {
      "headword": "upset"
    },
    {
      "headword": "upset"
    },
    {
      "headword": "upside down"
    },
    {
      "headword": "upside down"
    },
    {
      "headword": "upstairs"
    },
    {
      "headword": "upstairs"
    },
    {
      "headword": "upstairs"
    },
    {
      "headword": "up-to-date"
    },
    {
      "headword": "upward"
    },
    {
      "headword": "urban"
    },
    {
      "headword": "urge"
    },
    {
      "headword": "urge"
    },
    {
      "headword": "urgent"
    },
    {
      "headword": "urgently"
    },
    {
      "headword": "us"
    },
    {
      "headword": "usage"
    },
    {
      "headword": "use"
    },
    {
      "headword": "use"
    },
    {
      "headword": "used"
    },
    {
      "headword": "used to"
    },
    {
      "headword": "useful"
    },
    {
      "headword": "useless"
    },
    {
      "headword": "user"
    },
    {
      "headword": "usher"
    },
    {
      "headword": "usual"
    },
    {
      "headword": "usually"
    },
    {
      "headword": "utility"
    },
    {
      "headword": "utilize/utilise"
    },
    {
      "headword": "utter"
    },
    {
      "headword": "utterly"
    },
    {
      "headword": "vacancy"
    },
    {
      "headword": "vacant"
    },
    {
      "headword": "vacation"
    },
    {
      "headword": "vaccine"
    },
    {
      "headword": "vague"
    },
    {
      "headword": "vain"
    },
    {
      "headword": "valentine"
    },
    {
      "headword": "valid"
    },
    {
      "headword": "valley"
    },
    {
      "headword": "valuable"
    },
    {
      "headword": "value"
    },
    {
      "headword": "value"
    },
    {
      "headword": "van"
    },
    {
      "headword": "vanish"
    },
    {
      "headword": "vanity"
    },
    {
      "headword": "variation"
    },
    {
      "headword": "varied"
    },
    {
      "headword": "variety"
    },
    {
      "headword": "various"
    },
    {
      "headword": "vary"
    },
    {
      "headword": "vase"
    },
    {
      "headword": "vast"
    },
    {
      "headword": "vegetable"
    },
    {
      "headword": "vegetarian"
    },
    {
      "headword": "vegetarian"
    },
    {
      "headword": "vehicle"
    },
    {
      "headword": "vein"
    },
    {
      "headword": "venture"
    },
    {
      "headword": "venue"
    },
    {
      "headword": "verb"
    },
    {
      "headword": "verbal"
    },
    {
      "headword": "verbally"
    },
    {
      "headword": "verse"
    },
    {
      "headword": "verse"
    },
    {
      "headword": "version"
    },
    {
      "headword": "versus"
    },
    {
      "headword": "very"
    },
    {
      "headword": "very"
    },
    {
      "headword": "vessel"
    },
    {
      "headword": "vet"
    },
    {
      "headword": "veteran"
    },
    {
      "headword": "via"
    },
    {
      "headword": "vibrate"
    },
    {
      "headword": "vibration"
    },
    {
      "headword": "vice"
    },
    {
      "headword": "vice president"
    },
    {
      "headword": "victim"
    },
    {
      "headword": "victory"
    },
    {
      "headword": "video"
    },
    {
      "headword": "video clip"
    },
    {
      "headword": "video game"
    },
    {
      "headword": "view"
    },
    {
      "headword": "view"
    },
    {
      "headword": "viewer"
    },
    {
      "headword": "viewpoint"
    },
    {
      "headword": "vigor/vigour"
    },
    {
      "headword": "vigorous"
    },
    {
      "headword": "vigorously"
    },
    {
      "headword": "villa"
    },
    {
      "headword": "village"
    },
    {
      "headword": "villager"
    },
    {
      "headword": "vinegar"
    },
    {
      "headword": "violate"
    },
    {
      "headword": "violence"
    },
    {
      "headword": "violent"
    },
    {
      "headword": "violently"
    },
    {
      "headword": "violin"
    },
    {
      "headword": "virtual"
    },
    {
      "headword": "virtual reality"
    },
    {
      "headword": "virtually"
    },
    {
      "headword": "virtue"
    },
    {
      "headword": "virus"
    },
    {
      "headword": "visa"
    },
    {
      "headword": "visible"
    },
    {
      "headword": "visibly"
    },
    {
      "headword": "vision"
    },
    {
      "headword": "visit"
    },
    {
      "headword": "visit"
    },
    {
      "headword": "visitor"
    },
    {
      "headword": "visual"
    },
    {
      "headword": "visually"
    },
    {
      "headword": "vital"
    },
    {
      "headword": "vitamin"
    },
    {
      "headword": "vivid"
    },
    {
      "headword": "vividly"
    },
    {
      "headword": "vocabulary"
    },
    {
      "headword": "vocalist"
    },
    {
      "headword": "voice"
    },
    {
      "headword": "volcano"
    },
    {
      "headword": "volleyball"
    },
    {
      "headword": "volume"
    },
    {
      "headword": "volunteer"
    },
    {
      "headword": "volunteer"
    },
    {
      "headword": "vomit"
    },
    {
      "headword": "vote"
    },
    {
      "headword": "vote"
    },
    {
      "headword": "voter"
    },
    {
      "headword": "vow"
    },
    {
      "headword": "vowel"
    },
    {
      "headword": "voyage"
    },
    {
      "headword": "wage"
    },
    {
      "headword": "wagon"
    },
    {
      "headword": "waist"
    },
    {
      "headword": "waistcoat"
    },
    {
      "headword": "wait"
    },
    {
      "headword": "wait"
    },
    {
      "headword": "waiter"
    },
    {
      "headword": "waitress"
    },
    {
      "headword": "wake"
    },
    {
      "headword": "wake"
    },
    {
      "headword": "walk"
    },
    {
      "headword": "walk"
    },
    {
      "headword": "walkabout"
    },
    {
      "headword": "walker"
    },
    {
      "headword": "walking"
    },
    {
      "headword": "wall"
    },
    {
      "headword": "wallboard"
    },
    {
      "headword": "wallet"
    },
    {
      "headword": "walnut"
    },
    {
      "headword": "wander"
    },
    {
      "headword": "want"
    },
    {
      "headword": "want"
    },
    {
      "headword": "war"
    },
    {
      "headword": "ward"
    },
    {
      "headword": "wardrobe"
    },
    {
      "headword": "warm"
    },
    {
      "headword": "warm"
    },
    {
      "headword": "warmly"
    },
    {
      "headword": "warmth"
    },
    {
      "headword": "warn"
    },
    {
      "headword": "warning"
    },
    {
      "headword": "warranty"
    },
    {
      "headword": "warrior"
    },
    {
      "headword": "warship"
    },
    {
      "headword": "wartime"
    },
    {
      "headword": "was"
    },
    {
      "headword": "wash"
    },
    {
      "headword": "wash"
    },
    {
      "headword": "washbowl"
    },
    {
      "headword": "washing machine"
    },
    {
      "headword": "washing-up"
    },
    {
      "headword": "wasp"
    },
    {
      "headword": "waste"
    },
    {
      "headword": "waste"
    },
    {
      "headword": "waste"
    },
    {
      "headword": "wasteful"
    },
    {
      "headword": "watch"
    },
    {
      "headword": "watch"
    },
    {
      "headword": "water"
    },
    {
      "headword": "water"
    },
    {
      "headword": "waterfall"
    },
    {
      "headword": "waterproof"
    },
    {
      "headword": "wave"
    },
    {
      "headword": "wave"
    },
    {
      "headword": "wax"
    },
    {
      "headword": "wax"
    },
    {
      "headword": "way"
    },
    {
      "headword": "we"
    },
    {
      "headword": "weak"
    },
    {
      "headword": "weaken"
    },
    {
      "headword": "weakly"
    },
    {
      "headword": "weakness"
    },
    {
      "headword": "wealth"
    },
    {
      "headword": "wealthy"
    },
    {
      "headword": "weapon"
    },
    {
      "headword": "wear"
    },
    {
      "headword": "wearisome"
    },
    {
      "headword": "weary"
    },
    {
      "headword": "weather"
    },
    {
      "headword": "weather forecast"
    },
    {
      "headword": "weave"
    },
    {
      "headword": "web"
    },
    {
      "headword": "web page"
    },
    {
      "headword": "webcam"
    },
    {
      "headword": "website"
    },
    {
      "headword": "wed"
    },
    {
      "headword": "wedding"
    },
    {
      "headword": "Wednesday"
    },
    {
      "headword": "weed"
    },
    {
      "headword": "week"
    },
    {
      "headword": "weekday"
    },
    {
      "headword": "weekend"
    },
    {
      "headword": "weekly"
    },
    {
      "headword": "weekly"
    },
    {
      "headword": "weep"
    },
    {
      "headword": "weigh"
    },
    {
      "headword": "weight"
    },
    {
      "headword": "weird"
    },
    {
      "headword": "welcome"
    },
    {
      "headword": "welcome"
    },
    {
      "headword": "welcome"
    },
    {
      "headword": "welcome"
    },
    {
      "headword": "welfare"
    },
    {
      "headword": "well"
    },
    {
      "headword": "well"
    },
    {
      "headword": "well-balanced"
    },
    {
      "headword": "well-built"
    },
    {
      "headword": "well-dressed"
    },
    {
      "headword": "well-known"
    },
    {
      "headword": "well-organized/well-organised"
    },
    {
      "headword": "well-paid"
    },
    {
      "headword": "were"
    },
    {
      "headword": "west"
    },
    {
      "headword": "west"
    },
    {
      "headword": "west"
    },
    {
      "headword": "western"
    },
    {
      "headword": "westward"
    },
    {
      "headword": "wet"
    },
    {
      "headword": "wetland"
    },
    {
      "headword": "whale"
    },
    {
      "headword": "what"
    },
    {
      "headword": "what"
    },
    {
      "headword": "whatever"
    },
    {
      "headword": "whatever"
    },
    {
      "headword": "wheat"
    },
    {
      "headword": "wheel"
    },
    {
      "headword": "wheelchair"
    },
    {
      "headword": "when"
    },
    {
      "headword": "when"
    },
    {
      "headword": "whenever"
    },
    {
      "headword": "whenever"
    },
    {
      "headword": "where"
    },
    {
      "headword": "where"
    },
    {
      "headword": "whereas"
    },
    {
      "headword": "wherever"
    },
    {
      "headword": "whether"
    },
    {
      "headword": "which"
    },
    {
      "headword": "which"
    },
    {
      "headword": "whichever"
    },
    {
      "headword": "whichever"
    },
    {
      "headword": "while"
    },
    {
      "headword": "while"
    },
    {
      "headword": "whip"
    },
    {
      "headword": "whiskey/whisky"
    },
    {
      "headword": "whisper"
    },
    {
      "headword": "whisper"
    },
    {
      "headword": "whistle"
    },
    {
      "headword": "whistle"
    },
    {
      "headword": "white"
    },
    {
      "headword": "white"
    },
    {
      "headword": "who"
    },
    {
      "headword": "whoever"
    },
    {
      "headword": "whole"
    },
    {
      "headword": "whole"
    },
    {
      "headword": "whom"
    },
    {
      "headword": "whose"
    },
    {
      "headword": "whose"
    },
    {
      "headword": "why"
    },
    {
      "headword": "wide"
    },
    {
      "headword": "wide"
    },
    {
      "headword": "widely"
    },
    {
      "headword": "widen"
    },
    {
      "headword": "widespread"
    },
    {
      "headword": "widow"
    },
    {
      "headword": "width"
    },
    {
      "headword": "wife"
    },
    {
      "headword": "wild"
    },
    {
      "headword": "wilderness"
    },
    {
      "headword": "wildlife"
    },
    {
      "headword": "wildly"
    },
    {
      "headword": "will"
    },
    {
      "headword": "will"
    },
    {
      "headword": "willing"
    },
    {
      "headword": "willingly"
    },
    {
      "headword": "willingness"
    },
    {
      "headword": "win"
    },
    {
      "headword": "win"
    },
    {
      "headword": "wind"
    },
    {
      "headword": "wind"
    },
    {
      "headword": "winding"
    },
    {
      "headword": "window"
    },
    {
      "headword": "windscreen"
    },
    {
      "headword": "windshield"
    },
    {
      "headword": "windsurfing"
    },
    {
      "headword": "windy"
    },
    {
      "headword": "wine"
    },
    {
      "headword": "wing"
    },
    {
      "headword": "wink"
    },
    {
      "headword": "winner"
    },
    {
      "headword": "winter"
    },
    {
      "headword": "wipe"
    },
    {
      "headword": "wire"
    },
    {
      "headword": "wire"
    },
    {
      "headword": "wisdom"
    },
    {
      "headword": "wise"
    },
    {
      "headword": "wish"
    },
    {
      "headword": "wish"
    },
    {
      "headword": "wit"
    },
    {
      "headword": "with"
    },
    {
      "headword": "withdraw"
    },
    {
      "headword": "withdrawal"
    },
    {
      "headword": "wither"
    },
    {
      "headword": "within"
    },
    {
      "headword": "without"
    },
    {
      "headword": "witness"
    },
    {
      "headword": "witness"
    },
    {
      "headword": "witty"
    },
    {
      "headword": "wizard"
    },
    {
      "headword": "wolf"
    },
    {
      "headword": "woman"
    },
    {
      "headword": "wonder"
    },
    {
      "headword": "wonder"
    },
    {
      "headword": "wonderful"
    },
    {
      "headword": "wondrous"
    },
    {
      "headword": "wood"
    },
    {
      "headword": "woodcarving"
    },
    {
      "headword": "wooden"
    },
    {
      "headword": "wool"
    },
    {
      "headword": "word"
    },
    {
      "headword": "wordlessly"
    },
    {
      "headword": "work"
    },
    {
      "headword": "work"
    },
    {
      "headword": "workaholic"
    },
    {
      "headword": "workbench"
    },
    {
      "headword": "worker"
    },
    {
      "headword": "working"
    },
    {
      "headword": "workman"
    },
    {
      "headword": "workout"
    },
    {
      "headword": "workplace"
    },
    {
      "headword": "workshop"
    },
    {
      "headword": "worktable"
    },
    {
      "headword": "world"
    },
    {
      "headword": "worldly"
    },
    {
      "headword": "worldview"
    },
    {
      "headword": "worldwide"
    },
    {
      "headword": "worldwide"
    },
    {
      "headword": "worm"
    },
    {
      "headword": "worn"
    },
    {
      "headword": "wornout/worn out/worn-out"
    },
    {
      "headword": "worried"
    },
    {
      "headword": "worry"
    },
    {
      "headword": "worry"
    },
    {
      "headword": "worrying"
    },
    {
      "headword": "worse"
    },
    {
      "headword": "worse"
    },
    {
      "headword": "worse"
    },
    {
      "headword": "worsen"
    },
    {
      "headword": "worship"
    },
    {
      "headword": "worst"
    },
    {
      "headword": "worst"
    },
    {
      "headword": "worst"
    },
    {
      "headword": "worth"
    },
    {
      "headword": "worthless"
    },
    {
      "headword": "worthwhile"
    },
    {
      "headword": "worthy"
    },
    {
      "headword": "would"
    },
    {
      "headword": "wound"
    },
    {
      "headword": "wound"
    },
    {
      "headword": "wrap"
    },
    {
      "headword": "wrap"
    },
    {
      "headword": "wrapping"
    },
    {
      "headword": "wreck"
    },
    {
      "headword": "wrist"
    },
    {
      "headword": "wristwatch"
    },
    {
      "headword": "write"
    },
    {
      "headword": "writer"
    },
    {
      "headword": "writing"
    },
    {
      "headword": "written"
    },
    {
      "headword": "wrong"
    },
    {
      "headword": "wrong"
    },
    {
      "headword": "wrongly"
    },
    {
      "headword": "X-ray"
    },
    {
      "headword": "yacht"
    },
    {
      "headword": "yard"
    },
    {
      "headword": "yawn"
    },
    {
      "headword": "yawn"
    },
    {
      "headword": "yeah"
    },
    {
      "headword": "year"
    },
    {
      "headword": "yearn"
    },
    {
      "headword": "yell"
    },
    {
      "headword": "yell"
    },
    {
      "headword": "yellow"
    },
    {
      "headword": "yellow"
    },
    {
      "headword": "yes"
    },
    {
      "headword": "yesterday"
    },
    {
      "headword": "yet"
    },
    {
      "headword": "yet"
    },
    {
      "headword": "yield"
    },
    {
      "headword": "yoga"
    },
    {
      "headword": "yogurt/yoghurt"
    },
    {
      "headword": "you"
    },
    {
      "headword": "young"
    },
    {
      "headword": "your"
    },
    {
      "headword": "yours"
    },
    {
      "headword": "yourself"
    },
    {
      "headword": "youth"
    },
    {
      "headword": "youthful"
    },
    {
      "headword": "yummy"
    },
    {
      "headword": "zebra"
    },
    {
      "headword": "zip"
    },
    {
      "headword": "zone"
    },
    {
      "headword": "zoo"
    },
    {
      "headword": "zoom"
    },
    {
      "headword": "xterior"
    },
    {
      "headword": "cloak"
    },
    {
      "headword": "timid"
    },
    {
      "headword": "reluctantly"
    },
    {
      "headword": "complexity"
    },
    {
      "headword": "concur"
    },
    {
      "headword": "avid"
    },
    {
      "headword": "marvel"
    },
    {
      "headword": "wing"
    },
    {
      "headword": "enviable"
    },
    {
      "headword": "organizational"
    },
    {
      "headword": "psychiatrist"
    },
    {
      "headword": "psychiatric"
    },
    {
      "headword": "clinical"
    },
    {
      "headword": "corps"
    },
    {
      "headword": "forensic"
    },
    {
      "headword": "juvenile"
    },
    {
      "headword": "juvenile"
    },
    {
      "headword": "jurisdiction"
    },
    {
      "headword": "accustomed"
    },
    {
      "headword": "trauma"
    },
    {
      "headword": "traumatic"
    },
    {
      "headword": "constraint"
    },
    {
      "headword": "revealing"
    },
    {
      "headword": "eccentric"
    },
    {
      "headword": "sanctity"
    },
    {
      "headword": "conform"
    },
    {
      "headword": "norms"
    },
    {
      "headword": "quirk"
    },
    {
      "headword": "oddity"
    },
    {
      "headword": "compel"
    },
    {
      "headword": "compulsion"
    },
    {
      "headword": "conceive"
    },
    {
      "headword": "conceivable"
    },
    {
      "headword": "assertion"
    },
    {
      "headword": "individuality"
    },
    {
      "headword": "psyche"
    },
    {
      "headword": "conformity"
    },
    {
      "headword": "unconventional"
    },
    {
      "headword": "congregate"
    },
    {
      "headword": "rally"
    },
    {
      "headword": "resent"
    },
    {
      "headword": "self-conscious"
    },
    {
      "headword": "wary"
    },
    {
      "headword": "stoke"
    },
    {
      "headword": "dynamically"
    },
    {
      "headword": "hostess"
    },
    {
      "headword": "perpetuate"
    },
    {
      "headword": "naturalness"
    },
    {
      "headword": "exhibitionist"
    },
    {
      "headword": "isolate"
    },
    {
      "headword": "isolated"
    },
    {
      "headword": "humble"
    },
    {
      "headword": "humble"
    },
    {
      "headword": "refreshingly"
    },
    {
      "headword": "effortless"
    },
    {
      "headword": "vegetation"
    },
    {
      "headword": "brief"
    },
    {
      "headword": "respite"
    },
    {
      "headword": "suffice"
    },
    {
      "headword": "purity"
    },
    {
      "headword": "gruelling"
    },
    {
      "headword": "cast"
    },
    {
      "headword": "cast"
    },
    {
      "headword": "cast"
    },
    {
      "headword": "comprise"
    },
    {
      "headword": "plaster"
    },
    {
      "headword": "plaster"
    },
    {
      "headword": "darkroom"
    },
    {
      "headword": "induct"
    },
    {
      "headword": "induction"
    },
    {
      "headword": "stock"
    },
    {
      "headword": "fossil"
    },
    {
      "headword": "geological"
    },
    {
      "headword": "geologically"
    },
    {
      "headword": "house"
    },
    {
      "headword": "specimen"
    },
    {
      "headword": "enormously"
    },
    {
      "headword": "gem"
    },
    {
      "headword": "explanatory"
    },
    {
      "headword": "vertical"
    },
    {
      "headword": "knowledgeable"
    },
    {
      "headword": "ordinarily"
    },
    {
      "headword": "hanging"
    },
    {
      "headword": "hanging"
    },
    {
      "headword": "tomb"
    },
    {
      "headword": "formulate"
    },
    {
      "headword": "resin"
    },
    {
      "headword": "sacrifice"
    },
    {
      "headword": "sacrifice"
    },
    {
      "headword": "cleanly"
    },
    {
      "headword": "endorsement"
    },
    {
      "headword": "stretching"
    },
    {
      "headword": "continuity"
    },
    {
      "headword": "shambles"
    },
    {
      "headword": "claustrophobic"
    },
    {
      "headword": "claustrophobia"
    },
    {
      "headword": "headstrong"
    },
    {
      "headword": "tact"
    },
    {
      "headword": "tactful"
    },
    {
      "headword": "tactfully"
    },
    {
      "headword": "blister"
    },
    {
      "headword": "blister"
    },
    {
      "headword": "sponsorship"
    },
    {
      "headword": "ego"
    },
    {
      "headword": "class"
    },
    {
      "headword": "saloon"
    },
    {
      "headword": "lap"
    },
    {
      "headword": "beforehand"
    },
    {
      "headword": "slob"
    },
    {
      "headword": "coverage"
    },
    {
      "headword": "unplug"
    },
    {
      "headword": "gadget"
    },
    {
      "headword": "rediscover"
    },
    {
      "headword": "subtly"
    },
    {
      "headword": "brainwash"
    },
    {
      "headword": "brainwashing"
    },
    {
      "headword": "implicate"
    },
    {
      "headword": "craft"
    },
    {
      "headword": "malfunction"
    },
    {
      "headword": "dependent"
    },
    {
      "headword": "wayside"
    },
    {
      "headword": "expire"
    },
    {
      "headword": "con"
    },
    {
      "headword": "con"
    },
    {
      "headword": "puzzle"
    },
    {
      "headword": "damply"
    },
    {
      "headword": "ghostly"
    },
    {
      "headword": "carrier"
    },
    {
      "headword": "washtub"
    },
    {
      "headword": "apt"
    },
    {
      "headword": "apt to"
    },
    {
      "headword": "portable"
    },
    {
      "headword": "portable"
    },
    {
      "headword": "ornamental"
    },
    {
      "headword": "placid"
    },
    {
      "headword": "placidly"
    },
    {
      "headword": "unmanageable"
    },
    {
      "headword": "appliance"
    },
    {
      "headword": "relinquish"
    },
    {
      "headword": "tedious"
    },
    {
      "headword": "tedium"
    },
    {
      "headword": "exert"
    },
    {
      "headword": "extortion"
    },
    {
      "headword": "alleviate"
    },
    {
      "headword": "elaborate"
    },
    {
      "headword": "elaborate"
    },
    {
      "headword": "elaboration"
    },
    {
      "headword": "detest"
    },
    {
      "headword": "detestable"
    },
    {
      "headword": "suds"
    },
    {
      "headword": "agreeable"
    },
    {
      "headword": "prowl"
    },
    {
      "headword": "speculate"
    },
    {
      "headword": "speculation"
    },
    {
      "headword": "speculative"
    },
    {
      "headword": "peacock"
    },
    {
      "headword": "disdain"
    },
    {
      "headword": "reenact"
    },
    {
      "headword": "torment"
    },
    {
      "headword": "torment"
    },
    {
      "headword": "extravagance"
    },
    {
      "headword": "exploit"
    },
    {
      "headword": "exploitation"
    },
    {
      "headword": "mechanism"
    },
    {
      "headword": "hence"
    },
    {
      "headword": "offspring"
    },
    {
      "headword": "implicate"
    },
    {
      "headword": "fit"
    },
    {
      "headword": "oblige"
    },
    {
      "headword": "drive"
    },
    {
      "headword": "drive"
    },
    {
      "headword": "collaborate"
    },
    {
      "headword": "collaborator"
    },
    {
      "headword": "collaboration"
    },
    {
      "headword": "collaborative"
    },
    {
      "headword": "showy"
    },
    {
      "headword": "wrangle"
    },
    {
      "headword": "premise"
    },
    {
      "headword": "advantageous"
    },
    {
      "headword": "parasite"
    },
    {
      "headword": "fanciful"
    },
    {
      "headword": "poise"
    },
    {
      "headword": "customary"
    },
    {
      "headword": "insightful"
    },
    {
      "headword": "notable"
    },
    {
      "headword": "vicious"
    },
    {
      "headword": "viciously"
    },
    {
      "headword": "pupil"
    },
    {
      "headword": "withdrawn"
    },
    {
      "headword": "withdrawal"
    },
    {
      "headword": "torturous"
    },
    {
      "headword": "depict"
    },
    {
      "headword": "depiction"
    },
    {
      "headword": "upheaval"
    },
    {
      "headword": "shortlist"
    },
    {
      "headword": "shortlist"
    },
    {
      "headword": "uneventful"
    },
    {
      "headword": "pertinent"
    },
    {
      "headword": "pertain to"
    },
    {
      "headword": "daydream"
    },
    {
      "headword": "daydream"
    },
    {
      "headword": "protagonist"
    },
    {
      "headword": "simplicity"
    },
    {
      "headword": "blockbuster"
    },
    {
      "headword": "resonate"
    },
    {
      "headword": "sequel"
    },
    {
      "headword": "irony"
    },
    {
      "headword": "acidic"
    },
    {
      "headword": "align"
    },
    {
      "headword": "alignment"
    },
    {
      "headword": "manipulation"
    },
    {
      "headword": "suitor"
    },
    {
      "headword": "deceit"
    },
    {
      "headword": "alienate"
    },
    {
      "headword": "persuasively"
    },
    {
      "headword": "compel"
    },
    {
      "headword": "confinement"
    },
    {
      "headword": "minutiae"
    },
    {
      "headword": "peasant"
    },
    {
      "headword": "inexplicable"
    },
    {
      "headword": "inexplicably"
    },
    {
      "headword": "pigeon"
    },
    {
      "headword": "harass"
    },
    {
      "headword": "harassment"
    },
    {
      "headword": "believably"
    },
    {
      "headword": "readable"
    },
    {
      "headword": "cleverness"
    },
    {
      "headword": "persecute"
    },
    {
      "headword": "persecution"
    },
    {
      "headword": "smug"
    },
    {
      "headword": "smugly"
    },
    {
      "headword": "ferocious"
    },
    {
      "headword": "ferociously"
    },
    {
      "headword": "hostile"
    },
    {
      "headword": "hostility"
    },
    {
      "headword": "dismay"
    },
    {
      "headword": "dismay"
    },
    {
      "headword": "methodical"
    },
    {
      "headword": "ruthless"
    },
    {
      "headword": "ruthlessness"
    },
    {
      "headword": "talkative"
    },
    {
      "headword": "awe"
    },
    {
      "headword": "clan"
    },
    {
      "headword": "privileged"
    },
    {
      "headword": "crumble"
    },
    {
      "headword": "crumb"
    },
    {
      "headword": "pace"
    },
    {
      "headword": "closeness"
    },
    {
      "headword": "rarity"
    },
    {
      "headword": "evoke"
    },
    {
      "headword": "repel"
    },
    {
      "headword": "repellant"
    },
    {
      "headword": "repellant"
    },
    {
      "headword": "aqua"
    },
    {
      "headword": "aquarium"
    },
    {
      "headword": "insightful"
    },
    {
      "headword": "insightfully"
    },
    {
      "headword": "flashback"
    },
    {
      "headword": "self-worth"
    },
    {
      "headword": "agonize"
    },
    {
      "headword": "cite"
    },
    {
      "headword": "citation"
    },
    {
      "headword": "recite"
    },
    {
      "headword": "ecstasy"
    },
    {
      "headword": "ecstatic"
    },
    {
      "headword": "ecstatically"
    },
    {
      "headword": "pleasurable"
    },
    {
      "headword": "nature"
    },
    {
      "headword": "substantially"
    },
    {
      "headword": "favorably/favourably"
    },
    {
      "headword": "diversity"
    },
    {
      "headword": "elitist"
    },
    {
      "headword": "grumble"
    },
    {
      "headword": "rumble"
    },
    {
      "headword": "rumble"
    },
    {
      "headword": "neglectful"
    },
    {
      "headword": "roundup"
    },
    {
      "headword": "conscientious"
    },
    {
      "headword": "conscientiously"
    },
    {
      "headword": "indefinite"
    },
    {
      "headword": "indefinitely"
    },
    {
      "headword": "atmospheric"
    },
    {
      "headword": "fuse"
    },
    {
      "headword": "fusion"
    },
    {
      "headword": "robust"
    },
    {
      "headword": "robustly"
    },
    {
      "headword": "dismal"
    },
    {
      "headword": "dismally"
    },
    {
      "headword": "crave"
    },
    {
      "headword": "craving"
    },
    {
      "headword": "prospective"
    },
    {
      "headword": "swap"
    },
    {
      "headword": "remotely"
    },
    {
      "headword": "splatter"
    },
    {
      "headword": "automatic"
    },
    {
      "headword": "automatically"
    },
    {
      "headword": "exhaust"
    },
    {
      "headword": "violet"
    },
    {
      "headword": "bubbly"
    },
    {
      "headword": "chaotically"
    },
    {
      "headword": "apprehensive"
    },
    {
      "headword": "settee"
    },
    {
      "headword": "trampoline"
    },
    {
      "headword": "stamina"
    },
    {
      "headword": "ploy"
    },
    {
      "headword": "dither"
    },
    {
      "headword": "overalls"
    },
    {
      "headword": "unison"
    },
    {
      "headword": "snail"
    },
    {
      "headword": "bliss"
    },
    {
      "headword": "inexhaustible"
    },
    {
      "headword": "acre"
    },
    {
      "headword": "calf"
    },
    {
      "headword": "heifer"
    },
    {
      "headword": "ewe"
    },
    {
      "headword": "adversary"
    },
    {
      "headword": "victorious"
    },
    {
      "headword": "victoriously"
    },
    {
      "headword": "profound"
    },
    {
      "headword": "profoundly"
    },
    {
      "headword": "baldly"
    },
    {
      "headword": "bald"
    },
    {
      "headword": "bearded"
    },
    {
      "headword": "professionalism"
    },
    {
      "headword": "artistically"
    },
    {
      "headword": "popularization"
    },
    {
      "headword": "pendulum"
    },
    {
      "headword": "predecessor"
    },
    {
      "headword": "boast"
    },
    {
      "headword": "lapse"
    },
    {
      "headword": "ceaseless"
    },
    {
      "headword": "ceaselessly"
    },
    {
      "headword": "climax"
    },
    {
      "headword": "climactic"
    },
    {
      "headword": "anticlimactic"
    },
    {
      "headword": "scramble"
    },
    {
      "headword": "forfeit"
    },
    {
      "headword": "twitch"
    },
    {
      "headword": "twitch"
    },
    {
      "headword": "intellect"
    },
    {
      "headword": "descent"
    },
    {
      "headword": "shed"
    },
    {
      "headword": "exodus"
    },
    {
      "headword": "immortalize"
    },
    {
      "headword": "genome"
    },
    {
      "headword": "fraction"
    },
    {
      "headword": "faction"
    },
    {
      "headword": "physique"
    },
    {
      "headword": "utensil"
    },
    {
      "headword": "otter"
    },
    {
      "headword": "clammy"
    },
    {
      "headword": "absolute"
    },
    {
      "headword": "dispense"
    },
    {
      "headword": "dispensable"
    },
    {
      "headword": "dispensary"
    },
    {
      "headword": "indispensable"
    },
    {
      "headword": "diverge"
    },
    {
      "headword": "divergence"
    },
    {
      "headword": "divergent"
    },
    {
      "headword": "burst"
    },
    {
      "headword": "superficial"
    },
    {
      "headword": "superficially"
    },
    {
      "headword": "aesthetic"
    },
    {
      "headword": "aesthetically"
    },
    {
      "headword": "scrutinize/scrutinise"
    },
    {
      "headword": "scrutiny"
    },
    {
      "headword": "quip"
    },
    {
      "headword": "quip"
    },
    {
      "headword": "woo"
    },
    {
      "headword": "criteria"
    },
    {
      "headword": "plausible"
    },
    {
      "headword": "plausibility"
    },
    {
      "headword": "plausibly"
    },
    {
      "headword": "instinctive"
    },
    {
      "headword": "instinctively"
    },
    {
      "headword": "stylistic"
    },
    {
      "headword": "stylistically"
    },
    {
      "headword": "inheritance"
    },
    {
      "headword": "inherent"
    },
    {
      "headword": "inherently"
    },
    {
      "headword": "tune"
    },
    {
      "headword": "spontaneous"
    },
    {
      "headword": "spontaneously"
    },
    {
      "headword": "honk"
    },
    {
      "headword": "honk"
    },
    {
      "headword": "goose"
    },
    {
      "headword": "innovate"
    },
    {
      "headword": "innovation"
    },
    {
      "headword": "innovative"
    },
    {
      "headword": "connoisseur"
    },
    {
      "headword": "abstraction"
    },
    {
      "headword": "tantrum"
    },
    {
      "headword": "institute"
    },
    {
      "headword": "discard"
    },
    {
      "headword": "fatality"
    },
    {
      "headword": "angle"
    },
    {
      "headword": "stiffen"
    },
    {
      "headword": "wooded"
    },
    {
      "headword": "hostile"
    },
    {
      "headword": "hostility"
    },
    {
      "headword": "flatter"
    },
    {
      "headword": "flattery"
    },
    {
      "headword": "aimless"
    },
    {
      "headword": "aimlessly"
    },
    {
      "headword": "meaningless"
    },
    {
      "headword": "meaninglessly"
    },
    {
      "headword": "candid"
    },
    {
      "headword": "candidly"
    },
    {
      "headword": "vitality"
    },
    {
      "headword": "provoke"
    },
    {
      "headword": "provocative"
    },
    {
      "headword": "provocatively"
    },
    {
      "headword": "clench"
    },
    {
      "headword": "haggle"
    },
    {
      "headword": "scorn"
    },
    {
      "headword": "scornful"
    },
    {
      "headword": "scornfully"
    },
    {
      "headword": "animatedly"
    },
    {
      "headword": "obscure"
    },
    {
      "headword": "obscure"
    },
    {
      "headword": "obscurely"
    },
    {
      "headword": "elevate"
    },
    {
      "headword": "elevation"
    },
    {
      "headword": "pose"
    },
    {
      "headword": "tedious"
    },
    {
      "headword": "tediously"
    },
    {
      "headword": "succession"
    },
    {
      "headword": "formality"
    },
    {
      "headword": "jog"
    },
    {
      "headword": "mountaineer"
    },
    {
      "headword": "pioneer"
    },
    {
      "headword": "pioneer"
    },
    {
      "headword": "quest"
    },
    {
      "headword": "transatlantic"
    },
    {
      "headword": "rudiments"
    },
    {
      "headword": "rudimentary"
    },
    {
      "headword": "paddle"
    },
    {
      "headword": "immense"
    },
    {
      "headword": "immensely"
    },
    {
      "headword": "advisory"
    },
    {
      "headword": "trying"
    },
    {
      "headword": "adrenaline"
    },
    {
      "headword": "tinker"
    },
    {
      "headword": "tinker"
    },
    {
      "headword": "lavatory"
    },
    {
      "headword": "expedition"
    },
    {
      "headword": "pinnacle"
    },
    {
      "headword": "insecure"
    },
    {
      "headword": "insecurely"
    },
    {
      "headword": "reassure"
    },
    {
      "headword": "reassurance"
    },
    {
      "headword": "insensitive"
    },
    {
      "headword": "insensitively"
    },
    {
      "headword": "profess"
    },
    {
      "headword": "drawback"
    },
    {
      "headword": "resort"
    },
    {
      "headword": "resort"
    },
    {
      "headword": "oversee"
    },
    {
      "headword": "overseer"
    },
    {
      "headword": "estimation"
    },
    {
      "headword": "commission"
    },
    {
      "headword": "commission"
    },
    {
      "headword": "liaison"
    },
    {
      "headword": "stressfully"
    },
    {
      "headword": "loom"
    },
    {
      "headword": "notwithstanding"
    },
    {
      "headword": "structurally"
    },
    {
      "headword": "structural"
    },
    {
      "headword": "chauffer"
    },
    {
      "headword": "chauffer"
    },
    {
      "headword": "sedentary"
    },
    {
      "headword": "rapport"
    },
    {
      "headword": "landscape"
    },
    {
      "headword": "consultation"
    },
    {
      "headword": "consultancy"
    },
    {
      "headword": "bloom"
    },
    {
      "headword": "engineer"
    },
    {
      "headword": "retention"
    },
    {
      "headword": "quarry"
    },
    {
      "headword": "specification"
    },
    {
      "headword": "contract"
    },
    {
      "headword": "contract"
    },
    {
      "headword": "contractor"
    },
    {
      "headword": "query"
    },
    {
      "headword": "possessor"
    },
    {
      "headword": "chill"
    },
    {
      "headword": "chill"
    },
    {
      "headword": "chilly"
    },
    {
      "headword": "frost"
    },
    {
      "headword": "frosty"
    },
    {
      "headword": "frostily"
    },
    {
      "headword": "man"
    },
    {
      "headword": "unmanned"
    },
    {
      "headword": "impersonal"
    },
    {
      "headword": "impersonally"
    },
    {
      "headword": "impersonate"
    },
    {
      "headword": "impersonator"
    },
    {
      "headword": "impersonation"
    },
    {
      "headword": "buzzer"
    },
    {
      "headword": "desert"
    },
    {
      "headword": "desertion"
    },
    {
      "headword": "unoccupied"
    },
    {
      "headword": "stuffy"
    },
    {
      "headword": "stuffily"
    },
    {
      "headword": "stuffiness"
    },
    {
      "headword": "gape"
    },
    {
      "headword": "gape"
    },
    {
      "headword": "repute"
    },
    {
      "headword": "toughness"
    },
    {
      "headword": "recall"
    },
    {
      "headword": "recollection"
    },
    {
      "headword": "plumbing"
    },
    {
      "headword": "usher"
    },
    {
      "headword": "glum"
    },
    {
      "headword": "glumly"
    },
    {
      "headword": "gamely"
    },
    {
      "headword": "dissect"
    },
    {
      "headword": "dissection"
    },
    {
      "headword": "commend"
    },
    {
      "headword": "commendation"
    },
    {
      "headword": "thereby"
    },
    {
      "headword": "flick"
    },
    {
      "headword": "flicker"
    },
    {
      "headword": "unenviable"
    },
    {
      "headword": "unenviably"
    },
    {
      "headword": "voice"
    },
    {
      "headword": "tread"
    },
    {
      "headword": "allege"
    },
    {
      "headword": "allegation"
    },
    {
      "headword": "bribe"
    },
    {
      "headword": "bribe"
    },
    {
      "headword": "bribery"
    },
    {
      "headword": "inclusion"
    },
    {
      "headword": "inclusive"
    },
    {
      "headword": "inclusively"
    },
    {
      "headword": "unconvincing"
    },
    {
      "headword": "unconvincingly"
    },
    {
      "headword": "recharge"
    },
    {
      "headword": "facilitation"
    },
    {
      "headword": "condition"
    },
    {
      "headword": "conditional"
    },
    {
      "headword": "conditionally"
    },
    {
      "headword": "tone"
    },
    {
      "headword": "align"
    },
    {
      "headword": "alignment"
    },
    {
      "headword": "supple"
    },
    {
      "headword": "manicure"
    },
    {
      "headword": "manicure"
    },
    {
      "headword": "pedicure"
    },
    {
      "headword": "facial"
    },
    {
      "headword": "facial"
    },
    {
      "headword": "bouquet"
    },
    {
      "headword": "refurbish"
    },
    {
      "headword": "refurbishment"
    },
    {
      "headword": "grounds"
    },
    {
      "headword": "grounds"
    },
    {
      "headword": "grounds"
    },
    {
      "headword": "ground"
    },
    {
      "headword": "lethargy"
    },
    {
      "headword": "lethargic"
    },
    {
      "headword": "lethargically"
    },
    {
      "headword": "stately"
    },
    {
      "headword": "conserve"
    },
    {
      "headword": "conservatory"
    },
    {
      "headword": "disquieting"
    },
    {
      "headword": "fiercely"
    },
    {
      "headword": "grapefruit"
    },
    {
      "headword": "exotic"
    },
    {
      "headword": "exotically"
    },
    {
      "headword": "flask"
    },
    {
      "headword": "spacious"
    },
    {
      "headword": "gourmet"
    },
    {
      "headword": "gourmet"
    },
    {
      "headword": "rich"
    },
    {
      "headword": "conjure"
    },
    {
      "headword": "creamy"
    },
    {
      "headword": "sauna"
    },
    {
      "headword": "remedial"
    },
    {
      "headword": "posture"
    },
    {
      "headword": "sedate"
    },
    {
      "headword": "sedately"
    },
    {
      "headword": "sedate"
    },
    {
      "headword": "clutch"
    },
    {
      "headword": "clutch"
    },
    {
      "headword": "stagger"
    },
    {
      "headword": "staggering"
    },
    {
      "headword": "dutiful"
    },
    {
      "headword": "dutifully"
    },
    {
      "headword": "calorie"
    },
    {
      "headword": "firm"
    },
    {
      "headword": "fabulously"
    },
    {
      "headword": "premise"
    },
    {
      "headword": "premises"
    },
    {
      "headword": "eclectic"
    },
    {
      "headword": "eclectic"
    },
    {
      "headword": "eclectically"
    },
    {
      "headword": "revere"
    },
    {
      "headword": "harbor/harbour"
    },
    {
      "headword": "recognizable/recognisable"
    },
    {
      "headword": "recognizably/recognisably"
    },
    {
      "headword": "batter"
    },
    {
      "headword": "battery"
    },
    {
      "headword": "batter"
    },
    {
      "headword": "batter"
    },
    {
      "headword": "unreliably"
    },
    {
      "headword": "waterfront"
    },
    {
      "headword": "amply"
    },
    {
      "headword": "amplification"
    },
    {
      "headword": "battered"
    },
    {
      "headword": "battered"
    },
    {
      "headword": "comply"
    },
    {
      "headword": "compliance"
    },
    {
      "headword": "compliant"
    },
    {
      "headword": "compliantly"
    },
    {
      "headword": "blankness"
    },
    {
      "headword": "exuberant"
    },
    {
      "headword": "exuberance"
    },
    {
      "headword": "exuberantly"
    },
    {
      "headword": "linear"
    },
    {
      "headword": "linearly"
    },
    {
      "headword": "flourish"
    },
    {
      "headword": "flourish"
    },
    {
      "headword": "anchor"
    },
    {
      "headword": "anchored"
    },
    {
      "headword": "domination"
    },
    {
      "headword": "dominant"
    },
    {
      "headword": "dominantly"
    },
    {
      "headword": "interject"
    },
    {
      "headword": "interjection"
    },
    {
      "headword": "gush"
    },
    {
      "headword": "gushing"
    },
    {
      "headword": "gush"
    },
    {
      "headword": "gushingly"
    },
    {
      "headword": "voracious"
    },
    {
      "headword": "voraciously"
    },
    {
      "headword": "sketchbook"
    },
    {
      "headword": "sketch"
    },
    {
      "headword": "prop"
    },
    {
      "headword": "prop"
    },
    {
      "headword": "imp"
    },
    {
      "headword": "impish"
    },
    {
      "headword": "impishly"
    },
    {
      "headword": "wicked"
    },
    {
      "headword": "wickedly"
    },
    {
      "headword": "macabre"
    },
    {
      "headword": "gusto"
    },
    {
      "headword": "tantamount"
    },
    {
      "headword": "antics"
    },
    {
      "headword": "lapse"
    },
    {
      "headword": "lapse"
    },
    {
      "headword": "relapse"
    },
    {
      "headword": "relapse"
    },
    {
      "headword": "impede"
    },
    {
      "headword": "impediment"
    },
    {
      "headword": "taut"
    },
    {
      "headword": "tautly"
    },
    {
      "headword": "jersey"
    },
    {
      "headword": "jersey"
    },
    {
      "headword": "startling"
    },
    {
      "headword": "startlingly"
    },
    {
      "headword": "slack"
    },
    {
      "headword": "slack"
    },
    {
      "headword": "slack"
    },
    {
      "headword": "slackly"
    },
    {
      "headword": "unwavering"
    },
    {
      "headword": "unwaveringly"
    },
    {
      "headword": "removed"
    },
    {
      "headword": "buffoon"
    },
    {
      "headword": "beguiling"
    },
    {
      "headword": "beguilingly"
    },
    {
      "headword": "blithely"
    },
    {
      "headword": "stray"
    },
    {
      "headword": "stray"
    },
    {
      "headword": "stray"
    },
    {
      "headword": "mythological"
    },
    {
      "headword": "mythology"
    },
    {
      "headword": "venerate"
    },
    {
      "headword": "veneration"
    },
    {
      "headword": "ethical"
    },
    {
      "headword": "ethically"
    },
    {
      "headword": "heroine"
    },
    {
      "headword": "refreshing"
    },
    {
      "headword": "refresh"
    },
    {
      "headword": "refreshingly"
    },
    {
      "headword": "zany"
    },
    {
      "headword": "devotee"
    },
    {
      "headword": "salve"
    },
    {
      "headword": "salvation"
    },
    {
      "headword": "salvage"
    },
    {
      "headword": "staccato"
    },
    {
      "headword": "staccato"
    },
    {
      "headword": "verve"
    },
    {
      "headword": "motley"
    },
    {
      "headword": "preach"
    },
    {
      "headword": "preacher"
    },
    {
      "headword": "behind"
    },
    {
      "headword": "continuity"
    },
    {
      "headword": "justly"
    },
    {
      "headword": "wry"
    },
    {
      "headword": "wryly"
    },
    {
      "headword": "poetess"
    },
    {
      "headword": "confide"
    },
    {
      "headword": "sentient"
    },
    {
      "headword": "sentiment"
    },
    {
      "headword": "sentimental"
    },
    {
      "headword": "sentimentally"
    },
    {
      "headword": "tangle"
    },
    {
      "headword": "tangle"
    },
    {
      "headword": "tangled"
    },
    {
      "headword": "untangle"
    },
    {
      "headword": "untangled"
    },
    {
      "headword": "perceptive"
    },
    {
      "headword": "perceptively"
    },
    {
      "headword": "outset"
    },
    {
      "headword": "tycoon"
    },
    {
      "headword": "launch"
    },
    {
      "headword": "engross"
    },
    {
      "headword": "engrossing"
    },
    {
      "headword": "plague"
    },
    {
      "headword": "orphan"
    },
    {
      "headword": "detritus"
    },
    {
      "headword": "detriment"
    },
    {
      "headword": "detrimental"
    },
    {
      "headword": "detrimentally"
    },
    {
      "headword": "domestically"
    },
    {
      "headword": "domesticate"
    },
    {
      "headword": "domestication"
    },
    {
      "headword": "eccentric"
    },
    {
      "headword": "eccentric"
    },
    {
      "headword": "eccentrically"
    },
    {
      "headword": "render"
    },
    {
      "headword": "rendering"
    },
    {
      "headword": "pathos"
    },
    {
      "headword": "tailor"
    },
    {
      "headword": "tailor"
    },
    {
      "headword": "personalize/personalise"
    },
    {
      "headword": "personalization/personalisation"
    },
    {
      "headword": "personification"
    },
    {
      "headword": "limitless"
    },
    {
      "headword": "apprentice"
    },
    {
      "headword": "apprentice"
    },
    {
      "headword": "apprenticeship"
    },
    {
      "headword": "precision"
    },
    {
      "headword": "swap"
    },
    {
      "headword": "swap"
    },
    {
      "headword": "perfect"
    },
    {
      "headword": "silhouette"
    },
    {
      "headword": "nondescript"
    },
    {
      "headword": "signal"
    },
    {
      "headword": "negligible"
    },
    {
      "headword": "negligent"
    },
    {
      "headword": "negligently"
    },
    {
      "headword": "principally"
    },
    {
      "headword": "altruism"
    },
    {
      "headword": "altruistic"
    },
    {
      "headword": "scenario"
    },
    {
      "headword": "voluntary"
    },
    {
      "headword": "voluntarily"
    },
    {
      "headword": "reap"
    },
    {
      "headword": "paternal"
    },
    {
      "headword": "maternal"
    },
    {
      "headword": "maternalistic"
    },
    {
      "headword": "paternalistic"
    },
    {
      "headword": "provisions"
    },
    {
      "headword": "injustice"
    },
    {
      "headword": "impoverished"
    },
    {
      "headword": "unsustainable"
    },
    {
      "headword": "unsustainably"
    },
    {
      "headword": "sustainable"
    },
    {
      "headword": "sustainably"
    },
    {
      "headword": "bypass"
    },
    {
      "headword": "imperative"
    },
    {
      "headword": "imperative"
    },
    {
      "headword": "cynic"
    },
    {
      "headword": "cynical"
    },
    {
      "headword": "cynically"
    },
    {
      "headword": "cynicism"
    },
    {
      "headword": "sarcasm"
    },
    {
      "headword": "sarcastic"
    },
    {
      "headword": "sarcastically"
    },
    {
      "headword": "misplace"
    },
    {
      "headword": "symptomatic"
    },
    {
      "headword": "degrade"
    },
    {
      "headword": "degrading"
    },
    {
      "headword": "degradation"
    },
    {
      "headword": "discourse"
    },
    {
      "headword": "amid"
    },
    {
      "headword": "hedgehog"
    },
    {
      "headword": "nocturnal"
    },
    {
      "headword": "hibernate"
    },
    {
      "headword": "hibernation"
    },
    {
      "headword": "convict"
    },
    {
      "headword": "convict"
    },
    {
      "headword": "conviction"
    },
    {
      "headword": "latent"
    },
    {
      "headword": "snooze"
    },
    {
      "headword": "classy"
    },
    {
      "headword": "wrench"
    },
    {
      "headword": "reminisce"
    },
    {
      "headword": "reminiscent"
    },
    {
      "headword": "intuit"
    },
    {
      "headword": "intuition"
    },
    {
      "headword": "intuitive"
    },
    {
      "headword": "intuitively"
    },
    {
      "headword": "marginal"
    },
    {
      "headword": "marginally"
    },
    {
      "headword": "crude"
    },
    {
      "headword": "crudely"
    },
    {
      "headword": "strap"
    },
    {
      "headword": "strap"
    },
    {
      "headword": "strapping"
    },
    {
      "headword": "scoff"
    },
    {
      "headword": "fiddly"
    },
    {
      "headword": "fiddler"
    },
    {
      "headword": "fiddle"
    },
    {
      "headword": "fiddle"
    },
    {
      "headword": "unmusical"
    },
    {
      "headword": "unmusically"
    },
    {
      "headword": "repertory"
    },
    {
      "headword": "concerto"
    },
    {
      "headword": "premier"
    },
    {
      "headword": "premier"
    },
    {
      "headword": "fanatic"
    },
    {
      "headword": "fanatic"
    },
    {
      "headword": "fanatically"
    },
    {
      "headword": "acoustically"
    },
    {
      "headword": "acoustic"
    },
    {
      "headword": "acoustics"
    },
    {
      "headword": "compromised"
    },
    {
      "headword": "daunt"
    },
    {
      "headword": "daunting"
    },
    {
      "headword": "realist"
    },
    {
      "headword": "realism"
    },
    {
      "headword": "recess"
    },
    {
      "headword": "recess"
    },
    {
      "headword": "recessive"
    },
    {
      "headword": "prolific"
    },
    {
      "headword": "prolifically"
    },
    {
      "headword": "proliferate"
    },
    {
      "headword": "fragmentation"
    },
    {
      "headword": "campaign"
    },
    {
      "headword": "astray"
    },
    {
      "headword": "duration"
    },
    {
      "headword": "durable"
    },
    {
      "headword": "durable"
    },
    {
      "headword": "likelihood"
    },
    {
      "headword": "naive"
    },
    {
      "headword": "naively"
    },
    {
      "headword": "naivety"
    },
    {
      "headword": "impervious"
    },
    {
      "headword": "ludicrous"
    },
    {
      "headword": "ludicrously"
    },
    {
      "headword": "cost-effective"
    },
    {
      "headword": "gruesome"
    },
    {
      "headword": "gruesomely"
    },
    {
      "headword": "envisage"
    },
    {
      "headword": "screenwriter"
    },
    {
      "headword": "mingle"
    },
    {
      "headword": "churn"
    },
    {
      "headword": "buffer"
    },
    {
      "headword": "buffer"
    },
    {
      "headword": "irate"
    },
    {
      "headword": "irately"
    },
    {
      "headword": "docile"
    },
    {
      "headword": "docilely"
    },
    {
      "headword": "fiend"
    },
    {
      "headword": "fiendish"
    },
    {
      "headword": "fiendishly"
    },
    {
      "headword": "transfix"
    },
    {
      "headword": "gypsy"
    },
    {
      "headword": "temperament"
    },
    {
      "headword": "temperamental"
    },
    {
      "headword": "temperamentally"
    },
    {
      "headword": "screenplay"
    },
    {
      "headword": "disillusionment"
    },
    {
      "headword": "demise"
    },
    {
      "headword": "raunchy"
    },
    {
      "headword": "raunchily"
    },
    {
      "headword": "overdraft"
    },
    {
      "headword": "overdraft"
    },
    {
      "headword": "synopsis"
    },
    {
      "headword": "renown"
    },
    {
      "headword": "contest"
    },
    {
      "headword": "contested"
    },
    {
      "headword": "verandah"
    },
    {
      "headword": "occupational"
    },
    {
      "headword": "verdict"
    },
    {
      "headword": "ventilate"
    },
    {
      "headword": "ventilation"
    },
    {
      "headword": "occupant"
    },
    {
      "headword": "radiator"
    },
    {
      "headword": "homely"
    },
    {
      "headword": "bureaucratic"
    },
    {
      "headword": "bureaucratically"
    },
    {
      "headword": "adjustable"
    },
    {
      "headword": "fatigue"
    },
    {
      "headword": "muscular"
    },
    {
      "headword": "versatile"
    },
    {
      "headword": "versatility"
    },
    {
      "headword": "stimuli"
    },
    {
      "headword": "uninspiring"
    },
    {
      "headword": "mutually"
    },
    {
      "headword": "somber/sombre"
    },
    {
      "headword": "somberly/sombrely"
    },
    {
      "headword": "clutter"
    },
    {
      "headword": "clutter"
    },
    {
      "headword": "lodge"
    },
    {
      "headword": "dislodge"
    },
    {
      "headword": "carpenter"
    },
    {
      "headword": "carpentry"
    },
    {
      "headword": "transit"
    },
    {
      "headword": "plummet"
    },
    {
      "headword": "circulate"
    },
    {
      "headword": "circulation"
    },
    {
      "headword": "demography"
    },
    {
      "headword": "demographic"
    },
    {
      "headword": "demographic"
    },
    {
      "headword": "demographically"
    },
    {
      "headword": "phenomenal"
    },
    {
      "headword": "phenomenally"
    },
    {
      "headword": "prophet"
    },
    {
      "headword": "prophetic"
    },
    {
      "headword": "paywall"
    },
    {
      "headword": "firewall"
    },
    {
      "headword": "launch"
    },
    {
      "headword": "invoice"
    },
    {
      "headword": "demolition"
    },
    {
      "headword": "demo"
    },
    {
      "headword": "gig"
    },
    {
      "headword": "socialization"
    },
    {
      "headword": "antiquity"
    },
    {
      "headword": "antiquated"
    },
    {
      "headword": "restoration"
    },
    {
      "headword": "restorative"
    },
    {
      "headword": "rotate"
    },
    {
      "headword": "till"
    },
    {
      "headword": "coupled"
    },
    {
      "headword": "itinerary"
    },
    {
      "headword": "charter"
    },
    {
      "headword": "charter"
    },
    {
      "headword": "terrain"
    },
    {
      "headword": "resilient"
    },
    {
      "headword": "resilience"
    },
    {
      "headword": "enterprising"
    },
    {
      "headword": "integral"
    },
    {
      "headword": "canoe"
    },
    {
      "headword": "magnetic"
    },
    {
      "headword": "magnetism"
    },
    {
      "headword": "magnetically"
    },
    {
      "headword": "credible"
    },
    {
      "headword": "credibly"
    },
    {
      "headword": "credibility"
    },
    {
      "headword": "credential"
    },
    {
      "headword": "acutely"
    },
    {
      "headword": "prohibitive"
    },
    {
      "headword": "prohibitively"
    },
    {
      "headword": "fissure"
    },
    {
      "headword": "pendulum"
    },
    {
      "headword": "pendulous"
    },
    {
      "headword": "suspension"
    },
    {
      "headword": "aboard"
    },
    {
      "headword": "drill"
    },
    {
      "headword": "drill"
    },
    {
      "headword": "anthropology"
    },
    {
      "headword": "anthropologist"
    },
    {
      "headword": "squander"
    },
    {
      "headword": "munch"
    },
    {
      "headword": "adjoin"
    },
    {
      "headword": "adjoining"
    },
    {
      "headword": "wizened"
    },
    {
      "headword": "graft"
    },
    {
      "headword": "orchard"
    },
    {
      "headword": "seedling"
    },
    {
      "headword": "tract"
    },
    {
      "headword": "folktale"
    },
    {
      "headword": "sprout"
    },
    {
      "headword": "sprout"
    },
    {
      "headword": "hypocrisy"
    },
    {
      "headword": "hypocrite"
    },
    {
      "headword": "hypocritical"
    },
    {
      "headword": "hypocritically"
    },
    {
      "headword": "midwife"
    },
    {
      "headword": "harvest"
    },
    {
      "headword": "commercially"
    },
    {
      "headword": "uniformity"
    },
    {
      "headword": "numb"
    },
    {
      "headword": "numb"
    },
    {
      "headword": "tastebud"
    },
    {
      "headword": "amateur"
    },
    {
      "headword": "amateur"
    },
    {
      "headword": "retrace"
    },
    {
      "headword": "chart"
    },
    {
      "headword": "insubordinate"
    },
    {
      "headword": "insubordination"
    },
    {
      "headword": "insubordinately"
    },
    {
      "headword": "subordinate"
    },
    {
      "headword": "primitively"
    },
    {
      "headword": "embark"
    },
    {
      "headword": "expedite"
    },
    {
      "headword": "contextual"
    },
    {
      "headword": "contextually"
    },
    {
      "headword": "whilst"
    },
    {
      "headword": "maneuver/manoeuvre"
    },
    {
      "headword": "maneuver/manoeuvre"
    },
    {
      "headword": "riveting"
    },
    {
      "headword": "plunge"
    },
    {
      "headword": "plunge"
    },
    {
      "headword": "debut"
    },
    {
      "headword": "debut"
    },
    {
      "headword": "turmoil"
    },
    {
      "headword": "scathing"
    },
    {
      "headword": "unscathing"
    },
    {
      "headword": "convoluted"
    },
    {
      "headword": "undaunted"
    },
    {
      "headword": "gutsy"
    },
    {
      "headword": "deprivation"
    },
    {
      "headword": "farce"
    },
    {
      "headword": "portray"
    },
    {
      "headword": "portrayal"
    },
    {
      "headword": "elusive"
    },
    {
      "headword": "elude"
    },
    {
      "headword": "incisor"
    },
    {
      "headword": "incision"
    },
    {
      "headword": "chisel"
    },
    {
      "headword": "chiselled"
    },
    {
      "headword": "gnaw"
    },
    {
      "headword": "elongate"
    },
    {
      "headword": "telltale"
    },
    {
      "headword": "cavity"
    },
    {
      "headword": "rustle"
    },
    {
      "headword": "rustle"
    },
    {
      "headword": "glean"
    },
    {
      "headword": "niche"
    },
    {
      "headword": "somersault"
    },
    {
      "headword": "somersault"
    },
    {
      "headword": "exhilarate"
    },
    {
      "headword": "exhilarating"
    },
    {
      "headword": "exhilaration"
    },
    {
      "headword": "physicality"
    },
    {
      "headword": "hack"
    },
    {
      "headword": "hack"
    },
    {
      "headword": "lust"
    },
    {
      "headword": "unsettling"
    },
    {
      "headword": "unsettle"
    },
    {
      "headword": "suburban"
    },
    {
      "headword": "suburbia"
    },
    {
      "headword": "dramatist"
    },
    {
      "headword": "characterization/characterisation"
    },
    {
      "headword": "quirky"
    },
    {
      "headword": "quirky"
    },
    {
      "headword": "sprawl"
    },
    {
      "headword": "sprawl"
    },
    {
      "headword": "ingenuity"
    },
    {
      "headword": "panorama"
    },
    {
      "headword": "panoramic"
    },
    {
      "headword": "benign"
    },
    {
      "headword": "benignly"
    },
    {
      "headword": "explosively"
    },
    {
      "headword": "bequeath"
    },
    {
      "headword": "legacy"
    },
    {
      "headword": "synthetic"
    },
    {
      "headword": "synthetically"
    },
    {
      "headword": "lackluster/lacklustre"
    },
    {
      "headword": "elastic"
    },
    {
      "headword": "elastic"
    },
    {
      "headword": "appall/appal"
    },
    {
      "headword": "appalling"
    },
    {
      "headword": "appallingly"
    },
    {
      "headword": "pounce"
    },
    {
      "headword": "abound"
    },
    {
      "headword": "sap"
    },
    {
      "headword": "monotonous"
    },
    {
      "headword": "monotonously"
    },
    {
      "headword": "monotony"
    },
    {
      "headword": "turn to"
    },
    {
      "headword": "ingenious"
    },
    {
      "headword": "plaque"
    },
    {
      "headword": "neutralize/neutralise"
    },
    {
      "headword": "neutralization/neutralisation"
    },
    {
      "headword": "salivate"
    },
    {
      "headword": "cessation"
    },
    {
      "headword": "remorse"
    },
    {
      "headword": "remorseless"
    },
    {
      "headword": "remorsefully"
    },
    {
      "headword": "remorselessly"
    },
    {
      "headword": "inexcusable"
    },
    {
      "headword": "inexcusably"
    },
    {
      "headword": "inexhaustible"
    },
    {
      "headword": "unassisted"
    },
    {
      "headword": "heighten"
    },
    {
      "headword": "fixture"
    },
    {
      "headword": "bulk"
    },
    {
      "headword": "bulky"
    },
    {
      "headword": "bulk up"
    },
    {
      "headword": "digitalize/digitalise"
    },
    {
      "headword": "digitalization/digitalisation"
    },
    {
      "headword": "mark-up"
    },
    {
      "headword": "complementary"
    },
    {
      "headword": "complimentary"
    },
    {
      "headword": "staple"
    },
    {
      "headword": "wares"
    },
    {
      "headword": "testament"
    },
    {
      "headword": "succulent"
    },
    {
      "headword": "succulent"
    },
    {
      "headword": "succulently"
    },
    {
      "headword": "tranquil"
    },
    {
      "headword": "tranquility"
    },
    {
      "headword": "spartan"
    },
    {
      "headword": "peninsula"
    },
    {
      "headword": "billiards"
    },
    {
      "headword": "exude"
    },
    {
      "headword": "envisage"
    },
    {
      "headword": "headmistress"
    },
    {
      "headword": "mien"
    },
    {
      "headword": "timidity"
    },
    {
      "headword": "unravel"
    },
    {
      "headword": "concurrence"
    },
    {
      "headword": "unpromising"
    },
    {
      "headword": "teem"
    },
    {
      "headword": "marvel"
    },
    {
      "headword": "outpatient"
    },
    {
      "headword": "corpse"
    },
    {
      "headword": "apprentice"
    },
    {
      "headword": "constrained"
    },
    {
      "headword": "quirk"
    },
    {
      "headword": "indignant"
    },
    {
      "headword": "indignantly"
    },
    {
      "headword": "eccentricity"
    },
    {
      "headword": "locomotive"
    },
    {
      "headword": "locomotion"
    },
    {
      "headword": "individualism"
    },
    {
      "headword": "enthuse"
    },
    {
      "headword": "belligerent"
    },
    {
      "headword": "belligerence"
    },
    {
      "headword": "stoicism"
    },
    {
      "headword": "deliberate"
    },
    {
      "headword": "recluse"
    },
    {
      "headword": "reclusive"
    },
    {
      "headword": "metalled"
    },
    {
      "headword": "brief"
    },
    {
      "headword": "oblique"
    },
    {
      "headword": "facsimile"
    },
    {
      "headword": "shamble"
    },
    {
      "headword": "whir"
    },
    {
      "headword": "blight"
    },
    {
      "headword": "blight"
    },
    {
      "headword": "puritanical"
    },
    {
      "headword": "brood"
    },
    {
      "headword": "brood"
    },
    {
      "headword": "disdainful"
    },
    {
      "headword": "zoologist"
    },
    {
      "headword": "zoology"
    },
    {
      "headword": "encumbrance"
    },
    {
      "headword": "encumber"
    },
    {
      "headword": "hypothesis"
    },
    {
      "headword": "hypothesize"
    },
    {
      "headword": "hypothetical"
    },
    {
      "headword": "parasitic"
    },
    {
      "headword": "plumage"
    },
    {
      "headword": "utilitarian"
    },
    {
      "headword": "utilize"
    },
    {
      "headword": "utility"
    },
    {
      "headword": "predilection"
    },
    {
      "headword": "commensurate"
    },
    {
      "headword": "commensurately"
    },
    {
      "headword": "vindicate"
    },
    {
      "headword": "vindication"
    },
    {
      "headword": "parable"
    },
    {
      "headword": "poise"
    },
    {
      "headword": "minster"
    },
    {
      "headword": "wrack"
    },
    {
      "headword": "ironic"
    },
    {
      "headword": "predecessor"
    },
    {
      "headword": "ally"
    },
    {
      "headword": "callous"
    },
    {
      "headword": "callously"
    },
    {
      "headword": "derelict"
    },
    {
      "headword": "derelict"
    },
    {
      "headword": "materialism"
    },
    {
      "headword": "materialistic"
    },
    {
      "headword": "ferocity"
    },
    {
      "headword": "utter"
    },
    {
      "headword": "utter"
    },
    {
      "headword": "evokingly"
    },
    {
      "headword": "recitation"
    },
    {
      "headword": "equable"
    },
    {
      "headword": "extant"
    },
    {
      "headword": "denounce"
    },
    {
      "headword": "denunciation"
    },
    {
      "headword": "echo"
    },
    {
      "headword": "echo"
    },
    {
      "headword": "echo"
    },
    {
      "headword": "requisition"
    },
    {
      "headword": "substantiate"
    },
    {
      "headword": "inscrutable"
    },
    {
      "headword": "stratosphere"
    },
    {
      "headword": "indulge"
    },
    {
      "headword": "indulgence"
    },
    {
      "headword": "indulgently"
    },
    {
      "headword": "laudatory"
    },
    {
      "headword": "laud"
    },
    {
      "headword": "glitz"
    },
    {
      "headword": "glitzy"
    },
    {
      "headword": "automate"
    },
    {
      "headword": "apprehend"
    },
    {
      "headword": "athleticism"
    },
    {
      "headword": "daunt"
    },
    {
      "headword": "daunting"
    },
    {
      "headword": "acreage"
    },
    {
      "headword": "affectation"
    },
    {
      "headword": "imposition"
    },
    {
      "headword": "circuit"
    },
    {
      "headword": "stipulate"
    },
    {
      "headword": "stipulation"
    },
    {
      "headword": "allot"
    },
    {
      "headword": "allotment"
    },
    {
      "headword": "anticlimactically"
    },
    {
      "headword": "forfeiture"
    },
    {
      "headword": "blitz"
    },
    {
      "headword": "blitz"
    },
    {
      "headword": "primeval"
    },
    {
      "headword": "tenacity"
    },
    {
      "headword": "tenacious"
    },
    {
      "headword": "tenaciously"
    },
    {
      "headword": "exact"
    },
    {
      "headword": "genomic"
    },
    {
      "headword": "genomically"
    },
    {
      "headword": "capacious"
    },
    {
      "headword": "utilitarian"
    },
    {
      "headword": "utilization/utilisation"
    },
    {
      "headword": "unequivocal"
    },
    {
      "headword": "unequivocally"
    },
    {
      "headword": "spontaneity"
    },
    {
      "headword": "provocation"
    },
    {
      "headword": "portraiture"
    },
    {
      "headword": "tedium"
    },
    {
      "headword": "succeed"
    },
    {
      "headword": "circumnavigate"
    },
    {
      "headword": "circumnavigation"
    },
    {
      "headword": "liaise"
    },
    {
      "headword": "contractual"
    },
    {
      "headword": "contractually"
    },
    {
      "headword": "repute"
    },
    {
      "headword": "abject"
    },
    {
      "headword": "sheaf"
    },
    {
      "headword": "articulation"
    },
    {
      "headword": "articulate"
    },
    {
      "headword": "spurious"
    },
    {
      "headword": "spuriously"
    },
    {
      "headword": "posture"
    },
    {
      "headword": "calorific"
    },
    {
      "headword": "fabulate"
    },
    {
      "headword": "fabulation"
    },
    {
      "headword": "octogenarian"
    },
    {
      "headword": "voracity"
    },
    {
      "headword": "brandish"
    },
    {
      "headword": "repose"
    },
    {
      "headword": "repose"
    },
    {
      "headword": "encumber"
    },
    {
      "headword": "encumbrance"
    },
    {
      "headword": "unencumbered"
    },
    {
      "headword": "buffoonery"
    },
    {
      "headword": "gauche"
    },
    {
      "headword": "domesticity"
    },
    {
      "headword": "accrue"
    },
    {
      "headword": "proliferation"
    },
    {
      "headword": "blandishment"
    },
    {
      "headword": "pluck"
    },
    {
      "headword": "anthropological"
    },
    {
      "headword": "anthropologically"
    },
    {
      "headword": "carbonize/carbonise"
    },
    {
      "headword": "monastic"
    },
    {
      "headword": "graft"
    },
    {
      "headword": "midwifery"
    },
    {
      "headword": "adornment"
    },
    {
      "headword": "adorn"
    },
    {
      "headword": "idle"
    },
    {
      "headword": "conjecture"
    },
    {
      "headword": "conjecture"
    },
    {
      "headword": "malleable"
    },
    {
      "headword": "malleability"
    },
    {
      "headword": "ore"
    },
    {
      "headword": "gale"
    },
    {
      "headword": "promenade"
    },
    {
      "headword": "testimonial"
    },
    {
      "headword": "distill"
    },
    {
      "headword": "distillation"
    },
    {
      "headword": "informant"
    },
    {
      "headword": "vis-a-vis"
    },
    {
      "headword": "overlay"
    },
    {
      "headword": "nostalgia"
    },
    {
      "headword": "nostalgic"
    },
    {
      "headword": "nostalgically"
    },
    {
      "headword": "grievance"
    },
    {
      "headword": "deprivation"
    },
    {
      "headword": "residue"
    },
    {
      "headword": "residual"
    },
    {
      "headword": "physiological"
    },
    {
      "headword": "physiologically"
    },
    {
      "headword": "familiarize/familiarise"
    },
    {
      "headword": "methodology"
    },
    {
      "headword": "methodological"
    },
    {
      "headword": "methodologically"
    },
    {
      "headword": "proportional"
    },
    {
      "headword": "proportionally"
    },
    {
      "headword": "habitation"
    },
    {
      "headword": "inartistic"
    },
    {
      "headword": "ornate"
    },
    {
      "headword": "modernism"
    },
    {
      "headword": "presuppose"
    },
    {
      "headword": "presupposition"
    },
    {
      "headword": "centralized/centralised"
    },
    {
      "headword": "envisage"
    },
    {
      "headword": "contextual"
    },
    {
      "headword": "contextually"
    },
    {
      "headword": "transmitter"
    },
    {
      "headword": "regulatory"
    },
    {
      "headword": "archival"
    },
    {
      "headword": "diffuse"
    },
    {
      "headword": "diffuse"
    },
    {
      "headword": "egalitarian"
    },
    {
      "headword": "egalitarian"
    },
    {
      "headword": "hindsight"
    },
    {
      "headword": "materialize/materialise"
    },
    {
      "headword": "materialization/materialisation"
    },
    {
      "headword": "disperse"
    },
    {
      "headword": "dispersal"
    },
    {
      "headword": "adverse"
    },
    {
      "headword": "adversely"
    },
    {
      "headword": "stabilize/stabilise"
    },
    {
      "headword": "pervasive"
    },
    {
      "headword": "pervasiveness"
    },
    {
      "headword": "secure"
    },
    {
      "headword": "autonomous"
    },
    {
      "headword": "autonomously"
    },
    {
      "headword": "outmoded"
    },
    {
      "headword": "phase"
    },
    {
      "headword": "plum"
    },
    {
      "headword": "notorious"
    },
    {
      "headword": "notoriously"
    },
    {
      "headword": "notoriety"
    },
    {
      "headword": "menial"
    },
    {
      "headword": "insular"
    },
    {
      "headword": "antidote"
    },
    {
      "headword": "posture"
    },
    {
      "headword": "postural"
    },
    {
      "headword": "posturing"
    },
    {
      "headword": "revelatory"
    },
    {
      "headword": "prostrate"
    },
    {
      "headword": "prostrate"
    },
    {
      "headword": "haphazard"
    },
    {
      "headword": "haphazardly"
    },
    {
      "headword": "deficient"
    },
    {
      "headword": "deficiently"
    },
    {
      "headword": "deficit"
    },
    {
      "headword": "delicatessen"
    },
    {
      "headword": "muscle-bound"
    },
    {
      "headword": "dive"
    },
    {
      "headword": "maneuver/manoeuvre"
    },
    {
      "headword": "maneuver/manoeuvre"
    },
    {
      "headword": "posit"
    },
    {
      "headword": "cocoon"
    },
    {
      "headword": "chrysalis"
    },
    {
      "headword": "ignominious"
    },
    {
      "headword": "ignominiously"
    },
    {
      "headword": "euphoria"
    },
    {
      "headword": "euphoric"
    },
    {
      "headword": "euphorically"
    },
    {
      "headword": "relegate"
    },
    {
      "headword": "succumb"
    },
    {
      "headword": "treacherous"
    },
    {
      "headword": "treacherously"
    },
    {
      "headword": "treachery"
    },
    {
      "headword": "maggot"
    },
    {
      "headword": "palate"
    },
    {
      "headword": "palatable"
    },
    {
      "headword": "hermit"
    },
    {
      "headword": "hermetic"
    },
    {
      "headword": "irrelevancy"
    },
    {
      "headword": "mariner"
    },
    {
      "headword": "rift"
    },
    {
      "headword": "mere"
    },
    {
      "headword": "helm"
    },
    {
      "headword": "autopilot"
    },
    {
      "headword": "eminence"
    },
    {
      "headword": "eminent"
    },
    {
      "headword": "preeminent"
    },
    {
      "headword": "mold/mould"
    },
    {
      "headword": "unsuspected"
    },
    {
      "headword": "abolish"
    },
    {
      "headword": "paralyze/paralyse"
    },
    {
      "headword": "paralysis"
    },
    {
      "headword": "paralyzingly/paralysingly"
    },
    {
      "headword": "glory in"
    },
    {
      "headword": "decentralize/decentralise"
    },
    {
      "headword": "preoccupation"
    },
    {
      "headword": "preoccupy"
    },
    {
      "headword": "prolong"
    },
    {
      "headword": "audit"
    },
    {
      "headword": "audit"
    },
    {
      "headword": "drudgery"
    },
    {
      "headword": "pressurize"
    },
    {
      "headword": "pressurization"
    },
    {
      "headword": "intermediary"
    },
    {
      "headword": "hotelier"
    },
    {
      "headword": "denote"
    },
    {
      "headword": "denotation"
    },
    {
      "headword": "profitability"
    },
    {
      "headword": "jargon"
    },
    {
      "headword": "declination"
    },
    {
      "headword": "vocational"
    },
    {
      "headword": "spatial"
    },
    {
      "headword": "spatially"
    },
    {
      "headword": "punctual"
    },
    {
      "headword": "punctuality"
    },
    {
      "headword": "integration"
    },
    {
      "headword": "curriculum"
    },
    {
      "headword": "extracurricular"
    },
    {
      "headword": "extracurricular"
    },
    {
      "headword": "encompass"
    },
    {
      "headword": "all-encompassing"
    },
    {
      "headword": "accountability"
    },
    {
      "headword": "frolic"
    },
    {
      "headword": "minefield"
    },
    {
      "headword": "side-step"
    },
    {
      "headword": "abundant"
    },
    {
      "headword": "abundantly"
    },
    {
      "headword": "abundance"
    },
    {
      "headword": "anarchic"
    },
    {
      "headword": "crystallize/crystallise"
    },
    {
      "headword": "crystallization/crystallisation"
    },
    {
      "headword": "prescriptive"
    },
    {
      "headword": "slab"
    },
    {
      "headword": "retrospect"
    },
    {
      "headword": "retrospective"
    },
    {
      "headword": "retrospection"
    },
    {
      "headword": "wordage"
    },
    {
      "headword": "brevity"
    },
    {
      "headword": "uncanny"
    },
    {
      "headword": "tactic"
    },
    {
      "headword": "tactical"
    },
    {
      "headword": "tactically"
    },
    {
      "headword": "tactile"
    },
    {
      "headword": "gambit"
    },
    {
      "headword": "babble"
    },
    {
      "headword": "bauble"
    },
    {
      "headword": "correlate"
    },
    {
      "headword": "correlation"
    },
    {
      "headword": "correlate"
    },
    {
      "headword": "combustion"
    },
    {
      "headword": "painstaking"
    },
    {
      "headword": "painstakingly"
    },
    {
      "headword": "contraption"
    },
    {
      "headword": "mesh"
    },
    {
      "headword": "enabler"
    },
    {
      "headword": "fluctuate"
    },
    {
      "headword": "fluctuation"
    },
    {
      "headword": "lyricist"
    },
    {
      "headword": "lyrical"
    },
    {
      "headword": "lyrically"
    },
    {
      "headword": "bona fide"
    },
    {
      "headword": "moribund"
    },
    {
      "headword": "perch"
    },
    {
      "headword": "perch"
    },
    {
      "headword": "perch"
    },
    {
      "headword": "solicit"
    },
    {
      "headword": "vocalist"
    },
    {
      "headword": "philanthropy"
    },
    {
      "headword": "philanthropist"
    },
    {
      "headword": "philanthropic"
    },
    {
      "headword": "philanthropically"
    },
    {
      "headword": "precocious"
    },
    {
      "headword": "precociously"
    },
    {
      "headword": "wordsmith"
    },
    {
      "headword": "connote"
    },
    {
      "headword": "connotation"
    },
    {
      "headword": "herald"
    },
    {
      "headword": "herald"
    },
    {
      "headword": "philistine"
    },
    {
      "headword": "innuendo"
    },
    {
      "headword": "induce"
    },
    {
      "headword": "inducement"
    },
    {
      "headword": "anthology"
    },
    {
      "headword": "lament"
    },
    {
      "headword": "lamentation"
    },
    {
      "headword": "conduit"
    },
    {
      "headword": "chronology"
    },
    {
      "headword": "chronological"
    },
    {
      "headword": "chronologically"
    },
    {
      "headword": "equilibrium"
    },
    {
      "headword": "rebound"
    },
    {
      "headword": "rebound"
    },
    {
      "headword": "proposition"
    },
    {
      "headword": "flagging"
    },
    {
      "headword": "electrode"
    },
    {
      "headword": "caffeinate"
    },
    {
      "headword": "cosmic"
    },
    {
      "headword": "interlude"
    },
    {
      "headword": "haven"
    },
    {
      "headword": "beneficiary"
    },
    {
      "headword": "recuperate"
    },
    {
      "headword": "recuperation"
    },
    {
      "headword": "recuperative"
    },
    {
      "headword": "cultish"
    },
    {
      "headword": "seismic"
    },
    {
      "headword": "irrevocably"
    },
    {
      "headword": "irrevocable"
    },
    {
      "headword": "slither"
    },
    {
      "headword": "unnerve"
    },
    {
      "headword": "unnerving"
    },
    {
      "headword": "unnervingly"
    },
    {
      "headword": "protrude"
    },
    {
      "headword": "protrusion"
    },
    {
      "headword": "qualitative"
    },
    {
      "headword": "procedural"
    },
    {
      "headword": "procedural"
    },
    {
      "headword": "demystify"
    },
    {
      "headword": "demystification"
    },
    {
      "headword": "proprietary"
    },
    {
      "headword": "proprietorial"
    },
    {
      "headword": "tantamount"
    },
    {
      "headword": "floodgates"
    },
    {
      "headword": "imperceptible"
    },
    {
      "headword": "imperceptibly"
    },
    {
      "headword": "hapless"
    },
    {
      "headword": "catastrophic"
    },
    {
      "headword": "catastrophically"
    },
    {
      "headword": "commission"
    },
    {
      "headword": "commission"
    },
    {
      "headword": "wayward"
    },
    {
      "headword": "blurb"
    },
    {
      "headword": "provincial"
    },
    {
      "headword": "indolent"
    },
    {
      "headword": "indolently"
    },
    {
      "headword": "indolence"
    },
    {
      "headword": "taste-maker"
    },
    {
      "headword": "deviant"
    },
    {
      "headword": "deviant"
    },
    {
      "headword": "deviantly"
    },
    {
      "headword": "engender"
    },
    {
      "headword": "emolument"
    },
    {
      "headword": "munificence"
    },
    {
      "headword": "posterity"
    },
    {
      "headword": "venomous"
    },
    {
      "headword": "venomously"
    },
    {
      "headword": "choreography"
    },
    {
      "headword": "choreographical"
    },
    {
      "headword": "archetype"
    },
    {
      "headword": "archetypal"
    },
    {
      "headword": "dissension"
    },
    {
      "headword": "exalted"
    },
    {
      "headword": "exaltedly"
    },
    {
      "headword": "adept"
    },
    {
      "headword": "adept"
    },
    {
      "headword": "inert"
    },
    {
      "headword": "hitherto"
    },
    {
      "headword": "angst"
    },
    {
      "headword": "angsty"
    },
    {
      "headword": "drabness"
    },
    {
      "headword": "melodious"
    },
    {
      "headword": "melodiously"
    },
    {
      "headword": "magpie"
    },
    {
      "headword": "lark"
    },
    {
      "headword": "lark"
    },
    {
      "headword": "melancholy"
    },
    {
      "headword": "melancholy"
    },
    {
      "headword": "meteorology"
    },
    {
      "headword": "meteorological"
    },
    {
      "headword": "brink"
    },
    {
      "headword": "unsurpassed"
    },
    {
      "headword": "loiter"
    },
    {
      "headword": "topple"
    },
    {
      "headword": "intrinsic"
    },
    {
      "headword": "intrinsically"
    },
    {
      "headword": "merit"
    },
    {
      "headword": "merit"
    },
    {
      "headword": "promotable"
    },
    {
      "headword": "clinch"
    },
    {
      "headword": "anonymity"
    },
    {
      "headword": "splinter"
    },
    {
      "headword": "reproach"
    },
    {
      "headword": "disseminate"
    },
    {
      "headword": "dissemination"
    },
    {
      "headword": "dissemble"
    },
    {
      "headword": "mangle"
    },
    {
      "headword": "bereft"
    },
    {
      "headword": "bereftly"
    },
    {
      "headword": "soliloquy"
    },
    {
      "headword": "solipsism"
    },
    {
      "headword": "soliloquize"
    },
    {
      "headword": "mutinous"
    },
    {
      "headword": "mutinously"
    },
    {
      "headword": "prissy"
    },
    {
      "headword": "reptilian"
    },
    {
      "headword": "diminish"
    },
    {
      "headword": "undiminishing"
    },
    {
      "headword": "contagion"
    },
    {
      "headword": "homestead"
    },
    {
      "headword": "computerize/computerise"
    },
    {
      "headword": "incumbent"
    },
    {
      "headword": "incumbent"
    },
    {
      "headword": "recumbent"
    },
    {
      "headword": "nonchalant"
    },
    {
      "headword": "nonchalantly"
    },
    {
      "headword": "mesmeric"
    },
    {
      "headword": "stultify"
    },
    {
      "headword": "stultifyingly"
    },
    {
      "headword": "wallow"
    },
    {
      "headword": "ponderous"
    },
    {
      "headword": "ponderously"
    },
    {
      "headword": "lassitude"
    },
    {
      "headword": "vicinity"
    },
    {
      "headword": "ebb"
    },
    {
      "headword": "wax"
    },
    {
      "headword": "wane"
    },
    {
      "headword": "antediluvian"
    },
    {
      "headword": "ostensible"
    },
    {
      "headword": "ostensibly"
    },
    {
      "headword": "interlocking"
    },
    {
      "headword": "plane"
    },
    {
      "headword": "undemonstrative"
    },
    {
      "headword": "undemonstratively"
    },
    {
      "headword": "menace"
    },
    {
      "headword": "menacing"
    },
    {
      "headword": "menacingly"
    },
    {
      "headword": "calamity"
    },
    {
      "headword": "calamitous"
    },
    {
      "headword": "calamitously"
    },
    {
      "headword": "nigh"
    },
    {
      "headword": "austere"
    },
    {
      "headword": "austerely"
    },
    {
      "headword": "austerity"
    },
    {
      "headword": "idiosyncrasy"
    },
    {
      "headword": "idiosyncratic"
    },
    {
      "headword": "idiomatic"
    },
    {
      "headword": "idiomatically"
    },
    {
      "headword": "kinetic"
    },
    {
      "headword": "kinetically"
    },
    {
      "headword": "unmediated"
    },
    {
      "headword": "mediate"
    },
    {
      "headword": "mediation"
    },
    {
      "headword": "unharried"
    },
    {
      "headword": "figurative"
    },
    {
      "headword": "figuratively"
    },
    {
      "headword": "exorcism"
    },
    {
      "headword": "exorcist"
    },
    {
      "headword": "mundanity"
    },
    {
      "headword": "mediocrity"
    },
    {
      "headword": "dubiously"
    },
    {
      "headword": "curate"
    },
    {
      "headword": "curator"
    },
    {
      "headword": "antithesis"
    },
    {
      "headword": "antithetical"
    },
    {
      "headword": "parameter"
    },
    {
      "headword": "detract"
    },
    {
      "headword": "interrogate"
    },
    {
      "headword": "interrogation"
    },
    {
      "headword": "interrogative"
    },
    {
      "headword": "interrogatively"
    },
    {
      "headword": "perverse"
    },
    {
      "headword": "perversity"
    },
    {
      "headword": "attainment"
    },
    {
      "headword": "opaque"
    },
    {
      "headword": "opacity"
    },
    {
      "headword": "remit"
    },
    {
      "headword": "remittance"
    },
    {
      "headword": "recourse"
    },
    {
      "headword": "pedestal"
    },
    {
      "headword": "pedestrian"
    },
    {
      "headword": "lurid"
    },
    {
      "headword": "luridly"
    },
    {
      "headword": "fallacy"
    },
    {
      "headword": "rife"
    },
    {
      "headword": "grumble"
    },
    {
      "headword": "mercenary"
    },
    {
      "headword": "polysyllabic"
    },
    {
      "headword": "syllabic"
    },
    {
      "headword": "superfluous"
    },
    {
      "headword": "superfluously"
    },
    {
      "headword": "snippet"
    },
    {
      "headword": "practitioner"
    },
    {
      "headword": "ephemeral"
    },
    {
      "headword": "ephemera"
    },
    {
      "headword": "ephemerality"
    },
    {
      "headword": "summarily"
    },
    {
      "headword": "skim"
    },
    {
      "headword": "infallibly"
    },
    {
      "headword": "infallible"
    },
    {
      "headword": "infallibility"
    },
    {
      "headword": "depravity"
    },
    {
      "headword": "depraved"
    },
    {
      "headword": "deprecate"
    },
    {
      "headword": "deprecatingly"
    },
    {
      "headword": "revile"
    },
    {
      "headword": "revulsion"
    },
    {
      "headword": "meager/meagre"
    },
    {
      "headword": "arcane"
    },
    {
      "headword": "arcanely"
    },
    {
      "headword": "porten"
    },
    {
      "headword": "divination"
    },
    {
      "headword": "flit"
    },
    {
      "headword": "hitch"
    },
    {
      "headword": "prone"
    },
    {
      "headword": "scavenger"
    },
    {
      "headword": "vermin"
    },
    {
      "headword": "totemic"
    },
    {
      "headword": "emulate"
    },
    {
      "headword": "emulation"
    },
    {
      "headword": "avian"
    },
    {
      "headword": "vestigial"
    },
    {
      "headword": "vestigially"
    },
    {
      "headword": "barometer"
    },
    {
      "headword": "lament"
    },
    {
      "headword": "lamentation"
    },
    {
      "headword": "brouhaha"
    },
    {
      "headword": "magnate"
    },
    {
      "headword": "magnanimous"
    },
    {
      "headword": "magnanimously"
    },
    {
      "headword": "magnanimity"
    },
    {
      "headword": "whirlwind"
    },
    {
      "headword": "strait"
    },
    {
      "headword": "secular"
    },
    {
      "headword": "secularly"
    },
    {
      "headword": "euphemism"
    },
    {
      "headword": "euphemistic"
    },
    {
      "headword": "euphemistically"
    },
    {
      "headword": "condensation"
    },
    {
      "headword": "redundant"
    },
    {
      "headword": "redundancy"
    },
    {
      "headword": "redundantly"
    },
    {
      "headword": "colloquial"
    },
    {
      "headword": "colloquium"
    },
    {
      "headword": "colloquially"
    },
    {
      "headword": "allusion"
    },
    {
      "headword": "allude"
    },
    {
      "headword": "disparage"
    },
    {
      "headword": "disparaging"
    },
    {
      "headword": "disparagingly"
    },
    {
      "headword": "disparagement"
    },
    {
      "headword": "huddle"
    },
    {
      "headword": "huddle"
    },
    {
      "headword": "topography"
    },
    {
      "headword": "topographical"
    },
    {
      "headword": "topographically"
    },
    {
      "headword": "confabulate"
    },
    {
      "headword": "confabulation"
    },
    {
      "headword": "surrealist"
    },
    {
      "headword": "surrealism"
    },
    {
      "headword": "contrive"
    },
    {
      "headword": "malice"
    },
    {
      "headword": "malicious"
    },
    {
      "headword": "maliciously"
    },
    {
      "headword": "cinematography"
    },
    {
      "headword": "cinematographer"
    },
    {
      "headword": "maverick"
    },
    {
      "headword": "diligent"
    },
    {
      "headword": "diligence"
    },
    {
      "headword": "diligently"
    },
    {
      "headword": "turret"
    },
    {
      "headword": "impressionistic"
    },
    {
      "headword": "impressionistically"
    },
    {
      "headword": "snobbery"
    },
    {
      "headword": "parochial"
    },
    {
      "headword": "gravitate"
    },
    {
      "headword": "gravitational"
    },
    {
      "headword": "gravitationally"
    },
    {
      "headword": "consternation"
    },
    {
      "headword": "haughty"
    },
    {
      "headword": "haughtily"
    },
    {
      "headword": "axiom"
    },
    {
      "headword": "axiomatic"
    },
    {
      "headword": "attrition"
    },
    {
      "headword": "enduringly"
    },
    {
      "headword": "reissue"
    },
    {
      "headword": "sulphur"
    },
    {
      "headword": "sulphuric"
    },
    {
      "headword": "phantom"
    },
    {
      "headword": "moor"
    },
    {
      "headword": "solitary"
    },
    {
      "headword": "solitary"
    },
    {
      "headword": "solitariness"
    },
    {
      "headword": "solitude"
    },
    {
      "headword": "adhere"
    },
    {
      "headword": "adhesion"
    },
    {
      "headword": "proscribe"
    },
    {
      "headword": "proscription"
    },
    {
      "headword": "crony"
    },
    {
      "headword": "dribble"
    },
    {
      "headword": "dribble"
    },
    {
      "headword": "dribble"
    },
    {
      "headword": "ingrate"
    },
    {
      "headword": "prise"
    },
    {
      "headword": "rickety"
    },
    {
      "headword": "consign"
    },
    {
      "headword": "consignment"
    },
    {
      "headword": "fete"
    },
    {
      "headword": "dole out"
    },
    {
      "headword": "opulent"
    },
    {
      "headword": "opulence"
    },
    {
      "headword": "opulently"
    },
    {
      "headword": "plutocrat"
    },
    {
      "headword": "averse"
    },
    {
      "headword": "edify"
    },
    {
      "headword": "edification"
    },
    {
      "headword": "converse"
    },
    {
      "headword": "converse"
    },
    {
      "headword": "sterility"
    },
    {
      "headword": "rhetoric"
    },
    {
      "headword": "rhetorical"
    },
    {
      "headword": "rhetorically"
    },
    {
      "headword": "flighty"
    },
    {
      "headword": "flightiness"
    },
    {
      "headword": "brimstone"
    },
    {
      "headword": "impeccable"
    },
    {
      "headword": "impeccably"
    },
    {
      "headword": "romp"
    },
    {
      "headword": "romper"
    },
    {
      "headword": "meticulous"
    },
    {
      "headword": "meticulously"
    },
    {
      "headword": "ingratiate"
    },
    {
      "headword": "ingratiating"
    },
    {
      "headword": "ingratiatingly"
    },
    {
      "headword": "shimmer"
    },
    {
      "headword": "hull"
    },
    {
      "headword": "cull"
    },
    {
      "headword": "swivel"
    },
    {
      "headword": "relinquish"
    },
    {
      "headword": "quiver"
    },
    {
      "headword": "quiver"
    },
    {
      "headword": "sandwiched"
    },
    {
      "headword": "mottled"
    },
    {
      "headword": "epoxy"
    },
    {
      "headword": "resin"
    },
    {
      "headword": "sedately"
    },
    {
      "headword": "angular"
    },
    {
      "headword": "angularity"
    },
    {
      "headword": "dampen"
    },
    {
      "headword": "buccaneer"
    },
    {
      "headword": "buccaneer"
    },
    {
      "headword": "conglomerate"
    },
    {
      "headword": "cay"
    },
    {
      "headword": "singe"
    },
    {
      "headword": "cordon"
    },
    {
      "headword": "fabled"
    },
    {
      "headword": "glint"
    },
    {
      "headword": "glint"
    },
    {
      "headword": "infernal"
    },
    {
      "headword": "infernally"
    },
    {
      "headword": "presentational"
    },
    {
      "headword": "embed"
    },
    {
      "headword": "plume"
    },
    {
      "headword": "happenstance"
    },
    {
      "headword": "venture"
    },
    {
      "headword": "reconcile"
    },
    {
      "headword": "reconciliation"
    },
    {
      "headword": "conciliatory"
    },
    {
      "headword": "conciliation"
    },
    {
      "headword": "preconception"
    },
    {
      "headword": "baroque"
    },
    {
      "headword": "virginal"
    },
    {
      "headword": "spire"
    },
    {
      "headword": "elephantine"
    },
    {
      "headword": "agency"
    },
    {
      "headword": "condone"
    },
    {
      "headword": "commodity"
    },
    {
      "headword": "commode"
    },
    {
      "headword": "unobtrusive"
    },
    {
      "headword": "unobtrusively"
    },
    {
      "headword": "unobtrusiveness"
    },
    {
      "headword": "compellingly"
    },
    {
      "headword": "hauntingly"
    },
    {
      "headword": "brim"
    },
    {
      "headword": "hazard"
    },
    {
      "headword": "authenticity"
    },
    {
      "headword": "scholarly"
    },
    {
      "headword": "accessibility"
    },
    {
      "headword": "cognitive"
    },
    {
      "headword": "artifact"
    },
    {
      "headword": "preservationist"
    },
    {
      "headword": "qualm"
    },
    {
      "headword": "besiege"
    },
    {
      "headword": "cloister"
    },
    {
      "headword": "cloistered"
    },
    {
      "headword": "annex"
    },
    {
      "headword": "annex"
    },
    {
      "headword": "resuscitate"
    },
    {
      "headword": "resuscitation"
    },
    {
      "headword": "ravish"
    },
    {
      "headword": "fabricate"
    },
    {
      "headword": "fabrication"
    },
    {
      "headword": "patchy"
    },
    {
      "headword": "patchily"
    },
    {
      "headword": "resounding"
    },
    {
      "headword": "resoundingly"
    },
    {
      "headword": "resound"
    },
    {
      "headword": "ordain"
    },
    {
      "headword": "inchoate"
    },
    {
      "headword": "inchoately"
    },
    {
      "headword": "elated"
    },
    {
      "headword": "elation"
    },
    {
      "headword": "hysteria"
    },
    {
      "headword": "hysterical"
    },
    {
      "headword": "hysterically"
    },
    {
      "headword": "jarring"
    },
    {
      "headword": "suffuse"
    },
    {
      "headword": "totter"
    },
    {
      "headword": "pyre"
    },
    {
      "headword": "contemptuous"
    },
    {
      "headword": "contemptuously"
    },
    {
      "headword": "forlorn"
    },
    {
      "headword": "forlornly"
    },
    {
      "headword": "rebuke"
    },
    {
      "headword": "rebuke"
    },
    {
      "headword": "abhorrent"
    },
    {
      "headword": "abhor"
    },
    {
      "headword": "abhorrently"
    },
    {
      "headword": "aberration"
    },
    {
      "headword": "emulsify"
    },
    {
      "headword": "emulsification"
    },
    {
      "headword": "emulsifier"
    },
    {
      "headword": "additive"
    },
    {
      "headword": "additive"
    },
    {
      "headword": "confection"
    },
    {
      "headword": "proximal"
    },
    {
      "headword": "vandalize"
    },
    {
      "headword": "vandal"
    },
    {
      "headword": "feign"
    },
    {
      "headword": "paradoxical"
    },
    {
      "headword": "paradoxically"
    },
    {
      "headword": "laryngitis"
    },
    {
      "headword": "stringent"
    },
    {
      "headword": "astringent"
    },
    {
      "headword": "stringently"
    },
    {
      "headword": "standing"
    },
    {
      "headword": "economize/economise"
    },
    {
      "headword": "breadwinner"
    },
    {
      "headword": "cosset"
    },
    {
      "headword": "counsel"
    },
    {
      "headword": "misdemeanor/misdemanour"
    },
    {
      "headword": "aptitude"
    },
    {
      "headword": "torrential"
    },
    {
      "headword": "banish"
    },
    {
      "headword": "banishment"
    },
    {
      "headword": "knack"
    },
    {
      "headword": "fruition"
    },
    {
      "headword": "tantalize/tantalise"
    },
    {
      "headword": "tantalizingly/tantalisingly"
    },
    {
      "headword": "maelstrom"
    },
    {
      "headword": "vortex"
    },
    {
      "headword": "depressive"
    },
    {
      "headword": "shoal"
    },
    {
      "headword": "scroll"
    },
    {
      "headword": "collide"
    },
    {
      "headword": "collider"
    },
    {
      "headword": "edifice"
    },
    {
      "headword": "thicket"
    },
    {
      "headword": "leaven"
    },
    {
      "headword": "leavening"
    },
    {
      "headword": "ethos"
    },
    {
      "headword": "exhibitionist"
    },
    {
      "headword": "interweave"
    },
    {
      "headword": "burgeoning"
    },
    {
      "headword": "indiscrete"
    },
    {
      "headword": "indiscretion"
    },
    {
      "headword": "telescopic"
    },
    {
      "headword": "telescopically"
    },
    {
      "headword": "amorphous"
    },
    {
      "headword": "amorphously"
    },
    {
      "headword": "hamper"
    },
    {
      "headword": "proliferate"
    },
    {
      "headword": "proliferation"
    },
    {
      "headword": "deterrent"
    },
    {
      "headword": "selectivity"
    },
    {
      "headword": "fractious"
    },
    {
      "headword": "mystique"
    },
    {
      "headword": "assimilate"
    },
    {
      "headword": "assimilation"
    },
    {
      "headword": "intersperse"
    },
    {
      "headword": "verbatim"
    },
    {
      "headword": "verbatim"
    },
    {
      "headword": "verily"
    },
    {
      "headword": "veritable"
    },
    {
      "headword": "verisimilitude"
    },
    {
      "headword": "artifice"
    },
    {
      "headword": "advantageous"
    },
    {
      "headword": "unfeasible"
    },
    {
      "headword": "unfeasibly"
    },
    {
      "headword": "behest"
    },
    {
      "headword": "virtuoso"
    },
    {
      "headword": "virtuosity"
    },
    {
      "headword": "cascade"
    },
    {
      "headword": "cascade"
    },
    {
      "headword": "crippling"
    },
    {
      "headword": "nascent"
    },
    {
      "headword": "smattering"
    },
    {
      "headword": "corpus"
    },
    {
      "headword": "wheeze"
    },
    {
      "headword": "neophyte"
    },
    {
      "headword": "coax"
    },
    {
      "headword": "formidably"
    },
    {
      "headword": "formidable"
    },
    {
      "headword": "squint"
    },
    {
      "headword": "hoist"
    },
    {
      "headword": "flatout"
    },
    {
      "headword": "buzzard"
    },
    {
      "headword": "bogus"
    },
    {
      "headword": "derision"
    },
    {
      "headword": "derisive"
    },
    {
      "headword": "derisively"
    },
    {
      "headword": "truism"
    },
    {
      "headword": "prurient"
    },
    {
      "headword": "wither"
    },
    {
      "headword": "prurience"
    },
    {
      "headword": "tetchy"
    },
    {
      "headword": "agile"
    },
    {
      "headword": "agility"
    },
    {
      "headword": "aghast"
    },
    {
      "headword": "dwarf"
    },
    {
      "headword": "dwarfism"
    },
    {
      "headword": "etch"
    },
    {
      "headword": "etching"
    },
    {
      "headword": "rapture"
    },
    {
      "headword": "rapturous"
    },
    {
      "headword": "rapturously"
    },
    {
      "headword": "ad lib"
    },
    {
      "headword": "ad-lib"
    },
    {
      "headword": "improvisational"
    },
    {
      "headword": "acrobatics"
    },
    {
      "headword": "acrobatically"
    },
    {
      "headword": "acrobatic"
    },
    {
      "headword": "arduous"
    },
    {
      "headword": "ardor/ardour"
    },
    {
      "headword": "arduously"
    },
    {
      "headword": "counterproductive"
    },
    {
      "headword": "counterproductively"
    },
    {
      "headword": "proverbial"
    },
    {
      "headword": "instantaneous"
    },
    {
      "headword": "instantaneously"
    },
    {
      "headword": "mull over"
    },
    {
      "headword": "ruminate"
    },
    {
      "headword": "rumination"
    },
    {
      "headword": "ruminant"
    },
    {
      "headword": "ruminative"
    },
    {
      "headword": "hover"
    },
    {
      "headword": "armory/armoury"
    },
    {
      "headword": "apostle"
    },
    {
      "headword": "blubber"
    },
    {
      "headword": "blubbery"
    },
    {
      "headword": "merger"
    },
    {
      "headword": "trifle"
    },
    {
      "headword": "trifle"
    },
    {
      "headword": "eke out"
    },
    {
      "headword": "paramount"
    },
    {
      "headword": "squirm"
    },
    {
      "headword": "squirmy"
    },
    {
      "headword": "floe"
    },
    {
      "headword": "embody"
    },
    {
      "headword": "embodiment"
    },
    {
      "headword": "wistful"
    },
    {
      "headword": "wistfully"
    },
    {
      "headword": "mercantile"
    },
    {
      "headword": "skew"
    },
    {
      "headword": "subsist"
    },
    {
      "headword": "subsistence"
    },
    {
      "headword": "subsidy"
    },
    {
      "headword": "subsidize"
    },
    {
      "headword": "legion"
    },
    {
      "headword": "confrontational"
    },
    {
      "headword": "confrontationally"
    },
    {
      "headword": "bout"
    },
    {
      "headword": "gout"
    },
    {
      "headword": "hinder"
    },
    {
      "headword": "hindrance"
    },
    {
      "headword": "myriad"
    },
    {
      "headword": "histrionic"
    },
    {
      "headword": "histrionically"
    },
    {
      "headword": "marketability"
    },
    {
      "headword": "promotable"
    },
    {
      "headword": "tacit"
    },
    {
      "headword": "tacitly"
    },
    {
      "headword": "taciturn"
    },
    {
      "headword": "taciturnity"
    },
    {
      "headword": "surreptitious"
    },
    {
      "headword": "surreptitiously"
    },
    {
      "headword": "allegory"
    },
    {
      "headword": "allegorical"
    },
    {
      "headword": "seedy"
    },
    {
      "headword": "punitive"
    },
    {
      "headword": "punitively"
    },
    {
      "headword": "temper"
    },
    {
      "headword": "milieu"
    },
    {
      "headword": "self-aggrandizement/self-aggrandisement"
    },
    {
      "headword": "unadulterated"
    },
    {
      "headword": "adulterate"
    },
    {
      "headword": "patronize/patronise"
    },
    {
      "headword": "patronizing/patronising"
    },
    {
      "headword": "patronizingly/patronisingly"
    },
    {
      "headword": "cogent"
    },
    {
      "headword": "cogently"
    },
    {
      "headword": "relegate"
    },
    {
      "headword": "incongruous"
    },
    {
      "headword": "incongruously"
    },
    {
      "headword": "incongruity"
    },
    {
      "headword": "deaden"
    },
    {
      "headword": "attuned"
    },
    {
      "headword": "attributive"
    },
    {
      "headword": "ecotourism"
    },
    {
      "headword": "surge"
    },
    {
      "headword": "surge"
    },
    {
      "headword": "farcical"
    },
    {
      "headword": "incise"
    },
    {
      "headword": "incipient"
    },
    {
      "headword": "echolocation"
    },
    {
      "headword": "echolocate"
    },
    {
      "headword": "reverb"
    },
    {
      "headword": "reverberation"
    },
    {
      "headword": "reverberate"
    },
    {
      "headword": "ingenuous"
    },
    {
      "headword": "ingenuously"
    },
    {
      "headword": "impresario"
    },
    {
      "headword": "elasticity"
    },
    {
      "headword": "synthesis"
    },
    {
      "headword": "salivary"
    },
    {
      "headword": "hypnotherapy"
    },
    {
      "headword": "wholly"
    },
    {
      "headword": "remorseful"
    },
    {
      "headword": "remonstrate"
    },
    {
      "headword": "remonstrance"
    },
    {
      "headword": "unexcused"
    },
    {
      "headword": "unexceptionally"
    },
    {
      "headword": "unexceptional"
    },
    {
      "headword": "inexorable"
    },
    {
      "headword": "inexorably"
    },
    {
      "headword": "inexorability"
    },
    {
      "headword": "tranquilize/tranquilise"
    }
]